// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { Link } from "react-router-dom";
// import Filter from "../../../Assets/Images/CommanImages/filter.png";
// import columnaddition from "../../../Assets/Images/CommanImages/flat-color-icons_add-column.png";
// import updown from "../../../Assets/Images/CommanImages/updown.png";
// import searchicon from "../../../Assets/Images/CommanImages/searchyellow.png";
// import leftArrow from "../../../Assets/Images/CommanImages/Larrowbar.png";
// import rightArrow from "../../../Assets/Images/CommanImages/Rarrowbar.png";
// import FileExport from "../../../Assets/Images/CommanImages/fileexport.png";
// import InterogativeImg from "./../../../Assets/Images/CommanImages/Warning.png";
// import DeleteIcon from "./../../../Assets/Images/CommanImages/table_cross_icon.png";
// import ReplaceIcon from "./../../../Assets/Images/CommanImages/tabler_replace-filled.png";
// import EyeOpenIcon from "./../../../Assets/Images/CommanImages/eye_lock_open_icon.png";
// import ErrorImg from "../../../Assets/Images/CommanImages/Error.png";
// import InfoIcon from "../../../Assets/Images/CommanImages/Informative.png";
// import EyeLockIcon from "./../../../Assets/Images/CommanImages/eye-lock-icon.png";
// import SelectedValuesDropdown from "../../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
// import DropDown from "../../../Components/Shared/Dropdown/Dropdown";
// import FileSaver from "file-saver";
// import * as XLSX from "xlsx";
// import jsPDF from "jspdf";
// import "jspdf-autotable";
// import { API_BASE_URL } from "../../../Config/Config";
// import EndPoints from "../../../Api/Endpoints";
// import Latex from "react-latex";
// import "katex/dist/katex.min.css";
// import he from "he";
// import "./tab.css";

// const TableComponent = ({
//   headers,
//   data,
//   searchPlaceholder,
//   renderQuestionText,
//   handleRemoveRow,
//   selectedSections,
//   setSectionWiseQuestions,
//   selecteSectionTypeID,
//   handleReplaceRow,
//   renderQuestionTextTable,
//   selectedSectionPerRow,
//   setSelectedSectionPerRow,
//   isReadOnlyMode,
//   customSectionOptions,   // ← NEW: array of { id, label } — overrides generated options when provided
//   sectionColumnLabel,     // ← NEW: string to replace "Section" header label
//   numQuestionsPerDate,    // ← NEW: number — how many questions per date for sequential auto-assign
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
// }) => {
//   const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
//   const [isFilterVisible, setIsFilterVisible] = useState(false);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [visibleColumns, setVisibleColumns] = useState([]);
//   const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
//   const [currentPage, setCurrentPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10);
//   const [averageRunTime, setAverageRunTime] = useState("");
//   const columnDropdownRef = useRef(null);
//   const [filters, setFilters] = useState({});
//   const [appliedFilters, setAppliedFilters] = useState({});
//   const [isFiltersApplied, setIsFiltersApplied] = useState(false);
//   // const [selectedSectionPerRow, setSelectedSectionPerRow] = useState({});

//   const generateSectionOptions = (selectedSections) => {
//     return Array.from({ length: selectedSections }, (_, i) => {
//       const label =
//         selecteSectionTypeID === 2 ? `${i + 1}` : String.fromCharCode(65 + i); // ✅ numeric or alphabetic
//       return {
//         id: label,
//         label: label,
//       };
//     });
//   };

//   const options = customSectionOptions && customSectionOptions.length > 0
//     ? customSectionOptions
//     : generateSectionOptions(selectedSections || 1);
//   useEffect(() => {
//     if (data.length === 0) return;

//     if (customSectionOptions && customSectionOptions.length > 0) {
//       // ── Sequential date auto-assign ────────────────────────────────────
//       // Distribute questions across dates: numQuestionsPerDate per date in order.
//       // User can override manually afterwards.
//       const qPerDay = Math.max(1, parseInt(numQuestionsPerDate) || 1);
//       const autoDropdowns = {};
//       const autoSectionWise = {};

//       data.forEach((row, idx) => {
//         const questionId   = row[1];
//         const questionText = row[2];
//         const dateIndex    = Math.floor(idx / qPerDay);
//         const dateOption   = customSectionOptions[dateIndex] || customSectionOptions[customSectionOptions.length - 1];
//         const dateLabel    = dateOption.id;

//         autoDropdowns[questionId] = dateLabel;

//         if (!autoSectionWise[dateLabel]) autoSectionWise[dateLabel] = [];
//         autoSectionWise[dateLabel].push({
//           id:   questionId,
//           text: renderQuestionText(questionText),
//         });
//       });

//       setSelectedSectionPerRow(autoDropdowns);
//       setSectionWiseQuestions?.(autoSectionWise);
//       return;
//     }

//     // ── Original section logic (unchanged) ────────────────────────────────
//     if (data.length > 0 && selectedSections === 1) {
//       const defaultSectionLabel = selecteSectionTypeID === 2 ? "1" : "A";

//       const autoAssignDropdowns = {};
//       const autoAssignSectionWise = { [defaultSectionLabel]: [] };

//       data.forEach((row) => {
//         const questionId = row[1];
//         const questionText = row[2];

//         autoAssignDropdowns[questionId] = defaultSectionLabel;
//         autoAssignSectionWise[defaultSectionLabel].push({
//           id: questionId,
//           text: renderQuestionText(questionText),
//         });
//       });

//       setSelectedSectionPerRow(autoAssignDropdowns);
//       setSectionWiseQuestions?.(autoAssignSectionWise);
//     } else if (selectedSections > 1) {
//       // Clear previous auto-assignment if section count increased
//       setSelectedSectionPerRow({});
//       setSectionWiseQuestions({});
//     }
//   }, [data, selectedSections, selecteSectionTypeID, customSectionOptions, numQuestionsPerDate]);

//   // useEffect(() => {
//   //   if (headers.length > 0 && visibleColumns.length === 0) {
//   //     const initialVisible = headers
//   //       .slice(0, 6) // Get first 6 columns
//   //       .filter((_, index) => index !== 4 && index !== 5); // Exclude index 4 and 5
//   //     setVisibleColumns(initialVisible);
//   //   }
//   // }, [headers, visibleColumns]);


//   useEffect(() => {
//     if (headers.length > 0 && visibleColumns.length === 0) {
//       const questionIdColumn = headers[1]; // Question ID at index 1
//       const sectionColumn = headers[0]; // Section at index 0
      
//       const initialVisible = headers
//         .slice(0, 6) // Get first 6 columns
//         .filter((_, index) => 
//           index !== 4 && 
//           index !== 5 && 
//           index !== 0 // ✅ Exclude Section (index 0)
//         );
      
//       // Always include Section and Question ID
//       const finalVisible = [sectionColumn, ...initialVisible];
//       if (!finalVisible.includes(questionIdColumn)) {
//         finalVisible.push(questionIdColumn);
//       }
      
//       setVisibleColumns(finalVisible);
//     }
//   }, [headers, visibleColumns]);

//   // const handleColumnSelection = (column) => {
//   //   if (visibleColumns.includes(column)) {
//   //     setVisibleColumns(visibleColumns.filter((col) => col !== column));
//   //   } else {
//   //     setVisibleColumns([...visibleColumns, column]);
//   //   }
//   // };

//   const handleColumnSelection = (column) => {
//     const questionIdColumn = headers[1]; // Question ID at index 1
//     const sectionColumn = headers[0]; // Section at index 0
    
//     // Prevent toggling Section and Question ID
//     if (column === questionIdColumn || column === sectionColumn) {
//       return;
//     }
    
//     if (visibleColumns.includes(column)) {
//       setVisibleColumns(visibleColumns.filter((col) => col !== column));
//     } else {
//       setVisibleColumns([...visibleColumns, column]);
//     }
//   };


//   const handleSearch = (e) => {
//     setSearchQuery(e.target.value);
//     setCurrentPage(1);
//   };

//   const handleApplyFilter = () => {
//     if (Object.keys(filters).length > 0) {
//       setAppliedFilters({ ...filters }); // Persist selected filters
//       setCurrentPage(1); // Reset to the first page
//       setIsFiltersApplied(true); // Show Reset button
//       setIsFilterVisible(false); // Hide the filter sidebar
//     }
//   };

//   const handleResetFilter = () => {
//     setFilters({}); // Clear current filter selections
//     setAppliedFilters({}); // Clear applied filters
//     setAverageRunTime(""); // Reset any other state if required
//     setIsFiltersApplied(false); // Deactivate the Reset button
//   };

//   const filteredData = data.filter((row) => {
//     const matchesSearchQuery = row.some(
//       (cell) =>
//         cell && String(cell).toLowerCase().includes(searchQuery.toLowerCase())
//     );
//     const matchesAverageRunTime =
//       averageRunTime === "" || row[2] === averageRunTime;

//     // Apply appliedFilters
//     const matchesFilters = Object.entries(appliedFilters).every(
//       ([key, value]) => {
//         const colIndex = headers.indexOf(key);
//         return value ? row[colIndex] === value : true;
//       }
//     );

//     return matchesSearchQuery && matchesAverageRunTime && matchesFilters;
//   });

//   const handleSort = (column) => {
//     let direction = "asc";
//     if (sortConfig.key === column && sortConfig.direction === "asc") {
//       direction = "desc";
//     }
//     setSortConfig({ key: column, direction });
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         columnDropdownRef.current &&
//         !columnDropdownRef.current.contains(event.target)
//       ) {
//         setIsColumnDivVisible(false); // Close the dropdown if clicked outside
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const sortedData = React.useMemo(() => {
//     let sortableData = [...filteredData];
//     if (sortConfig.key !== null) {
//       const colIndex = headers.indexOf(sortConfig.key);
//       sortableData.sort((a, b) => {
//         if (a[colIndex] < b[colIndex]) {
//           return sortConfig.direction === "asc" ? -1 : 1;
//         }
//         if (a[colIndex] > b[colIndex]) {
//           return sortConfig.direction === "asc" ? 1 : -1;
//         }
//         return 0;
//       });
//     }
//     return sortableData;
//   }, [filteredData, sortConfig, headers]);

//   const handlePageSizeChange = (size) => {
//     setPageSize(size);
//     setCurrentPage(1);
//   };

//   const handlePageChange = (page) => {
//     setCurrentPage(page);
//   };

//   const totalPages = Math.ceil(sortedData.length / pageSize);
//   const paginatedData = React.useMemo(() => {
//     const startIndex = (currentPage - 1) * pageSize;
//     return sortedData.slice(startIndex, startIndex + pageSize);
//   }, [sortedData, currentPage, pageSize]);

//   const renderPagination = () => {
//     const pages = [];
//     if (totalPages <= 5) {
//       for (let i = 1; i <= totalPages; i++) {
//         pages.push(
//           <button
//             key={i}
//             onClick={() => handlePageChange(i)}
//             style={{ borderRadius: "5px" }}
//             className={i === currentPage ? "active" : ""}
//           >
//             {" "}
//             {i}{" "}
//           </button>
//         );
//       }
//     } else {
//       if (currentPage <= 3) {
//         for (let i = 1; i <= 3; i++) {
//           pages.push(
//             <button
//               key={i}
//               style={{ borderRadius: "5px" }}
//               onClick={() => handlePageChange(i)}
//               className={i === currentPage ? "active" : ""}
//             >
//               {" "}
//               {i}{" "}
//             </button>
//           );
//         }
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots1">
//             {" "}
//             ...{" "}
//           </span>
//         );
//         pages.push(
//           <button
//             key={totalPages}
//             onClick={() => handlePageChange(totalPages)}
//             style={{ borderRadius: "5px" }}
//           >
//             {totalPages}
//           </button>
//         );
//       } else if (currentPage > 3 && currentPage < totalPages - 2) {
//         pages.push(
//           <button
//             key={1}
//             onClick={() => handlePageChange(1)}
//             style={{ borderRadius: "5px" }}
//           >
//             {" "}
//             1{" "}
//           </button>
//         );
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots1">
//             {" "}
//             ...{" "}
//           </span>
//         );
//         for (let i = currentPage - 1; i <= currentPage + 1; i++) {
//           pages.push(
//             <button
//               key={i}
//               onClick={() => handlePageChange(i)}
//               style={{ borderRadius: "5px" }}
//               className={i === currentPage ? "active" : ""}
//             >
//               {" "}
//               {i}{" "}
//             </button>
//           );
//         }
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots2">
//             {" "}
//             ...{" "}
//           </span>
//         );
//         pages.push(
//           <button
//             key={totalPages}
//             onClick={() => handlePageChange(totalPages)}
//             style={{ borderRadius: "5px" }}
//           >
//             {" "}
//             {totalPages}{" "}
//           </button>
//         );
//       } else {
//         pages.push(
//           <button
//             key={1}
//             onClick={() => handlePageChange(1)}
//             style={{ borderRadius: "5px" }}
//           >
//             {" "}
//             1{" "}
//           </button>
//         );
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots1">
//             {" "}
//             ...{" "}
//           </span>
//         );
//         for (let i = totalPages - 2; i <= totalPages; i++) {
//           pages.push(
//             <button
//               key={i}
//               onClick={() => handlePageChange(i)}
//               style={{ borderRadius: "5px" }}
//               className={i === currentPage ? "active" : ""}
//             >
//               {" "}
//               {i}{" "}
//             </button>
//           );
//         }
//       }
//     }
//     return pages;
//   };
//   const [columnWidth, setColumnWidth] = useState(400);
//   const columnRef = useRef(null);
//   const isResizing = useRef(false);

//   const handleMouseDown = (event) => {
//     isResizing.current = true;
//     document.addEventListener("mousemove", handleMouseMove);
//     document.addEventListener("mouseup", handleMouseUp);
//   };

//   const handleMouseMove = (event) => {
//     if (isResizing.current) {
//       const newWidth = Math.max(
//         100,
//         event.clientX - columnRef.current.offsetLeft
//       );
//       setColumnWidth(newWidth);
//     }
//   };

//   const handleMouseUp = () => {
//     isResizing.current = false;
//     document.removeEventListener("mousemove", handleMouseMove);
//     document.removeEventListener("mouseup", handleMouseUp);
//   };

//   return (
//     <div>
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "space-between",
//           marginTop: "1.5%",
//         }}
//       >
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             width: "80vw",
//           }}
//         >
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               border: "1px solid #6A6A6A",
//               overflow: "hidden",
//             }}
//           >
//             <input
//               type="text"
//               placeholder={searchPlaceholder}
//               name="search"
//               className="search-input-ques-dash"
//               onChange={handleSearch}
//             />
//             <div
//               style={{
//                 width: "1px",
//                 height: "24px",
//                 backgroundColor: "#2F2E40",
//                 margin: "0 4px",
//               }}
//             ></div>
//             <img
//               src={searchicon}
//               alt="search"
//               className="search-icon-ques-dash"
//             />
//           </div>
//           <div
//             style={{ textAlign: "end", marginTop: "20px", color: "#424242" }}
//           >
//             Displaying{" "}
//             {Math.min((currentPage - 1) * pageSize + 1, sortedData.length)} -{" "}
//             {Math.min(currentPage * pageSize, sortedData.length)} of{" "}
//             {sortedData.length} records |
//             {["10", "25", "50", "100", "500"].map((size) => (
//               <span
//                 key={size}
//                 onClick={() => handlePageSizeChange(Number(size))}
//                 style={{
//                   cursor: "pointer",
//                   margin: "0 5px",
//                   textDecoration:
//                     size === pageSize.toString() ? "none" : "underline",
//                   color: size === pageSize.toString() ? "black" : "#337AB7",
//                 }}
//               >
//                 {size}
//               </span>
//             ))}
//           </div>
//         </div>
//       </div>
//       <div
//         style={{
//           display: "flex",
//           backgroundColor: "#D6D6D6",
//           marginTop: "9px",
//           borderTop: "1px solid grey",
//           borderBottom: "1px solid grey",
//         }}
//       >
//         <div
//           style={{
//             backgroundColor: "#FFBD20",
//             display: "flex",
//             alignItems: "center",
//             cursor: "pointer",
//             paddingLeft: "8px",
//             width: "90px",
//           }}
//           onClick={() => setIsFilterVisible(!isFilterVisible)}
//         >
//           <img
//             src={Filter}
//             style={{ height: "24px", width: "24px" }}
//             alt="filter"
//           />
//           <span style={{ marginLeft: "10px", color: "#2F2E40" }}>Filter</span>
//         </div>
//         <div
//           style={{
//             marginLeft: "auto",
//             textAlign: "end",
//             marginRight: "8px",
//             display: "flex",
//             alignItems: "center",
//             position: "relative",
//             cursor: "pointer",
//             height: "40px",
//           }}
//           onClick={() => setIsColumnDivVisible(!isColumnDivVisible)}
//         >
//           <img
//             src={columnaddition}
//             style={{ height: "34px", width: "32px" }}
//             alt="column addition"
//           />
//           <span
//             style={{
//               marginLeft: "4px",
//               color: "#2F2E40",
//               marginRight: "14px",
//               fontSize: "14px",
//             }}
//           >
//             Column Selection
//           </span>
//           {isColumnDivVisible && (
//             <div ref={columnDropdownRef}>
//               <div className="arrow-up-tc"></div>
//               <div className="popupColumn-tc">
//                 {/* {headers
//                   .filter((_, index) => index !== 4 && index !== 5) // Skip index 4 and 5
//                   .map((column, index) => (
//                     <div
//                       key={index}
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         handleColumnSelection(column);
//                       }}
//                     >
//                       <input
//                         type="checkbox"
//                         id={`column-${index}`}
//                         name="columnSelection"
//                         value={column}
//                         className="square-checkbox-tc"
//                         checked={visibleColumns.includes(column)}
//                         readOnly
//                       />
//                       <label htmlFor={`column-${index}`}>{column}</label>
//                     </div>
//                   ))} */}
//                   {headers
//                     .filter((_, index) => 
//                       index !== 0 && // ✅ Skip Section (index 0) from dropdown
//                       index !== 4 && 
//                       index !== 5
//                     )
//                     .map((column, index) => {
//                       const originalIndex = headers.indexOf(column);
//                       const isQuestionId = originalIndex === 1; // Check if it's Question ID
                      
//                       return (
//                         <div
//                           key={index}
//                           onClick={(e) => {
//                             e.stopPropagation();
//                             handleColumnSelection(column);
//                           }}
//                           style={{
//                             cursor: isQuestionId ? 'not-allowed' : 'pointer',
//                             opacity: isQuestionId ? 0.7 : 1,
//                           }}
//                         >
//                           <input
//                             type="checkbox"
//                             id={`column-${index}`}
//                             name="columnSelection"
//                             value={column}
//                             className="square-checkbox-tc"
//                             checked={visibleColumns.includes(column)}
//                             disabled={isQuestionId} 
//                             readOnly
//                           />
//                           <label 
//                             htmlFor={`column-${index}`}
//                             style={{
//                               cursor: isQuestionId ? 'not-allowed' : 'pointer',
//                             }}
//                           >
//                             {column}
//                           </label>
//                         </div>
//                       );
//                     })}
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//       {data.length > 0 ? (
//         <>
//           <div className="table-wrapper-cols-selections-selected-ques-list">
//             <table className="table-tc" style={{ width: "100%" }}>
//               <thead>
//                 <tr>
//                   {visibleColumns.map((heading, index) => (
//                     <td
//                       key={index}
//                       ref={index === 1 ? columnRef : null}
//                       className={`Heading-tc resizable-header ${
//                         index === 1 ? "resizable-header" : ""
//                       }`}
//                       style={{
//                         textAlign: "right",
//                         cursor: "pointer",
//                         width: index === 1 ? `${columnWidth}px` : "auto",
//                         position: "relative",
//                       }}
//                     >
//                       <span
//                         style={{
//                           display: "flex",
//                           alignItems: "left",
//                           justifyContent: "left",
//                           marginLeft: index === 0 ? "130px" : "",
//                         }}
//                       >
//                         {index === 0 && sectionColumnLabel ? sectionColumnLabel : heading}
//                         {index === 2 && (
//                           <div
//                             className="resize-handle"
//                             onMouseDown={handleMouseDown}
//                           ></div>
//                         )}
//                         <img
//                           onClick={() => handleSort(heading)}
//                           src={updown}
//                           style={{
//                             height: "20px",
//                             width: "20px",
//                             marginLeft: "5px",
//                           }}
//                           alt="sort"
//                         />
//                       </span>
//                     </td>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {/* {paginatedData.map((row, rowIndex) => ( */}
//                 {paginatedData.map((row, rowIndex) => {
//                   const questionId = row[1]; // ✅ Index for Question ID
//                   const questionText = row[2]; // ✅ Index for Question Text
//                   return (
//                     <tr
//                       key={rowIndex}
//                       className={rowIndex % 2 === 1 ? "even-row-tc" : ""}
//                     >
//                       {visibleColumns.map((column, cellIndex) => (
//                         <td
//                           key={cellIndex}
//                           style={{
//                             width:
//                               cellIndex === 3 ? `${columnWidth}px` : "100px",
//                             textAlign: "left",
//                             color: "#6A6A6A",
//                             verticalAlign: "middle",
//                             whiteSpace: "nowrap",
//                             overflow: "hidden",
//                             textOverflow: "ellipsis",
//                             maxWidth: `${columnWidth}px`,
//                           }}
//                         >
//                           {cellIndex === 0 ? ( // Ensure link only appears once
//                             <div
//                               style={{ display: "flex", alignItems: "center" }}
//                             >
//                               <div
//                                 className="flag-container-ques-bank-dash"
//                                 style={{
//                                   width: "220px",
//                                   display: "flex",
//                                   alignItems: "center",
//                                   gap: "20px",
//                                 }}
//                               >
//                                 <img
//                                   src={DeleteIcon}
//                                   alt="flag count"
//                                   style={{
//                                     width: "20px",
//                                     opacity: isReadOnlyMode ? 0.6 : 1,
//                                   }}
//                                   // onClick={() => handleRemoveRow && handleRemoveRow(row)}
//                                   onClick={() => {
//                                     if (!isReadOnlyMode && handleRemoveRow) {
//                                       handleRemoveRow(row);
//                                     }
//                                   }}
//                                 />
//                                 <img
//                                   src={ReplaceIcon}
//                                   alt="replace question"
//                                   style={{
//                                     width: "24px",
//                                     cursor: "pointer",
//                                     opacity: isReadOnlyMode ? 0.6 : 1,
//                                   }}
//                                   // onClick={() => handleReplaceRow(row)}
//                                   onClick={() => {
//                                     if (!isReadOnlyMode) {
//                                       handleReplaceRow(row);
//                                     }
//                                   }}
//                                 />
//                                 <div style={{ width: "24px" }}>
//                                   {row[4] === 13 && (
//                                     <img
//                                       src={EyeLockIcon}
//                                       alt="replace question"
//                                       style={{
//                                         width: "24px",
//                                         cursor: "pointer",
//                                       }}
//                                     />
//                                   )}
//                                 </div>
//                                 <select
//                                   style={{
//                                     width: "140px",
//                                     padding: "5px",
//                                     borderRadius: "4px",
//                                     border: "1px solid #ccc",
//                                     cursor: "pointer",
//                                   }}
//                                   value={
//                                     selectedSectionPerRow[questionId] || ""
//                                   }
//                                   onChange={(e) => {
//                                     const sectionLabel = e.target.value;

//                                     // ── Slot-full validation (MCQ-of-the-Day mode) ──
//                                     if (customSectionOptions && customSectionOptions.length > 0 && sectionLabel) {
//                                       const qPerDay = Math.max(1, parseInt(numQuestionsPerDate) || 1);
//                                       const currentInDate = Object.entries(selectedSectionPerRow)
//                                         .filter(([qid, date]) => date === sectionLabel && qid !== String(questionId))
//                                         .length;
//                                       if (currentInDate >= qPerDay) {
//                                         setMessageBox?.(
//                                           <div className="Container-messageBOX">
//                                             <div className="messagebox-insider1">
//                                               <span>
//                                                 ⚠ Date <b>{sectionLabel}</b> already has {qPerDay} question{qPerDay !== 1 ? "s" : ""} (slot full).
//                                                 Please deselect a question from that date first.
//                                               </span>
//                                             </div>
//                                             <div className="messagebox-insider2" style={{ marginTop: 10 }}>
//                                               <button className="messagebox-cancel-btn-ok" onClick={() => setIsMessageBoxVisible?.(false)}>OK</button>
//                                             </div>
//                                           </div>
//                                         );
//                                         setActiveImg?.(InterogativeImg);
//                                         setIsMessageBoxVisible?.(true);
//                                         return; // block the change
//                                       }
//                                     }
//                                     setSelectedSectionPerRow((prev) => ({
//                                       ...prev,
//                                       [questionId]: sectionLabel,
//                                     }));

//                                     setSectionWiseQuestions?.((prev) => {
//                                       const updated = { ...prev };

//                                       // Remove this question from all sections
//                                       for (const sec in updated) {
//                                         updated[sec] = updated[sec].filter(
//                                           (q) => q.id !== questionId
//                                         );
//                                       }

//                                       // Add to new section
//                                       if (sectionLabel) {
//                                         if (!updated[sectionLabel])
//                                           updated[sectionLabel] = [];
//                                         updated[sectionLabel].push({
//                                           id: questionId,
//                                           text: questionText,
//                                         });
//                                       }
//                                       return updated;
//                                     });
//                                   }}
//                                   disabled={isReadOnlyMode}
//                                 >
//                                   <option value="">Select</option>
//                                   {options.map((option) => (
//                                     <option key={option.id} value={option.id}>
//                                       {option.label}
//                                     </option>
//                                   ))}
//                                 </select>
//                               </div>
//                               <Link style={{ color: "#337ab7" }}>
//                                 <span
//                                   className="truncated-text"
//                                   title={row[headers.indexOf(column)]}
//                                 >
//                                   {" "}
//                                   {headers.indexOf(column) === 2
//                                     ? renderQuestionTextTable(
//                                         row[headers.indexOf(column)]
//                                       )
//                                     : row[headers.indexOf(column)]}{" "}
//                                 </span>
//                               </Link>
//                             </div>
//                           ) : (
//                             <span className="truncated-text-2">
//                               {" "}
//                               {headers.indexOf(column) === 2
//                                 ? renderQuestionTextTable(
//                                     row[headers.indexOf(column)]
//                                   )
//                                 : row[headers.indexOf(column)]}{" "}
//                             </span>
//                           )}
//                         </td>
//                       ))}
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </table>
//           </div>
//           <div className="pagination-tc">
//             <button
//               onClick={() => handlePageChange(1)}
//               disabled={currentPage === 1}
//               className="extreme-left-tc-pagination"
//             >
//               {" "}
//               <img src={leftArrow} alt="" />{" "}
//             </button>
//             <button
//               onClick={() => handlePageChange(currentPage - 1)}
//               disabled={currentPage === 1}
//               className="lefttc-pagination"
//             >
//               {" "}
//               {"<"}
//             </button>{" "}
//             {renderPagination()}{" "}
//             <button
//               onClick={() => handlePageChange(currentPage + 1)}
//               disabled={currentPage === totalPages}
//               className="righttc-pagination"
//             >
//               {" "}
//               {">"}{" "}
//             </button>
//             <button
//               onClick={() => handlePageChange(totalPages)}
//               disabled={currentPage === totalPages}
//               className="extreme-right-tc-pagination"
//             >
//               {" "}
//               <img src={rightArrow} alt="" />{" "}
//             </button>
//           </div>
//         </>
//       ) : (
//         "No data available"
//       )}
//       {isFilterVisible && (
//         <div className="filter-sidebar-tc">
//           <div className="filter-content-tc" style={{ position: "relative" }}>
//             <button
//               className="repman-cross-btn"
//               onClick={() => {
//                 setIsFilterVisible(false);
//               }}
//             >
//               {" "}
//               <p>X</p>{" "}
//             </button>
//             <h3 className="AdvanceF-heading-tc"> Filter</h3>
//             <div className="filter-apply-reset-ques-rev-dash">
//               {isFiltersApplied && (
//                 <button
//                   className="reset-btn-question-review-dash"
//                   onClick={handleResetFilter}
//                 >
//                   {" "}
//                   RESET{" "}
//                 </button>
//               )}
//               <button
//                 className="apply-btn-question-review-dash"
//                 onClick={handleApplyFilter}
//               >
//                 {" "}
//                 APPLY{" "}
//               </button>
//             </div>
//             <div className="filter-options-container">
//               {headers
//                 .filter((_, index) => index === 0 || index >= 3) // Skip index 2 and 4
//                 .map((header, filteredIndex) => {
//                   const originalIndex =
//                     filteredIndex === 0
//                       ? 0
//                       : filteredIndex + 1 + (filteredIndex >= 1 ? 1 : 0);
//                   let uniqueOptions = [
//                     ...new Set(
//                       data
//                         .map((row) => row[originalIndex])
//                         .filter((option) => option)
//                     ),
//                   ];
//                   if (originalIndex === 0 || originalIndex === 6) {
//                     uniqueOptions.sort((a, b) => (a > b ? 1 : -1));
//                   }
//                   return (
//                     <SelectedValuesDropdown
//                       key={originalIndex}
//                       label={header}
//                       width="300px"
//                       marginLeft="15px"
//                       marginTop="18px"
//                       setSelected={(selectedOption) => {
//                         setFilters((prevFilters) => ({
//                           ...prevFilters,
//                           [header]: selectedOption,
//                         }));
//                       }}
//                       options={uniqueOptions.map((value) => ({
//                         label: value,
//                         id: value,
//                       }))}
//                       selected={filters[header] || ""}
//                       Height="auto"
//                       OverFlow="auto"
//                       minheight="200px"
//                     />
//                   );
//                 })}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// const TableDetailsSelectedQuestions = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   dataClient,
//   setPagePath,
//   selectedSections,
//   setQuestionIds,
//   activeSubjectId,
//   setSectionWiseQuestions,
//   selecteSectionTypeID,
//   // tableQuestions,
//   allQuesList,
//   draftData,
//   isReadOnlyMode,
//   setDifficultyCount,
//   version,
//   customSectionOptions,   // ← NEW
//   sectionColumnLabel,     // ← NEW
//   numQuestionsPerDate,    // ← NEW
// }) => {
//   const [reportDashboardData, setReportDashboardData] = useState([]);
//   const [headers, setHeaders] = useState([]);
//   const [selectedSectionPerRow, setSelectedSectionPerRow] = useState({});
//   const [draftLoaded, setDraftLoaded] = useState(false);

//   const renderQuestionTextTable = (questionText) => {
//     const decodedQuestion = he.decode(questionText);
//     const questionSegments = decodedQuestion.split(/(imgsrc=[^ ]+)/g);
//     return questionSegments.map((segment, index) => {
//       if (segment.startsWith("imgsrc=")) {
//         const imageUrl = segment.replace("imgsrc=", "");
//         return (
//           <img
//             key={index}
//             src={imageUrl}
//             alt={`Question Image ${index}`}
//             style={{ width: "30px", height: "auto", margin: "5px" }}
//           />
//         );
//       } else {
//         return (
//           <span key={index} className="truncated-text-2">
//             <Latex>{segment}</Latex>
//           </span>
//         );
//       }
//     });
//   };

//   const renderQuestionText = (questionText) => {
//     const decodedQuestion = he.decode(questionText);
//     const questionSegments = decodedQuestion.split(/(imgsrc=[^ ]+)/g);
//     return questionSegments.map((segment, index) => {
//       if (segment.startsWith("imgsrc=")) {
//         const imageUrl = segment.replace("imgsrc=", "");
//         return (
//           <img
//             key={index}
//             src={imageUrl}
//             alt={`Question Image ${index}`}
//             style={{ width: "30px", margin: "5px" }}
//           />
//         );
//       } else {
//         return (
//           <span key={index} className="truncated-text-2">
//             <Latex>{segment}</Latex>
//           </span>
//         );
//       }
//     });
//   };

//   // useEffect(() => {
//   //   const fetchSelectedQuestions = async () => {
//   //     const subjectWiseSelected = JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}");
//   //     const localSubjectIds = subjectWiseSelected[activeSubjectId] || [];

//   //     const draftSubjectQuestions = draftData?.subjects?.find(subject => subject.subject_id === activeSubjectId)?.questions?.filter(q => q.status === 1) || [];
//   //     const draftSubjectIds = draftSubjectQuestions.map(q => q.parse_ques_set_question_id);
//   //     // console.log(draftSubjectIds, "draftSubjectIds in TableDetailsSelectedQuestions");

//   //     const mergedIds = Array.from(new Set([...localSubjectIds, ...draftSubjectIds]));
//   //     if (mergedIds.length === 0) return;

//   //     try {
//   //       const response = await fetch(`${API_BASE_URL}/coaching-collaborator-api/api/v1/get-questions-by-ids`, {
//   //         method: "POST",
//   //         headers: {
//   //           Authorization: `Bearer ${localStorage.getItem("other")}`,
//   //           Accept: "application/json",
//   //           "Content-Type": "application/json",
//   //         },
//   //         body: JSON.stringify(mergedIds),
//   //       });

//   //       const result = await response.json();
//   //       const tableData = result?.data?.table_data || [];

//   //       if (tableData.length > 1) {
//   //         const headers = tableData[0].map(h => h.replace(/^t\*|d\*|n\*/, ""));
//   //         const rows = tableData.slice(1);
//   //         setHeaders(["Section", ...headers]);
//   //         setReportDashboardData(rows.map(row => ["", ...row]));

//   //         const allIds = rows.map(row => row[0]);
//   //         const existing = JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}");
//   //         const updated = {
//   //           ...existing,
//   //           [activeSubjectId]: Array.from(new Set([...(existing[activeSubjectId] || []), ...allIds])),
//   //         };
//   //         localStorage.setItem("subjectWiseSelectedRowIds", JSON.stringify(updated));
//   //         setDraftLoaded(true);
//   //       }
//   //     } catch (error) {
//   //       console.error("Failed to fetch selected questions:", error);
//   //     }
//   //   };

//   //   fetchSelectedQuestions();
//   // }, [draftData, activeSubjectId, version]);

//   // useEffect(() => {
//   //   if (!reportDashboardData.length || !draftLoaded) return;
//   //   const difficultyIndex = headers.findIndex(h => h.toLowerCase().includes("difficulty level"));
//   //   const difficultyCount = { easy: 0, medium: 0, tough: 0 };
//   //   reportDashboardData.forEach(row => {
//   //     const diff = row[difficultyIndex]?.toLowerCase();
//   //     if (["easy", "medium", "tough"].includes(diff)) difficultyCount[diff]++;
//   //   });
//   //   setDifficultyCount?.(difficultyCount);
//   // }, [reportDashboardData, headers, draftLoaded]);

//   useEffect(() => {
//     const difficultyIndex = headers.findIndex((h) =>
//       h.toLowerCase().includes("difficulty level")
//     );

//     const difficultyCount = { easy: 0, medium: 0, tough: 0 };

//     if (reportDashboardData.length && draftLoaded) {
//       reportDashboardData.forEach((row) => {
//         const diff = row[difficultyIndex]?.toLowerCase();
//         if (["easy", "medium", "tough"].includes(diff)) {
//           difficultyCount[diff]++;
//         }
//       });
//     }
//     setDifficultyCount?.(difficultyCount);
//   }, [reportDashboardData, headers, draftLoaded, activeSubjectId]);

//   const quesTypeMapping = {
//     "Single Correct MCQ": 1,
//     "Multi Correct MCQ": 2,
//     "Fill in the blanks": 3,
//     "True/False": 4,
//   };

//   // Additional function to fetch selected questions based on activeSubjectId and draftData(SHASHI ON FRIDAY 30/05 2025)
//   const fetchSelectedQuestions = async () => {
//     const subjectWiseSelected = JSON.parse(
//       localStorage.getItem("subjectWiseSelectedRowIds") || "{}"
//     );
//     const deletedRowMap = JSON.parse(
//       localStorage.getItem("subjectWiseDeletedRowIds") || "{}"
//     );

//     const localSubjectIds = subjectWiseSelected[activeSubjectId] || [];

//     // const draftSubjectQuestions = draftData?.subjects?.find(
//     //   (subject) => subject.subject_id === activeSubjectId
//     // )?.questions?.filter((q) => q.status === 1) || [];

//     const draftSubjectQuestionsRaw =
//       draftData?.subjects?.find(
//         (subject) => subject.subject_superset_id === activeSubjectId
//       )?.questions || [];

//     // // CHANGES BY SHASHI ON MONDAY 16/05/2026 
//     // const draftSubjectQuestionsRaw =
//     //     draftData?.subjects
//     //       ?.filter((subject) => subject.subject_superset_id === activeSubjectId)
//     //       ?.flatMap((subject) => subject.questions || []) || [];

//     const draftSubjectQuestions = draftSubjectQuestionsRaw.filter(
//       (q) => q.status === 1
//     );
//     const draftSubjectDeletedQuestions = draftSubjectQuestionsRaw.filter(
//       (q) => q.status === 2
//     );

//     const draftSubjectIds = draftSubjectQuestions.map(
//       (q) => q.parse_ques_set_question_id
//     );
//     const deletedDraftIds = draftSubjectDeletedQuestions.map(
//       (q) => q.parse_ques_set_question_id
//     );

//     // const draftSubjectIds = draftSubjectQuestions.map((q) => q.parse_ques_set_question_id);

//     // Merge and deduplicate
//     const mergedIds = Array.from(
//       new Set([...localSubjectIds, ...draftSubjectIds])
//     );

//     // ✅ Remove deleted IDs
//     const deletedIds = deletedRowMap[activeSubjectId] || [];
//     const finalIds = mergedIds.filter((id) => !deletedIds.includes(id));

//     if (finalIds.length === 0) {
//       setReportDashboardData([]);
//       setHeaders([]);
//       return;
//     }

//     try {
//       const response = await fetch(
//         `${EndPoints.PRISM_GET_QUESTIONS_BY_IDS}`,
//         {
//           method: "POST",
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("other")}`,
//             Accept: "application/json",
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(finalIds),
//         }
//       );

//       const result = await response.json();
//       const tableData = result?.data?.table_data || [];

//       if (tableData.length > 1) {
//         const headers = tableData[0].map((h) => h.replace(/^t\*|d\*|n\*/, ""));
//         const rows = tableData.slice(1);
//         setHeaders([(sectionColumnLabel || "Section"), ...headers]);
//         // setReportDashboardData(rows.map((row) => ["", ...row]));

//         // Ensure table rows follow the order of `finalIds`
//         const idToRowMap = new Map();
//         rows.forEach((row) => {
//           const quesId = row[0]; // assuming 0 is Question ID (since headers have ["Section", ...])
//           idToRowMap.set(quesId, row);
//         });

//         const orderedRows = finalIds
//           .map((id) => idToRowMap.get(id))
//           .filter((row) => row); // skip if not found
//         setReportDashboardData(orderedRows.map((row) => ["", ...row])); // add empty section as first column

//         // ✅ Auto-assign default section (A/1) when selecting questions for the first time if only one section exists
//         if (selectedSections === 1) {
//           const defaultSection = selecteSectionTypeID === 2 ? "1" : "A";
//           const newSectionMap = {};

//           orderedRows.forEach((row) => {
//             const questionId = row[0]; // before "Section" column
//             newSectionMap[questionId] = defaultSection;
//           });

//           setSelectedSectionPerRow(newSectionMap);

//           // Also build sectionWiseQuestions
//           const sectionQuesMap = {
//             [defaultSection]: orderedRows.map((row) => ({
//               id: row[0],
//               text: renderQuestionTextTable(row[2]),
//             })),
//           };
//           setSectionWiseQuestions(sectionQuesMap);
//         }

//         const quesTypeMapPerSubject = {}; // New variable
//         const questionTypeIndex = headers.findIndex((h) =>
//           h.toLowerCase().includes("question type")
//         );
//         if (questionTypeIndex !== -1) {
//           rows.forEach((row) => {
//             const quesId = row[0]; // First column is Question ID (after Section)
//             const quesTypeText = row[questionTypeIndex];
//             const quesTypeId = quesTypeMapping[quesTypeText] || null;

//             if (quesTypeId !== null) {
//               quesTypeMapPerSubject[quesId] = quesTypeId;
//             }
//           });

//           // ✅ Save as a new key in localStorage
//           const existingTypeMap = JSON.parse(
//             localStorage.getItem("subjectWiseQuesTypeIds") || "{}"
//           );
//           localStorage.setItem(
//             "subjectWiseQuesTypeIds",
//             JSON.stringify({
//               ...existingTypeMap,
//               [activeSubjectId]: quesTypeMapPerSubject,
//             })
//           );
//         }

//         // ✅ Update localStorage: merge both
//         const existing = JSON.parse(
//           localStorage.getItem("subjectWiseSelectedRowIds") || "{}"
//         );
//         localStorage.setItem(
//           "subjectWiseSelectedRowIds",
//           JSON.stringify({
//             ...existing,
//             [activeSubjectId]: finalIds,
//           })
//         );

//         // ✅ Save deleted question IDs (status 2) in localStorage
//         // const existingDeleted = JSON.parse(localStorage.getItem("subjectWiseDeletedRowIds") || "{}");
//         // localStorage.setItem("subjectWiseDeletedRowIds", JSON.stringify({
//         //   ...existingDeleted,
//         //   [activeSubjectId]: deletedDraftIds,
//         // }));

//         const existingDeleted = JSON.parse(
//           localStorage.getItem("subjectWiseDeletedRowIds") || "{}"
//         );
//         const currentSelected =
//           JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}")[
//             activeSubjectId
//           ] || [];

//         const mergedDeletedIds = deletedDraftIds.filter(
//           (id) => !currentSelected.includes(id)
//         ); // ✅ do not save as deleted if user already reselected

//         localStorage.setItem(
//           "subjectWiseDeletedRowIds",
//           JSON.stringify({
//             ...existingDeleted,
//             [activeSubjectId]: mergedDeletedIds,
//           })
//         );
//         setDraftLoaded(true);
//       }
//     } catch (error) {
//       console.error("Failed to fetch selected questions:", error);
//     }
//   };

//   useEffect(() => {
//     fetchSelectedQuestions();
//   }, [activeSubjectId, draftData, version]);

//   // ── Reactively update the first header when sectionColumnLabel changes ──
//   // fetchSelectedQuestions only runs on version/draftData/activeSubjectId changes,
//   // so when the user picks a date range AFTER questions are already loaded,
//   // headers[0] stays "Section". This effect patches it in-place.
//   useEffect(() => {
//     if (!sectionColumnLabel) return;
//     setHeaders((prev) => {
//       if (prev.length === 0) return prev;
//       if (prev[0] === sectionColumnLabel) return prev; // already correct
//       return [sectionColumnLabel, ...prev.slice(1)];
//     });
//   }, [sectionColumnLabel]);

//   // Save selectedSectionPerRow to localStorage every time it updates
//   useEffect(() => {
//     if (
//       !selectedSectionPerRow ||
//       Object.keys(selectedSectionPerRow).length === 0
//     )
//       return;

//     const existingMap = JSON.parse(
//       localStorage.getItem("subjectWiseSectionMap") || "{}"
//     );
//     localStorage.setItem(
//       "subjectWiseSectionMap",
//       JSON.stringify({
//         ...existingMap,
//         [activeSubjectId]: selectedSectionPerRow,
//       })
//     );
//   }, [selectedSectionPerRow, activeSubjectId]);

//   // Restore selectedSectionPerRow and sectionWiseQuestions from localStorage.
//   // Skipped when customSectionOptions is provided (MCQ of the Day mode) — auto-assign handles it.
//   useEffect(() => {
//     if (customSectionOptions && customSectionOptions.length > 0) return;

//     const savedMap = JSON.parse(
//       localStorage.getItem("subjectWiseSectionMap") || "{}"
//     );
//     const subjectMap = savedMap[activeSubjectId] || {};

//     setSelectedSectionPerRow(subjectMap); // 🟢 restore dropdowns

//     const newSectionWise = {};
//     reportDashboardData.forEach((row) => {
//       const quesId = row[1];
//       const section = subjectMap[quesId];
//       if (section) {
//         if (!newSectionWise[section]) newSectionWise[section] = [];
//         newSectionWise[section].push({
//           id: quesId,
//           text: renderQuestionTextTable(row[2]),
//         });
//       }
//     });

//     setSectionWiseQuestions(newSectionWise); // 🟢 restore section mapping
//   }, [reportDashboardData, draftLoaded, activeSubjectId, customSectionOptions]);

//   // useEffect(() => {
//   //   if (!reportDashboardData.length || !draftLoaded) return;

//   //   const subject = draftData?.subjects?.find(s => s.subject_id === activeSubjectId);
//   //   const dropdownMap = {};

//   //   subject?.questions?.forEach(q => {
//   //     if (q.status === 1 && q.section_name) {
//   //       dropdownMap[q.parse_ques_set_question_id] = q.section_name;
//   //     }
//   //   });

//   //   setSelectedSectionPerRow(dropdownMap); // ✅ THIS LINE SETS DROPDOWN DEFAULT VALUES
//   // }, [reportDashboardData, draftData, activeSubjectId, draftLoaded]);

//   // This effect sets the section-wise questions map based on reportDashboardData and draftData
//   // useEffect(() => {
//   //   if (!reportDashboardData.length || !draftLoaded) return;

//   //   const subject = draftData?.subjects?.find(s => s.subject_id === activeSubjectId);
//   //   const dropdownMap = {};
//   //   const sectionMap = {};

//   //   subject?.questions?.forEach(q => {
//   //     if (q.status === 1 && q.section_name) {
//   //       const quesId = q.parse_ques_set_question_id;
//   //       const section = q.section_name;

//   //       dropdownMap[quesId] = section;

//   //       const matchingRow = reportDashboardData.find(r => r[1] === quesId);
//   //       const questionText = matchingRow?.[2] || ""; // 👈 take from reportDashboardData

//   //       if (!sectionMap[section]) sectionMap[section] = [];
//   //       sectionMap[section].push({
//   //         id: quesId,
//   //         text: renderQuestionTextTable(questionText), // ✅ make sure text is added here
//   //       });
//   //     }
//   //   });

//   //   setSelectedSectionPerRow(dropdownMap);
//   //   setSectionWiseQuestions(sectionMap); // ✅ key part
//   // }, [reportDashboardData, draftData, activeSubjectId, draftLoaded]);

//   useEffect(() => {
//     if (!reportDashboardData.length || !draftLoaded) return;

//     // Skip in MCQ-of-the-Day mode — sequential auto-assign handles this
//     if (customSectionOptions && customSectionOptions.length > 0) return;

//     const subject = draftData?.subjects?.find(
//       (s) => s.subject_superset_id === activeSubjectId
//     );
//     const dropdownMap = {};

//     subject?.questions?.forEach((q) => {

//     // // CHANGE ON 16/03/2026 BY SHASHI - to handle multiple subjects with same superset id
//     // const allSubjectQuestions = draftData?.subjects
//     //     ?.filter((s) => s.subject_superset_id === activeSubjectId)
//     //     ?.flatMap((s) => s.questions || []) || [];
        
//     //   const dropdownMap = {};

//     //   allSubjectQuestions.forEach((q) => {
      
//       if (q.status === 1 && q.section_name) {
//         const quesId = q.parse_ques_set_question_id;
//         dropdownMap[quesId] = q.section_name;
//       }
//     });

//     // 🧠 Merge draft (dropdownMap) + localStorage map
//     const savedMap = JSON.parse(
//       localStorage.getItem("subjectWiseSectionMap") || "{}"
//     );
//     const savedSubjectMap = savedMap[activeSubjectId] || {};

//     const mergedMap = {
//       ...dropdownMap, // from draft
//       ...savedSubjectMap, // from previously saved manual changes
//     };

//     setSelectedSectionPerRow(mergedMap);

//     // 🧠 Auto-assign section if none exists and only one section add this logic on Monday 14/07/2025
//     const finalMap = { ...mergedMap };
//     const defaultSection = selecteSectionTypeID === 2 ? "1" : "A";

//     if (selectedSections === 1) {
//       reportDashboardData.forEach((row) => {
//         const quesId = row[1];
//         if (!finalMap[quesId]) {
//           finalMap[quesId] = defaultSection;
//         }
//       });
//     }

//     setSelectedSectionPerRow(finalMap);

//     // 💾 Save merged version back
//     localStorage.setItem(
//       "subjectWiseSectionMap",
//       JSON.stringify({
//         ...savedMap,
//         [activeSubjectId]: mergedMap,
//       })
//     );

//     // 🛠 Build sectionWiseQuestions from merged map
//     const sectionMap = {};
//     reportDashboardData.forEach((row) => {
//       const quesId = row[1];
//       const section = mergedMap[quesId];
//       if (section) {
//         if (!sectionMap[section]) sectionMap[section] = [];
//         sectionMap[section].push({
//           id: quesId,
//           text: renderQuestionTextTable(row[2]),
//         });
//       }
//     });

//     setSectionWiseQuestions(sectionMap);
//   }, [reportDashboardData, draftData, activeSubjectId, draftLoaded, customSectionOptions]);

//   const handleRemoveRow = (rowToDelete) => {
//     const questionId = rowToDelete[1];
//     // Remove from UI
//     const updatedData = reportDashboardData.filter(
//       (row) => row[1] !== questionId
//     );
//     setReportDashboardData(updatedData);

//     // ✅ Remove from subjectWiseSelectedRowIds
//     const selectedMap = JSON.parse(
//       localStorage.getItem("subjectWiseSelectedRowIds") || "{}"
//     );
//     const updatedSelected = (selectedMap[activeSubjectId] || []).filter(
//       (id) => id !== questionId
//     );
//     localStorage.setItem(
//       "subjectWiseSelectedRowIds",
//       JSON.stringify({
//         ...selectedMap,
//         [activeSubjectId]: updatedSelected,
//       })
//     );

//     // ✅ Add to subjectWiseDeletedRowIds
//     const deletedMap = JSON.parse(
//       localStorage.getItem("subjectWiseDeletedRowIds") || "{}"
//     );
//     const updatedDeleted = Array.from(
//       new Set([...(deletedMap[activeSubjectId] || []), questionId])
//     );
//     localStorage.setItem(
//       "subjectWiseDeletedRowIds",
//       JSON.stringify({
//         ...deletedMap,
//         [activeSubjectId]: updatedDeleted,
//       })
//     );

//     // ✅ Update difficulty count
//     const difficultyIndex = headers.findIndex((h) =>
//       h.toLowerCase().includes("difficulty level")
//     );
//     const diff = rowToDelete[difficultyIndex]?.toLowerCase();
//     if (["easy", "medium", "tough"].includes(diff)) {
//       setDifficultyCount((prev) => ({
//         ...prev,
//         [diff]: Math.max(0, (prev?.[diff] || 0) - 1),
//       }));
//     }
//   };

//   const handleReplaceRow = (rowToReplace) => {
//     const questionIdIndex = 1; // in reportDashboardData
//     const currentQuesId = rowToReplace[questionIdIndex];

//     // ✅ Find this question in allQuesList to get correct Group ID
//     const matchedRow = allQuesList.find((r) => r[0] === currentQuesId);
//     // if (!matchedRow) {
//     //   console.warn("❌ No matching row found in allQuesList for ID:", currentQuesId);
//     //   return;
//     // }
//     if (!matchedRow) {
//       // console.warn("❌ No matching row found in allQuesList for ID:", currentQuesId);

//       setIsMessageBoxVisible(true);
//       setActiveImg(ErrorImg);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>
//               This question is missing from the current question set and cannot
//               be replaced.
//             </span>
//           </div>
//         </div>
//       );
//       return;
//     }
//     const groupIdIndexInAll =
//       headers.findIndex((h) => h.toLowerCase().includes("group id")) - 1; // -1 because allQuesList doesn't have "Section"
//     const currentGroupId = matchedRow[groupIdIndexInAll];

//     console.log("✅ Correct Group ID from allQuesList:", currentGroupId);

//     const selectedMap = JSON.parse(
//       localStorage.getItem("subjectWiseSelectedRowIds") || "{}"
//     );
//     const selectedIds = selectedMap[activeSubjectId] || [];

//     // ✅ Get same-group rows (excluding current and already selected)
//     const sameGroupRows = allQuesList.filter(
//       (r) =>
//         r[groupIdIndexInAll] === currentGroupId &&
//         r[0] !== currentQuesId &&
//         !selectedIds.includes(r[0])
//     );

//     console.log(
//       "🔄 Replacement candidates:",
//       sameGroupRows.map((r) => r[0])
//     );

//     if (sameGroupRows.length === 0) {
//       setIsMessageBoxVisible(true);
//       setActiveImg(ErrorImg);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             {/* <span>No replacement found for the same Group ID.</span> */}
//             <span>
//               No available questions in the list to replace the selected
//               question.
//             </span>
//           </div>
//         </div>
//       );
//       return;
//     }

//     const replacementRow = sameGroupRows[0];

//     // ✅ Replace row in reportDashboardData
//     const updatedData = reportDashboardData.map((row) =>
//       row[questionIdIndex] === currentQuesId ? [row[0], ...replacementRow] : row
//     );
//     setReportDashboardData(updatedData);

//     // ✅ Update localStorage IDs
//     const updatedIds = selectedIds
//       .filter((id) => id !== currentQuesId)
//       .concat(replacementRow[0]);
//     localStorage.setItem(
//       "subjectWiseSelectedRowIds",
//       JSON.stringify({
//         ...selectedMap,
//         [activeSubjectId]: updatedIds,
//       })
//     );

//     // ✅ Update question type map
//     const quesTypeText =
//       replacementRow[
//         headers.findIndex((h) => h.toLowerCase().includes("question type")) - 1
//       ]; // -1 because we added "Section"
//     const quesTypeId = quesTypeMapping[quesTypeText] || null;

//     if (quesTypeId !== null) {
//       const existingQuesTypeMap = JSON.parse(
//         localStorage.getItem("subjectWiseQuesTypeIds") || "{}"
//       );
//       const updatedQuesTypeMap = {
//         ...(existingQuesTypeMap[activeSubjectId] || {}),
//         [replacementRow[0]]: quesTypeId,
//       };

//       // Remove old ID
//       delete updatedQuesTypeMap[currentQuesId];

//       localStorage.setItem(
//         "subjectWiseQuesTypeIds",
//         JSON.stringify({
//           ...existingQuesTypeMap,
//           [activeSubjectId]: updatedQuesTypeMap,
//         })
//       );
//     }
//     console.log("✅ Replacement successful:", replacementRow[0]);
//   };

//   return (
//     <div style={{ height: "auto", width: "100%" }}>
//       <div style={{ position: "sticky", top: "0", paddingLeft: "15px" }}>
//         <TableComponent
//           headers={headers}
//           data={reportDashboardData}
//           searchPlaceholder="Filter Questions..."
//           dataClient={dataClient}
//           setPagePath={setPagePath}
//           renderQuestionText={renderQuestionText}
//           handleRemoveRow={handleRemoveRow}
//           selectedSections={selectedSections}
//           setIsMessageBoxVisible={setIsMessageBoxVisible}
//           setMessageBox={setMessageBox}
//           setActiveImg={setActiveImg}
//           setSectionWiseQuestions={setSectionWiseQuestions}
//           selecteSectionTypeID={selecteSectionTypeID}
//           setQuestionIds={setQuestionIds}
//           // tableQuestions={tableQuestions}
//           allQuesList={allQuesList}
//           handleReplaceRow={handleReplaceRow}
//           renderQuestionTextTable={renderQuestionTextTable}
//           selectedSectionPerRow={selectedSectionPerRow}
//           setSelectedSectionPerRow={setSelectedSectionPerRow}
//           isReadOnlyMode={isReadOnlyMode}
//           customSectionOptions={customSectionOptions}
//           sectionColumnLabel={sectionColumnLabel}
//           numQuestionsPerDate={numQuestionsPerDate}
//         />
//       </div>
//     </div>
//   );
// };

// export default TableDetailsSelectedQuestions;






















































// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { Link } from "react-router-dom";
// import Filter from "../../../Assets/Images/CommanImages/filter.png";
// import columnaddition from "../../../Assets/Images/CommanImages/flat-color-icons_add-column.png";
// import updown from "../../../Assets/Images/CommanImages/updown.png";
// import searchicon from "../../../Assets/Images/CommanImages/searchyellow.png";
// import leftArrow from "../../../Assets/Images/CommanImages/Larrowbar.png";
// import rightArrow from "../../../Assets/Images/CommanImages/Rarrowbar.png";
// import FileExport from "../../../Assets/Images/CommanImages/fileexport.png";
// import InterogativeImg from "./../../../Assets/Images/CommanImages/Warning.png";
// import DeleteIcon from "./../../../Assets/Images/CommanImages/table_cross_icon.png";
// import ReplaceIcon from "./../../../Assets/Images/CommanImages/tabler_replace-filled.png";
// import EyeOpenIcon from "./../../../Assets/Images/CommanImages/eye_lock_open_icon.png";
// import ErrorImg from "../../../Assets/Images/CommanImages/Error.png";
// import InfoIcon from "../../../Assets/Images/CommanImages/Informative.png";
// import EyeLockIcon from "./../../../Assets/Images/CommanImages/eye-lock-icon.png";
// import SelectedValuesDropdown from "../../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
// import DropDown from "../../../Components/Shared/Dropdown/Dropdown";
// import FileSaver from "file-saver";
// import * as XLSX from "xlsx";
// import jsPDF from "jspdf";
// import "jspdf-autotable";
// import { API_BASE_URL } from "../../../Config/Config";
// import EndPoints from "../../../Api/Endpoints";
// import Latex from "react-latex";
// import "katex/dist/katex.min.css";
// import he from "he";
// import "./tab.css";

// const TableComponent = ({
//   headers,
//   data,
//   searchPlaceholder,
//   renderQuestionText,
//   handleRemoveRow,
//   selectedSections,
//   setSectionWiseQuestions,
//   selecteSectionTypeID,
//   handleReplaceRow,
//   renderQuestionTextTable,
//   selectedSectionPerRow,
//   setSelectedSectionPerRow,
//   isReadOnlyMode,
//   customSectionOptions,   // ← NEW: array of { id, label } — overrides generated options when provided
//   sectionColumnLabel,     // ← NEW: string to replace "Section" header label
//   numQuestionsPerDate,    // ← NEW: number — how many questions per date for sequential auto-assign
// }) => {
//   const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
//   const [isFilterVisible, setIsFilterVisible] = useState(false);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [visibleColumns, setVisibleColumns] = useState([]);
//   const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
//   const [currentPage, setCurrentPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10);
//   const [averageRunTime, setAverageRunTime] = useState("");
//   const columnDropdownRef = useRef(null);
//   const [filters, setFilters] = useState({});
//   const [appliedFilters, setAppliedFilters] = useState({});
//   const [isFiltersApplied, setIsFiltersApplied] = useState(false);
//   // const [selectedSectionPerRow, setSelectedSectionPerRow] = useState({});

//   const generateSectionOptions = (selectedSections) => {
//     return Array.from({ length: selectedSections }, (_, i) => {
//       const label =
//         selecteSectionTypeID === 2 ? `${i + 1}` : String.fromCharCode(65 + i); // ✅ numeric or alphabetic
//       return {
//         id: label,
//         label: label,
//       };
//     });
//   };

//   const options = customSectionOptions && customSectionOptions.length > 0
//     ? customSectionOptions
//     : generateSectionOptions(selectedSections || 1);
//   useEffect(() => {
//     if (data.length === 0) return;

//     if (customSectionOptions && customSectionOptions.length > 0) {
//       // ── Sequential date auto-assign ────────────────────────────────────
//       // Distribute questions across dates: numQuestionsPerDate per date in order.
//       // User can override manually afterwards.
//       const qPerDay = Math.max(1, parseInt(numQuestionsPerDate) || 1);
//       const autoDropdowns = {};
//       const autoSectionWise = {};

//       data.forEach((row, idx) => {
//         const questionId   = row[1];
//         const questionText = row[2];
//         const dateIndex    = Math.floor(idx / qPerDay);
//         const dateOption   = customSectionOptions[dateIndex] || customSectionOptions[customSectionOptions.length - 1];
//         const dateLabel    = dateOption.id;

//         autoDropdowns[questionId] = dateLabel;

//         if (!autoSectionWise[dateLabel]) autoSectionWise[dateLabel] = [];
//         autoSectionWise[dateLabel].push({
//           id:   questionId,
//           text: renderQuestionText(questionText),
//         });
//       });

//       setSelectedSectionPerRow(autoDropdowns);
//       setSectionWiseQuestions?.(autoSectionWise);
//       return;
//     }

//     // ── Original section logic (unchanged) ────────────────────────────────
//     if (data.length > 0 && selectedSections === 1) {
//       const defaultSectionLabel = selecteSectionTypeID === 2 ? "1" : "A";

//       const autoAssignDropdowns = {};
//       const autoAssignSectionWise = { [defaultSectionLabel]: [] };

//       data.forEach((row) => {
//         const questionId = row[1];
//         const questionText = row[2];

//         autoAssignDropdowns[questionId] = defaultSectionLabel;
//         autoAssignSectionWise[defaultSectionLabel].push({
//           id: questionId,
//           text: renderQuestionText(questionText),
//         });
//       });

//       setSelectedSectionPerRow(autoAssignDropdowns);
//       setSectionWiseQuestions?.(autoAssignSectionWise);
//     } else if (selectedSections > 1) {
//       // Clear previous auto-assignment if section count increased
//       setSelectedSectionPerRow({});
//       setSectionWiseQuestions({});
//     }
//   }, [data, selectedSections, selecteSectionTypeID, customSectionOptions, numQuestionsPerDate]);

//   // useEffect(() => {
//   //   if (headers.length > 0 && visibleColumns.length === 0) {
//   //     const initialVisible = headers
//   //       .slice(0, 6) // Get first 6 columns
//   //       .filter((_, index) => index !== 4 && index !== 5); // Exclude index 4 and 5
//   //     setVisibleColumns(initialVisible);
//   //   }
//   // }, [headers, visibleColumns]);


//   useEffect(() => {
//     if (headers.length > 0 && visibleColumns.length === 0) {
//       const questionIdColumn = headers[1]; // Question ID at index 1
//       const sectionColumn = headers[0]; // Section at index 0
      
//       const initialVisible = headers
//         .slice(0, 6) // Get first 6 columns
//         .filter((_, index) => 
//           index !== 4 && 
//           index !== 5 && 
//           index !== 0 // ✅ Exclude Section (index 0)
//         );
      
//       // Always include Section and Question ID
//       const finalVisible = [sectionColumn, ...initialVisible];
//       if (!finalVisible.includes(questionIdColumn)) {
//         finalVisible.push(questionIdColumn);
//       }
      
//       setVisibleColumns(finalVisible);
//     }
//   }, [headers, visibleColumns]);

//   // const handleColumnSelection = (column) => {
//   //   if (visibleColumns.includes(column)) {
//   //     setVisibleColumns(visibleColumns.filter((col) => col !== column));
//   //   } else {
//   //     setVisibleColumns([...visibleColumns, column]);
//   //   }
//   // };

//   const handleColumnSelection = (column) => {
//     const questionIdColumn = headers[1]; // Question ID at index 1
//     const sectionColumn = headers[0]; // Section at index 0
    
//     // Prevent toggling Section and Question ID
//     if (column === questionIdColumn || column === sectionColumn) {
//       return;
//     }
    
//     if (visibleColumns.includes(column)) {
//       setVisibleColumns(visibleColumns.filter((col) => col !== column));
//     } else {
//       setVisibleColumns([...visibleColumns, column]);
//     }
//   };


//   const handleSearch = (e) => {
//     setSearchQuery(e.target.value);
//     setCurrentPage(1);
//   };

//   const handleApplyFilter = () => {
//     if (Object.keys(filters).length > 0) {
//       setAppliedFilters({ ...filters }); // Persist selected filters
//       setCurrentPage(1); // Reset to the first page
//       setIsFiltersApplied(true); // Show Reset button
//       setIsFilterVisible(false); // Hide the filter sidebar
//     }
//   };

//   const handleResetFilter = () => {
//     setFilters({}); // Clear current filter selections
//     setAppliedFilters({}); // Clear applied filters
//     setAverageRunTime(""); // Reset any other state if required
//     setIsFiltersApplied(false); // Deactivate the Reset button
//   };

//   const filteredData = data.filter((row) => {
//     const matchesSearchQuery = row.some(
//       (cell) =>
//         cell && String(cell).toLowerCase().includes(searchQuery.toLowerCase())
//     );
//     const matchesAverageRunTime =
//       averageRunTime === "" || row[2] === averageRunTime;

//     // Apply appliedFilters
//     const matchesFilters = Object.entries(appliedFilters).every(
//       ([key, value]) => {
//         const colIndex = headers.indexOf(key);
//         return value ? row[colIndex] === value : true;
//       }
//     );

//     return matchesSearchQuery && matchesAverageRunTime && matchesFilters;
//   });

//   const handleSort = (column) => {
//     let direction = "asc";
//     if (sortConfig.key === column && sortConfig.direction === "asc") {
//       direction = "desc";
//     }
//     setSortConfig({ key: column, direction });
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         columnDropdownRef.current &&
//         !columnDropdownRef.current.contains(event.target)
//       ) {
//         setIsColumnDivVisible(false); // Close the dropdown if clicked outside
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const sortedData = React.useMemo(() => {
//     let sortableData = [...filteredData];
//     if (sortConfig.key !== null) {
//       const colIndex = headers.indexOf(sortConfig.key);
//       sortableData.sort((a, b) => {
//         if (a[colIndex] < b[colIndex]) {
//           return sortConfig.direction === "asc" ? -1 : 1;
//         }
//         if (a[colIndex] > b[colIndex]) {
//           return sortConfig.direction === "asc" ? 1 : -1;
//         }
//         return 0;
//       });
//     }
//     return sortableData;
//   }, [filteredData, sortConfig, headers]);

//   const handlePageSizeChange = (size) => {
//     setPageSize(size);
//     setCurrentPage(1);
//   };

//   const handlePageChange = (page) => {
//     setCurrentPage(page);
//   };

//   const totalPages = Math.ceil(sortedData.length / pageSize);
//   const paginatedData = React.useMemo(() => {
//     const startIndex = (currentPage - 1) * pageSize;
//     return sortedData.slice(startIndex, startIndex + pageSize);
//   }, [sortedData, currentPage, pageSize]);

//   const renderPagination = () => {
//     const pages = [];
//     if (totalPages <= 5) {
//       for (let i = 1; i <= totalPages; i++) {
//         pages.push(
//           <button
//             key={i}
//             onClick={() => handlePageChange(i)}
//             style={{ borderRadius: "5px" }}
//             className={i === currentPage ? "active" : ""}
//           >
//             {" "}
//             {i}{" "}
//           </button>
//         );
//       }
//     } else {
//       if (currentPage <= 3) {
//         for (let i = 1; i <= 3; i++) {
//           pages.push(
//             <button
//               key={i}
//               style={{ borderRadius: "5px" }}
//               onClick={() => handlePageChange(i)}
//               className={i === currentPage ? "active" : ""}
//             >
//               {" "}
//               {i}{" "}
//             </button>
//           );
//         }
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots1">
//             {" "}
//             ...{" "}
//           </span>
//         );
//         pages.push(
//           <button
//             key={totalPages}
//             onClick={() => handlePageChange(totalPages)}
//             style={{ borderRadius: "5px" }}
//           >
//             {totalPages}
//           </button>
//         );
//       } else if (currentPage > 3 && currentPage < totalPages - 2) {
//         pages.push(
//           <button
//             key={1}
//             onClick={() => handlePageChange(1)}
//             style={{ borderRadius: "5px" }}
//           >
//             {" "}
//             1{" "}
//           </button>
//         );
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots1">
//             {" "}
//             ...{" "}
//           </span>
//         );
//         for (let i = currentPage - 1; i <= currentPage + 1; i++) {
//           pages.push(
//             <button
//               key={i}
//               onClick={() => handlePageChange(i)}
//               style={{ borderRadius: "5px" }}
//               className={i === currentPage ? "active" : ""}
//             >
//               {" "}
//               {i}{" "}
//             </button>
//           );
//         }
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots2">
//             {" "}
//             ...{" "}
//           </span>
//         );
//         pages.push(
//           <button
//             key={totalPages}
//             onClick={() => handlePageChange(totalPages)}
//             style={{ borderRadius: "5px" }}
//           >
//             {" "}
//             {totalPages}{" "}
//           </button>
//         );
//       } else {
//         pages.push(
//           <button
//             key={1}
//             onClick={() => handlePageChange(1)}
//             style={{ borderRadius: "5px" }}
//           >
//             {" "}
//             1{" "}
//           </button>
//         );
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots1">
//             {" "}
//             ...{" "}
//           </span>
//         );
//         for (let i = totalPages - 2; i <= totalPages; i++) {
//           pages.push(
//             <button
//               key={i}
//               onClick={() => handlePageChange(i)}
//               style={{ borderRadius: "5px" }}
//               className={i === currentPage ? "active" : ""}
//             >
//               {" "}
//               {i}{" "}
//             </button>
//           );
//         }
//       }
//     }
//     return pages;
//   };
//   const [columnWidth, setColumnWidth] = useState(400);
//   const columnRef = useRef(null);
//   const isResizing = useRef(false);

//   const handleMouseDown = (event) => {
//     isResizing.current = true;
//     document.addEventListener("mousemove", handleMouseMove);
//     document.addEventListener("mouseup", handleMouseUp);
//   };

//   const handleMouseMove = (event) => {
//     if (isResizing.current) {
//       const newWidth = Math.max(
//         100,
//         event.clientX - columnRef.current.offsetLeft
//       );
//       setColumnWidth(newWidth);
//     }
//   };

//   const handleMouseUp = () => {
//     isResizing.current = false;
//     document.removeEventListener("mousemove", handleMouseMove);
//     document.removeEventListener("mouseup", handleMouseUp);
//   };

//   return (
//     <div>
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "space-between",
//           marginTop: "1.5%",
//         }}
//       >
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             width: "80vw",
//           }}
//         >
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               border: "1px solid #6A6A6A",
//               overflow: "hidden",
//             }}
//           >
//             <input
//               type="text"
//               placeholder={searchPlaceholder}
//               name="search"
//               className="search-input-ques-dash"
//               onChange={handleSearch}
//             />
//             <div
//               style={{
//                 width: "1px",
//                 height: "24px",
//                 backgroundColor: "#2F2E40",
//                 margin: "0 4px",
//               }}
//             ></div>
//             <img
//               src={searchicon}
//               alt="search"
//               className="search-icon-ques-dash"
//             />
//           </div>
//           <div
//             style={{ textAlign: "end", marginTop: "20px", color: "#424242" }}
//           >
//             Displaying{" "}
//             {Math.min((currentPage - 1) * pageSize + 1, sortedData.length)} -{" "}
//             {Math.min(currentPage * pageSize, sortedData.length)} of{" "}
//             {sortedData.length} records |
//             {["10", "25", "50", "100", "500"].map((size) => (
//               <span
//                 key={size}
//                 onClick={() => handlePageSizeChange(Number(size))}
//                 style={{
//                   cursor: "pointer",
//                   margin: "0 5px",
//                   textDecoration:
//                     size === pageSize.toString() ? "none" : "underline",
//                   color: size === pageSize.toString() ? "black" : "#337AB7",
//                 }}
//               >
//                 {size}
//               </span>
//             ))}
//           </div>
//         </div>
//       </div>
//       <div
//         style={{
//           display: "flex",
//           backgroundColor: "#D6D6D6",
//           marginTop: "9px",
//           borderTop: "1px solid grey",
//           borderBottom: "1px solid grey",
//         }}
//       >
//         <div
//           style={{
//             backgroundColor: "#FFBD20",
//             display: "flex",
//             alignItems: "center",
//             cursor: "pointer",
//             paddingLeft: "8px",
//             width: "90px",
//           }}
//           onClick={() => setIsFilterVisible(!isFilterVisible)}
//         >
//           <img
//             src={Filter}
//             style={{ height: "24px", width: "24px" }}
//             alt="filter"
//           />
//           <span style={{ marginLeft: "10px", color: "#2F2E40" }}>Filter</span>
//         </div>
//         <div
//           style={{
//             marginLeft: "auto",
//             textAlign: "end",
//             marginRight: "8px",
//             display: "flex",
//             alignItems: "center",
//             position: "relative",
//             cursor: "pointer",
//             height: "40px",
//           }}
//           onClick={() => setIsColumnDivVisible(!isColumnDivVisible)}
//         >
//           <img
//             src={columnaddition}
//             style={{ height: "34px", width: "32px" }}
//             alt="column addition"
//           />
//           <span
//             style={{
//               marginLeft: "4px",
//               color: "#2F2E40",
//               marginRight: "14px",
//               fontSize: "14px",
//             }}
//           >
//             Column Selection
//           </span>
//           {isColumnDivVisible && (
//             <div ref={columnDropdownRef}>
//               <div className="arrow-up-tc"></div>
//               <div className="popupColumn-tc">
//                 {/* {headers
//                   .filter((_, index) => index !== 4 && index !== 5) // Skip index 4 and 5
//                   .map((column, index) => (
//                     <div
//                       key={index}
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         handleColumnSelection(column);
//                       }}
//                     >
//                       <input
//                         type="checkbox"
//                         id={`column-${index}`}
//                         name="columnSelection"
//                         value={column}
//                         className="square-checkbox-tc"
//                         checked={visibleColumns.includes(column)}
//                         readOnly
//                       />
//                       <label htmlFor={`column-${index}`}>{column}</label>
//                     </div>
//                   ))} */}
//                   {headers
//                     .filter((_, index) => 
//                       index !== 0 && // ✅ Skip Section (index 0) from dropdown
//                       index !== 4 && 
//                       index !== 5
//                     )
//                     .map((column, index) => {
//                       const originalIndex = headers.indexOf(column);
//                       const isQuestionId = originalIndex === 1; // Check if it's Question ID
                      
//                       return (
//                         <div
//                           key={index}
//                           onClick={(e) => {
//                             e.stopPropagation();
//                             handleColumnSelection(column);
//                           }}
//                           style={{
//                             cursor: isQuestionId ? 'not-allowed' : 'pointer',
//                             opacity: isQuestionId ? 0.7 : 1,
//                           }}
//                         >
//                           <input
//                             type="checkbox"
//                             id={`column-${index}`}
//                             name="columnSelection"
//                             value={column}
//                             className="square-checkbox-tc"
//                             checked={visibleColumns.includes(column)}
//                             disabled={isQuestionId} 
//                             readOnly
//                           />
//                           <label 
//                             htmlFor={`column-${index}`}
//                             style={{
//                               cursor: isQuestionId ? 'not-allowed' : 'pointer',
//                             }}
//                           >
//                             {column}
//                           </label>
//                         </div>
//                       );
//                     })}
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//       {data.length > 0 ? (
//         <>
//           <div className="table-wrapper-cols-selections-selected-ques-list">
//             <table className="table-tc" style={{ width: "100%" }}>
//               <thead>
//                 <tr>
//                   {visibleColumns.map((heading, index) => (
//                     <td
//                       key={index}
//                       ref={index === 1 ? columnRef : null}
//                       className={`Heading-tc resizable-header ${
//                         index === 1 ? "resizable-header" : ""
//                       }`}
//                       style={{
//                         textAlign: "right",
//                         cursor: "pointer",
//                         width: index === 1 ? `${columnWidth}px` : "auto",
//                         position: "relative",
//                       }}
//                     >
//                       <span
//                         style={{
//                           display: "flex",
//                           alignItems: "left",
//                           justifyContent: "left",
//                           marginLeft: index === 0 ? "130px" : "",
//                         }}
//                       >
//                         {index === 0 && sectionColumnLabel ? sectionColumnLabel : heading}
//                         {index === 2 && (
//                           <div
//                             className="resize-handle"
//                             onMouseDown={handleMouseDown}
//                           ></div>
//                         )}
//                         <img
//                           onClick={() => handleSort(heading)}
//                           src={updown}
//                           style={{
//                             height: "20px",
//                             width: "20px",
//                             marginLeft: "5px",
//                           }}
//                           alt="sort"
//                         />
//                       </span>
//                     </td>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {/* {paginatedData.map((row, rowIndex) => ( */}
//                 {paginatedData.map((row, rowIndex) => {
//                   const questionId = row[1]; // ✅ Index for Question ID
//                   const questionText = row[2]; // ✅ Index for Question Text
//                   return (
//                     <tr
//                       key={rowIndex}
//                       className={rowIndex % 2 === 1 ? "even-row-tc" : ""}
//                     >
//                       {visibleColumns.map((column, cellIndex) => (
//                         <td
//                           key={cellIndex}
//                           style={{
//                             width:
//                               cellIndex === 3 ? `${columnWidth}px` : "100px",
//                             textAlign: "left",
//                             color: "#6A6A6A",
//                             verticalAlign: "middle",
//                             whiteSpace: "nowrap",
//                             overflow: "hidden",
//                             textOverflow: "ellipsis",
//                             maxWidth: `${columnWidth}px`,
//                           }}
//                         >
//                           {cellIndex === 0 ? ( // Ensure link only appears once
//                             <div
//                               style={{ display: "flex", alignItems: "center" }}
//                             >
//                               <div
//                                 className="flag-container-ques-bank-dash"
//                                 style={{
//                                   width: "220px",
//                                   display: "flex",
//                                   alignItems: "center",
//                                   gap: "20px",
//                                 }}
//                               >
//                                 <img
//                                   src={DeleteIcon}
//                                   alt="flag count"
//                                   style={{
//                                     width: "20px",
//                                     opacity: isReadOnlyMode ? 0.6 : 1,
//                                   }}
//                                   // onClick={() => handleRemoveRow && handleRemoveRow(row)}
//                                   onClick={() => {
//                                     if (!isReadOnlyMode && handleRemoveRow) {
//                                       handleRemoveRow(row);
//                                     }
//                                   }}
//                                 />
//                                 <img
//                                   src={ReplaceIcon}
//                                   alt="replace question"
//                                   style={{
//                                     width: "24px",
//                                     cursor: "pointer",
//                                     opacity: isReadOnlyMode ? 0.6 : 1,
//                                   }}
//                                   // onClick={() => handleReplaceRow(row)}
//                                   onClick={() => {
//                                     if (!isReadOnlyMode) {
//                                       handleReplaceRow(row);
//                                     }
//                                   }}
//                                 />
//                                 <div style={{ width: "24px" }}>
//                                   {row[4] === 13 && (
//                                     <img
//                                       src={EyeLockIcon}
//                                       alt="replace question"
//                                       style={{
//                                         width: "24px",
//                                         cursor: "pointer",
//                                       }}
//                                     />
//                                   )}
//                                 </div>
//                                 <select
//                                   style={{
//                                     width: "140px",
//                                     padding: "5px",
//                                     borderRadius: "4px",
//                                     border: "1px solid #ccc",
//                                     cursor: "pointer",
//                                   }}
//                                   value={
//                                     selectedSectionPerRow[questionId] || ""
//                                   }
//                                   onChange={(e) => {
//                                     const sectionLabel = e.target.value;
//                                     setSelectedSectionPerRow((prev) => ({
//                                       ...prev,
//                                       [questionId]: sectionLabel,
//                                     }));

//                                     setSectionWiseQuestions?.((prev) => {
//                                       const updated = { ...prev };

//                                       // Remove this question from all sections
//                                       for (const sec in updated) {
//                                         updated[sec] = updated[sec].filter(
//                                           (q) => q.id !== questionId
//                                         );
//                                       }

//                                       // Add to new section
//                                       if (sectionLabel) {
//                                         if (!updated[sectionLabel])
//                                           updated[sectionLabel] = [];
//                                         updated[sectionLabel].push({
//                                           id: questionId,
//                                           text: questionText,
//                                         });
//                                       }
//                                       return updated;
//                                     });
//                                   }}
//                                   disabled={isReadOnlyMode}
//                                 >
//                                   <option value="">Select</option>
//                                   {options.map((option) => (
//                                     <option key={option.id} value={option.id}>
//                                       {option.label}
//                                     </option>
//                                   ))}
//                                 </select>
//                               </div>
//                               <Link style={{ color: "#337ab7" }}>
//                                 <span
//                                   className="truncated-text"
//                                   title={row[headers.indexOf(column)]}
//                                 >
//                                   {" "}
//                                   {headers.indexOf(column) === 2
//                                     ? renderQuestionTextTable(
//                                         row[headers.indexOf(column)]
//                                       )
//                                     : row[headers.indexOf(column)]}{" "}
//                                 </span>
//                               </Link>
//                             </div>
//                           ) : (
//                             <span className="truncated-text-2">
//                               {" "}
//                               {headers.indexOf(column) === 2
//                                 ? renderQuestionTextTable(
//                                     row[headers.indexOf(column)]
//                                   )
//                                 : row[headers.indexOf(column)]}{" "}
//                             </span>
//                           )}
//                         </td>
//                       ))}
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </table>
//           </div>
//           <div className="pagination-tc">
//             <button
//               onClick={() => handlePageChange(1)}
//               disabled={currentPage === 1}
//               className="extreme-left-tc-pagination"
//             >
//               {" "}
//               <img src={leftArrow} alt="" />{" "}
//             </button>
//             <button
//               onClick={() => handlePageChange(currentPage - 1)}
//               disabled={currentPage === 1}
//               className="lefttc-pagination"
//             >
//               {" "}
//               {"<"}
//             </button>{" "}
//             {renderPagination()}{" "}
//             <button
//               onClick={() => handlePageChange(currentPage + 1)}
//               disabled={currentPage === totalPages}
//               className="righttc-pagination"
//             >
//               {" "}
//               {">"}{" "}
//             </button>
//             <button
//               onClick={() => handlePageChange(totalPages)}
//               disabled={currentPage === totalPages}
//               className="extreme-right-tc-pagination"
//             >
//               {" "}
//               <img src={rightArrow} alt="" />{" "}
//             </button>
//           </div>
//         </>
//       ) : (
//         "No data available"
//       )}
//       {isFilterVisible && (
//         <div className="filter-sidebar-tc">
//           <div className="filter-content-tc" style={{ position: "relative" }}>
//             <button
//               className="repman-cross-btn"
//               onClick={() => {
//                 setIsFilterVisible(false);
//               }}
//             >
//               {" "}
//               <p>X</p>{" "}
//             </button>
//             <h3 className="AdvanceF-heading-tc"> Filter</h3>
//             <div className="filter-apply-reset-ques-rev-dash">
//               {isFiltersApplied && (
//                 <button
//                   className="reset-btn-question-review-dash"
//                   onClick={handleResetFilter}
//                 >
//                   {" "}
//                   RESET{" "}
//                 </button>
//               )}
//               <button
//                 className="apply-btn-question-review-dash"
//                 onClick={handleApplyFilter}
//               >
//                 {" "}
//                 APPLY{" "}
//               </button>
//             </div>
//             <div className="filter-options-container">
//               {headers
//                 .filter((_, index) => index === 0 || index >= 3) // Skip index 2 and 4
//                 .map((header, filteredIndex) => {
//                   const originalIndex =
//                     filteredIndex === 0
//                       ? 0
//                       : filteredIndex + 1 + (filteredIndex >= 1 ? 1 : 0);
//                   let uniqueOptions = [
//                     ...new Set(
//                       data
//                         .map((row) => row[originalIndex])
//                         .filter((option) => option)
//                     ),
//                   ];
//                   if (originalIndex === 0 || originalIndex === 6) {
//                     uniqueOptions.sort((a, b) => (a > b ? 1 : -1));
//                   }
//                   return (
//                     <SelectedValuesDropdown
//                       key={originalIndex}
//                       label={header}
//                       width="300px"
//                       marginLeft="15px"
//                       marginTop="18px"
//                       setSelected={(selectedOption) => {
//                         setFilters((prevFilters) => ({
//                           ...prevFilters,
//                           [header]: selectedOption,
//                         }));
//                       }}
//                       options={uniqueOptions.map((value) => ({
//                         label: value,
//                         id: value,
//                       }))}
//                       selected={filters[header] || ""}
//                       Height="auto"
//                       OverFlow="auto"
//                       minheight="200px"
//                     />
//                   );
//                 })}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// const TableDetailsSelectedQuestions = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   dataClient,
//   setPagePath,
//   selectedSections,
//   setQuestionIds,
//   activeSubjectId,
//   setSectionWiseQuestions,
//   selecteSectionTypeID,
//   // tableQuestions,
//   allQuesList,
//   draftData,
//   isReadOnlyMode,
//   setDifficultyCount,
//   version,
//   customSectionOptions,   // ← NEW
//   sectionColumnLabel,     // ← NEW
//   numQuestionsPerDate,    // ← NEW
// }) => {
//   const [reportDashboardData, setReportDashboardData] = useState([]);
//   const [headers, setHeaders] = useState([]);
//   const [selectedSectionPerRow, setSelectedSectionPerRow] = useState({});
//   const [draftLoaded, setDraftLoaded] = useState(false);

//   const renderQuestionTextTable = (questionText) => {
//     const decodedQuestion = he.decode(questionText);
//     const questionSegments = decodedQuestion.split(/(imgsrc=[^ ]+)/g);
//     return questionSegments.map((segment, index) => {
//       if (segment.startsWith("imgsrc=")) {
//         const imageUrl = segment.replace("imgsrc=", "");
//         return (
//           <img
//             key={index}
//             src={imageUrl}
//             alt={`Question Image ${index}`}
//             style={{ width: "30px", height: "auto", margin: "5px" }}
//           />
//         );
//       } else {
//         return (
//           <span key={index} className="truncated-text-2">
//             <Latex>{segment}</Latex>
//           </span>
//         );
//       }
//     });
//   };

//   const renderQuestionText = (questionText) => {
//     const decodedQuestion = he.decode(questionText);
//     const questionSegments = decodedQuestion.split(/(imgsrc=[^ ]+)/g);
//     return questionSegments.map((segment, index) => {
//       if (segment.startsWith("imgsrc=")) {
//         const imageUrl = segment.replace("imgsrc=", "");
//         return (
//           <img
//             key={index}
//             src={imageUrl}
//             alt={`Question Image ${index}`}
//             style={{ width: "30px", margin: "5px" }}
//           />
//         );
//       } else {
//         return (
//           <span key={index} className="truncated-text-2">
//             <Latex>{segment}</Latex>
//           </span>
//         );
//       }
//     });
//   };

//   // useEffect(() => {
//   //   const fetchSelectedQuestions = async () => {
//   //     const subjectWiseSelected = JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}");
//   //     const localSubjectIds = subjectWiseSelected[activeSubjectId] || [];

//   //     const draftSubjectQuestions = draftData?.subjects?.find(subject => subject.subject_id === activeSubjectId)?.questions?.filter(q => q.status === 1) || [];
//   //     const draftSubjectIds = draftSubjectQuestions.map(q => q.parse_ques_set_question_id);
//   //     // console.log(draftSubjectIds, "draftSubjectIds in TableDetailsSelectedQuestions");

//   //     const mergedIds = Array.from(new Set([...localSubjectIds, ...draftSubjectIds]));
//   //     if (mergedIds.length === 0) return;

//   //     try {
//   //       const response = await fetch(`${API_BASE_URL}/coaching-collaborator-api/api/v1/get-questions-by-ids`, {
//   //         method: "POST",
//   //         headers: {
//   //           Authorization: `Bearer ${localStorage.getItem("other")}`,
//   //           Accept: "application/json",
//   //           "Content-Type": "application/json",
//   //         },
//   //         body: JSON.stringify(mergedIds),
//   //       });

//   //       const result = await response.json();
//   //       const tableData = result?.data?.table_data || [];

//   //       if (tableData.length > 1) {
//   //         const headers = tableData[0].map(h => h.replace(/^t\*|d\*|n\*/, ""));
//   //         const rows = tableData.slice(1);
//   //         setHeaders(["Section", ...headers]);
//   //         setReportDashboardData(rows.map(row => ["", ...row]));

//   //         const allIds = rows.map(row => row[0]);
//   //         const existing = JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}");
//   //         const updated = {
//   //           ...existing,
//   //           [activeSubjectId]: Array.from(new Set([...(existing[activeSubjectId] || []), ...allIds])),
//   //         };
//   //         localStorage.setItem("subjectWiseSelectedRowIds", JSON.stringify(updated));
//   //         setDraftLoaded(true);
//   //       }
//   //     } catch (error) {
//   //       console.error("Failed to fetch selected questions:", error);
//   //     }
//   //   };

//   //   fetchSelectedQuestions();
//   // }, [draftData, activeSubjectId, version]);

//   // useEffect(() => {
//   //   if (!reportDashboardData.length || !draftLoaded) return;
//   //   const difficultyIndex = headers.findIndex(h => h.toLowerCase().includes("difficulty level"));
//   //   const difficultyCount = { easy: 0, medium: 0, tough: 0 };
//   //   reportDashboardData.forEach(row => {
//   //     const diff = row[difficultyIndex]?.toLowerCase();
//   //     if (["easy", "medium", "tough"].includes(diff)) difficultyCount[diff]++;
//   //   });
//   //   setDifficultyCount?.(difficultyCount);
//   // }, [reportDashboardData, headers, draftLoaded]);

//   useEffect(() => {
//     const difficultyIndex = headers.findIndex((h) =>
//       h.toLowerCase().includes("difficulty level")
//     );

//     const difficultyCount = { easy: 0, medium: 0, tough: 0 };

//     if (reportDashboardData.length && draftLoaded) {
//       reportDashboardData.forEach((row) => {
//         const diff = row[difficultyIndex]?.toLowerCase();
//         if (["easy", "medium", "tough"].includes(diff)) {
//           difficultyCount[diff]++;
//         }
//       });
//     }
//     setDifficultyCount?.(difficultyCount);
//   }, [reportDashboardData, headers, draftLoaded, activeSubjectId]);

//   const quesTypeMapping = {
//     "Single Correct MCQ": 1,
//     "Multi Correct MCQ": 2,
//     "Fill in the blanks": 3,
//     "True/False": 4,
//   };

//   // Additional function to fetch selected questions based on activeSubjectId and draftData(SHASHI ON FRIDAY 30/05 2025)
//   const fetchSelectedQuestions = async () => {
//     const subjectWiseSelected = JSON.parse(
//       localStorage.getItem("subjectWiseSelectedRowIds") || "{}"
//     );
//     const deletedRowMap = JSON.parse(
//       localStorage.getItem("subjectWiseDeletedRowIds") || "{}"
//     );

//     const localSubjectIds = subjectWiseSelected[activeSubjectId] || [];

//     // const draftSubjectQuestions = draftData?.subjects?.find(
//     //   (subject) => subject.subject_id === activeSubjectId
//     // )?.questions?.filter((q) => q.status === 1) || [];

//     const draftSubjectQuestionsRaw =
//       draftData?.subjects?.find(
//         (subject) => subject.subject_superset_id === activeSubjectId
//       )?.questions || [];

//     // // CHANGES BY SHASHI ON MONDAY 16/05/2026 
//     // const draftSubjectQuestionsRaw =
//     //     draftData?.subjects
//     //       ?.filter((subject) => subject.subject_superset_id === activeSubjectId)
//     //       ?.flatMap((subject) => subject.questions || []) || [];

//     const draftSubjectQuestions = draftSubjectQuestionsRaw.filter(
//       (q) => q.status === 1
//     );
//     const draftSubjectDeletedQuestions = draftSubjectQuestionsRaw.filter(
//       (q) => q.status === 2
//     );

//     const draftSubjectIds = draftSubjectQuestions.map(
//       (q) => q.parse_ques_set_question_id
//     );
//     const deletedDraftIds = draftSubjectDeletedQuestions.map(
//       (q) => q.parse_ques_set_question_id
//     );

//     // const draftSubjectIds = draftSubjectQuestions.map((q) => q.parse_ques_set_question_id);

//     // Merge and deduplicate
//     const mergedIds = Array.from(
//       new Set([...localSubjectIds, ...draftSubjectIds])
//     );

//     // ✅ Remove deleted IDs
//     const deletedIds = deletedRowMap[activeSubjectId] || [];
//     const finalIds = mergedIds.filter((id) => !deletedIds.includes(id));

//     if (finalIds.length === 0) {
//       setReportDashboardData([]);
//       setHeaders([]);
//       return;
//     }

//     try {
//       const response = await fetch(
//         `${EndPoints.PRISM_GET_QUESTIONS_BY_IDS}`,
//         {
//           method: "POST",
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("other")}`,
//             Accept: "application/json",
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(finalIds),
//         }
//       );

//       const result = await response.json();
//       const tableData = result?.data?.table_data || [];

//       if (tableData.length > 1) {
//         const headers = tableData[0].map((h) => h.replace(/^t\*|d\*|n\*/, ""));
//         const rows = tableData.slice(1);
//         setHeaders([(sectionColumnLabel || "Section"), ...headers]);
//         // setReportDashboardData(rows.map((row) => ["", ...row]));

//         // Ensure table rows follow the order of `finalIds`
//         const idToRowMap = new Map();
//         rows.forEach((row) => {
//           const quesId = row[0]; // assuming 0 is Question ID (since headers have ["Section", ...])
//           idToRowMap.set(quesId, row);
//         });

//         const orderedRows = finalIds
//           .map((id) => idToRowMap.get(id))
//           .filter((row) => row); // skip if not found
//         setReportDashboardData(orderedRows.map((row) => ["", ...row])); // add empty section as first column

//         // ✅ Auto-assign default section (A/1) when selecting questions for the first time if only one section exists
//         if (selectedSections === 1) {
//           const defaultSection = selecteSectionTypeID === 2 ? "1" : "A";
//           const newSectionMap = {};

//           orderedRows.forEach((row) => {
//             const questionId = row[0]; // before "Section" column
//             newSectionMap[questionId] = defaultSection;
//           });

//           setSelectedSectionPerRow(newSectionMap);

//           // Also build sectionWiseQuestions
//           const sectionQuesMap = {
//             [defaultSection]: orderedRows.map((row) => ({
//               id: row[0],
//               text: renderQuestionTextTable(row[2]),
//             })),
//           };
//           setSectionWiseQuestions(sectionQuesMap);
//         }

//         const quesTypeMapPerSubject = {}; // New variable
//         const questionTypeIndex = headers.findIndex((h) =>
//           h.toLowerCase().includes("question type")
//         );
//         if (questionTypeIndex !== -1) {
//           rows.forEach((row) => {
//             const quesId = row[0]; // First column is Question ID (after Section)
//             const quesTypeText = row[questionTypeIndex];
//             const quesTypeId = quesTypeMapping[quesTypeText] || null;

//             if (quesTypeId !== null) {
//               quesTypeMapPerSubject[quesId] = quesTypeId;
//             }
//           });

//           // ✅ Save as a new key in localStorage
//           const existingTypeMap = JSON.parse(
//             localStorage.getItem("subjectWiseQuesTypeIds") || "{}"
//           );
//           localStorage.setItem(
//             "subjectWiseQuesTypeIds",
//             JSON.stringify({
//               ...existingTypeMap,
//               [activeSubjectId]: quesTypeMapPerSubject,
//             })
//           );
//         }

//         // ✅ Update localStorage: merge both
//         const existing = JSON.parse(
//           localStorage.getItem("subjectWiseSelectedRowIds") || "{}"
//         );
//         localStorage.setItem(
//           "subjectWiseSelectedRowIds",
//           JSON.stringify({
//             ...existing,
//             [activeSubjectId]: finalIds,
//           })
//         );

//         // ✅ Save deleted question IDs (status 2) in localStorage
//         // const existingDeleted = JSON.parse(localStorage.getItem("subjectWiseDeletedRowIds") || "{}");
//         // localStorage.setItem("subjectWiseDeletedRowIds", JSON.stringify({
//         //   ...existingDeleted,
//         //   [activeSubjectId]: deletedDraftIds,
//         // }));

//         const existingDeleted = JSON.parse(
//           localStorage.getItem("subjectWiseDeletedRowIds") || "{}"
//         );
//         const currentSelected =
//           JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}")[
//             activeSubjectId
//           ] || [];

//         const mergedDeletedIds = deletedDraftIds.filter(
//           (id) => !currentSelected.includes(id)
//         ); // ✅ do not save as deleted if user already reselected

//         localStorage.setItem(
//           "subjectWiseDeletedRowIds",
//           JSON.stringify({
//             ...existingDeleted,
//             [activeSubjectId]: mergedDeletedIds,
//           })
//         );
//         setDraftLoaded(true);
//       }
//     } catch (error) {
//       console.error("Failed to fetch selected questions:", error);
//     }
//   };

//   useEffect(() => {
//     fetchSelectedQuestions();
//   }, [activeSubjectId, draftData, version]);

//   // ── Reactively update the first header when sectionColumnLabel changes ──
//   // fetchSelectedQuestions only runs on version/draftData/activeSubjectId changes,
//   // so when the user picks a date range AFTER questions are already loaded,
//   // headers[0] stays "Section". This effect patches it in-place.
//   useEffect(() => {
//     if (!sectionColumnLabel) return;
//     setHeaders((prev) => {
//       if (prev.length === 0) return prev;
//       if (prev[0] === sectionColumnLabel) return prev; // already correct
//       return [sectionColumnLabel, ...prev.slice(1)];
//     });
//   }, [sectionColumnLabel]);

//   // Save selectedSectionPerRow to localStorage every time it updates
//   useEffect(() => {
//     if (
//       !selectedSectionPerRow ||
//       Object.keys(selectedSectionPerRow).length === 0
//     )
//       return;

//     const existingMap = JSON.parse(
//       localStorage.getItem("subjectWiseSectionMap") || "{}"
//     );
//     localStorage.setItem(
//       "subjectWiseSectionMap",
//       JSON.stringify({
//         ...existingMap,
//         [activeSubjectId]: selectedSectionPerRow,
//       })
//     );
//   }, [selectedSectionPerRow, activeSubjectId]);

//   // Restore selectedSectionPerRow and sectionWiseQuestions from localStorage.
//   // Skipped when customSectionOptions is provided (MCQ of the Day mode) — auto-assign handles it.
//   useEffect(() => {
//     if (customSectionOptions && customSectionOptions.length > 0) return;

//     const savedMap = JSON.parse(
//       localStorage.getItem("subjectWiseSectionMap") || "{}"
//     );
//     const subjectMap = savedMap[activeSubjectId] || {};

//     setSelectedSectionPerRow(subjectMap); // 🟢 restore dropdowns

//     const newSectionWise = {};
//     reportDashboardData.forEach((row) => {
//       const quesId = row[1];
//       const section = subjectMap[quesId];
//       if (section) {
//         if (!newSectionWise[section]) newSectionWise[section] = [];
//         newSectionWise[section].push({
//           id: quesId,
//           text: renderQuestionTextTable(row[2]),
//         });
//       }
//     });

//     setSectionWiseQuestions(newSectionWise); // 🟢 restore section mapping
//   }, [reportDashboardData, draftLoaded, activeSubjectId, customSectionOptions]);

//   // useEffect(() => {
//   //   if (!reportDashboardData.length || !draftLoaded) return;

//   //   const subject = draftData?.subjects?.find(s => s.subject_id === activeSubjectId);
//   //   const dropdownMap = {};

//   //   subject?.questions?.forEach(q => {
//   //     if (q.status === 1 && q.section_name) {
//   //       dropdownMap[q.parse_ques_set_question_id] = q.section_name;
//   //     }
//   //   });

//   //   setSelectedSectionPerRow(dropdownMap); // ✅ THIS LINE SETS DROPDOWN DEFAULT VALUES
//   // }, [reportDashboardData, draftData, activeSubjectId, draftLoaded]);

//   // This effect sets the section-wise questions map based on reportDashboardData and draftData
//   // useEffect(() => {
//   //   if (!reportDashboardData.length || !draftLoaded) return;

//   //   const subject = draftData?.subjects?.find(s => s.subject_id === activeSubjectId);
//   //   const dropdownMap = {};
//   //   const sectionMap = {};

//   //   subject?.questions?.forEach(q => {
//   //     if (q.status === 1 && q.section_name) {
//   //       const quesId = q.parse_ques_set_question_id;
//   //       const section = q.section_name;

//   //       dropdownMap[quesId] = section;

//   //       const matchingRow = reportDashboardData.find(r => r[1] === quesId);
//   //       const questionText = matchingRow?.[2] || ""; // 👈 take from reportDashboardData

//   //       if (!sectionMap[section]) sectionMap[section] = [];
//   //       sectionMap[section].push({
//   //         id: quesId,
//   //         text: renderQuestionTextTable(questionText), // ✅ make sure text is added here
//   //       });
//   //     }
//   //   });

//   //   setSelectedSectionPerRow(dropdownMap);
//   //   setSectionWiseQuestions(sectionMap); // ✅ key part
//   // }, [reportDashboardData, draftData, activeSubjectId, draftLoaded]);

//   useEffect(() => {
//     if (!reportDashboardData.length || !draftLoaded) return;
//     // Skip in MCQ-of-the-Day mode — sequential auto-assign handles this
//     if (customSectionOptions && customSectionOptions.length > 0) return;

//     const subject = draftData?.subjects?.find(
//       (s) => s.subject_superset_id === activeSubjectId
//     );
//     const dropdownMap = {};

//     subject?.questions?.forEach((q) => {

//     // // CHANGE ON 16/03/2026 BY SHASHI - to handle multiple subjects with same superset id
//     // const allSubjectQuestions = draftData?.subjects
//     //     ?.filter((s) => s.subject_superset_id === activeSubjectId)
//     //     ?.flatMap((s) => s.questions || []) || [];
        
//     //   const dropdownMap = {};

//     //   allSubjectQuestions.forEach((q) => {
      
//       if (q.status === 1 && q.section_name) {
//         const quesId = q.parse_ques_set_question_id;
//         dropdownMap[quesId] = q.section_name;
//       }
//     });

//     // 🧠 Merge draft (dropdownMap) + localStorage map
//     const savedMap = JSON.parse(
//       localStorage.getItem("subjectWiseSectionMap") || "{}"
//     );
//     const savedSubjectMap = savedMap[activeSubjectId] || {};

//     const mergedMap = {
//       ...dropdownMap, // from draft
//       ...savedSubjectMap, // from previously saved manual changes
//     };

//     setSelectedSectionPerRow(mergedMap);

//     // 🧠 Auto-assign section if none exists and only one section add this logic on Monday 14/07/2025
//     const finalMap = { ...mergedMap };
//     const defaultSection = selecteSectionTypeID === 2 ? "1" : "A";

//     if (selectedSections === 1) {
//       reportDashboardData.forEach((row) => {
//         const quesId = row[1];
//         if (!finalMap[quesId]) {
//           finalMap[quesId] = defaultSection;
//         }
//       });
//     }

//     setSelectedSectionPerRow(finalMap);

//     // 💾 Save merged version back
//     localStorage.setItem(
//       "subjectWiseSectionMap",
//       JSON.stringify({
//         ...savedMap,
//         [activeSubjectId]: mergedMap,
//       })
//     );

//     // 🛠 Build sectionWiseQuestions from merged map
//     const sectionMap = {};
//     reportDashboardData.forEach((row) => {
//       const quesId = row[1];
//       const section = mergedMap[quesId];
//       if (section) {
//         if (!sectionMap[section]) sectionMap[section] = [];
//         sectionMap[section].push({
//           id: quesId,
//           text: renderQuestionTextTable(row[2]),
//         });
//       }
//     });

//     setSectionWiseQuestions(sectionMap);
//   }, [reportDashboardData, draftData, activeSubjectId, draftLoaded, customSectionOptions]);

//   const handleRemoveRow = (rowToDelete) => {
//     const questionId = rowToDelete[1];
//     // Remove from UI
//     const updatedData = reportDashboardData.filter(
//       (row) => row[1] !== questionId
//     );
//     setReportDashboardData(updatedData);

//     // ✅ Remove from subjectWiseSelectedRowIds
//     const selectedMap = JSON.parse(
//       localStorage.getItem("subjectWiseSelectedRowIds") || "{}"
//     );
//     const updatedSelected = (selectedMap[activeSubjectId] || []).filter(
//       (id) => id !== questionId
//     );
//     localStorage.setItem(
//       "subjectWiseSelectedRowIds",
//       JSON.stringify({
//         ...selectedMap,
//         [activeSubjectId]: updatedSelected,
//       })
//     );

//     // ✅ Add to subjectWiseDeletedRowIds
//     const deletedMap = JSON.parse(
//       localStorage.getItem("subjectWiseDeletedRowIds") || "{}"
//     );
//     const updatedDeleted = Array.from(
//       new Set([...(deletedMap[activeSubjectId] || []), questionId])
//     );
//     localStorage.setItem(
//       "subjectWiseDeletedRowIds",
//       JSON.stringify({
//         ...deletedMap,
//         [activeSubjectId]: updatedDeleted,
//       })
//     );

//     // ✅ Update difficulty count
//     const difficultyIndex = headers.findIndex((h) =>
//       h.toLowerCase().includes("difficulty level")
//     );
//     const diff = rowToDelete[difficultyIndex]?.toLowerCase();
//     if (["easy", "medium", "tough"].includes(diff)) {
//       setDifficultyCount((prev) => ({
//         ...prev,
//         [diff]: Math.max(0, (prev?.[diff] || 0) - 1),
//       }));
//     }
//   };

//   const handleReplaceRow = (rowToReplace) => {
//     const questionIdIndex = 1; // in reportDashboardData
//     const currentQuesId = rowToReplace[questionIdIndex];

//     // ✅ Find this question in allQuesList to get correct Group ID
//     const matchedRow = allQuesList.find((r) => r[0] === currentQuesId);
//     // if (!matchedRow) {
//     //   console.warn("❌ No matching row found in allQuesList for ID:", currentQuesId);
//     //   return;
//     // }
//     if (!matchedRow) {
//       // console.warn("❌ No matching row found in allQuesList for ID:", currentQuesId);

//       setIsMessageBoxVisible(true);
//       setActiveImg(ErrorImg);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>
//               This question is missing from the current question set and cannot
//               be replaced.
//             </span>
//           </div>
//         </div>
//       );
//       return;
//     }
//     const groupIdIndexInAll =
//       headers.findIndex((h) => h.toLowerCase().includes("group id")) - 1; // -1 because allQuesList doesn't have "Section"
//     const currentGroupId = matchedRow[groupIdIndexInAll];

//     console.log("✅ Correct Group ID from allQuesList:", currentGroupId);

//     const selectedMap = JSON.parse(
//       localStorage.getItem("subjectWiseSelectedRowIds") || "{}"
//     );
//     const selectedIds = selectedMap[activeSubjectId] || [];

//     // ✅ Get same-group rows (excluding current and already selected)
//     const sameGroupRows = allQuesList.filter(
//       (r) =>
//         r[groupIdIndexInAll] === currentGroupId &&
//         r[0] !== currentQuesId &&
//         !selectedIds.includes(r[0])
//     );

//     console.log(
//       "🔄 Replacement candidates:",
//       sameGroupRows.map((r) => r[0])
//     );

//     if (sameGroupRows.length === 0) {
//       setIsMessageBoxVisible(true);
//       setActiveImg(ErrorImg);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             {/* <span>No replacement found for the same Group ID.</span> */}
//             <span>
//               No available questions in the list to replace the selected
//               question.
//             </span>
//           </div>
//         </div>
//       );
//       return;
//     }

//     const replacementRow = sameGroupRows[0];

//     // ✅ Replace row in reportDashboardData
//     const updatedData = reportDashboardData.map((row) =>
//       row[questionIdIndex] === currentQuesId ? [row[0], ...replacementRow] : row
//     );
//     setReportDashboardData(updatedData);

//     // ✅ Update localStorage IDs
//     const updatedIds = selectedIds
//       .filter((id) => id !== currentQuesId)
//       .concat(replacementRow[0]);
//     localStorage.setItem(
//       "subjectWiseSelectedRowIds",
//       JSON.stringify({
//         ...selectedMap,
//         [activeSubjectId]: updatedIds,
//       })
//     );

//     // ✅ Update question type map
//     const quesTypeText =
//       replacementRow[
//         headers.findIndex((h) => h.toLowerCase().includes("question type")) - 1
//       ]; // -1 because we added "Section"
//     const quesTypeId = quesTypeMapping[quesTypeText] || null;

//     if (quesTypeId !== null) {
//       const existingQuesTypeMap = JSON.parse(
//         localStorage.getItem("subjectWiseQuesTypeIds") || "{}"
//       );
//       const updatedQuesTypeMap = {
//         ...(existingQuesTypeMap[activeSubjectId] || {}),
//         [replacementRow[0]]: quesTypeId,
//       };

//       // Remove old ID
//       delete updatedQuesTypeMap[currentQuesId];

//       localStorage.setItem(
//         "subjectWiseQuesTypeIds",
//         JSON.stringify({
//           ...existingQuesTypeMap,
//           [activeSubjectId]: updatedQuesTypeMap,
//         })
//       );
//     }
//     console.log("✅ Replacement successful:", replacementRow[0]);
//   };

//   return (
//     <div style={{ height: "auto", width: "100%" }}>
//       <div style={{ position: "sticky", top: "0", paddingLeft: "15px" }}>
//         <TableComponent
//           headers={headers}
//           data={reportDashboardData}
//           searchPlaceholder="Filter Questions..."
//           dataClient={dataClient}
//           setPagePath={setPagePath}
//           renderQuestionText={renderQuestionText}
//           handleRemoveRow={handleRemoveRow}
//           selectedSections={selectedSections}
//           setIsMessageBoxVisible={setIsMessageBoxVisible}
//           setMessageBox={setMessageBox}
//           setActiveImg={setActiveImg}
//           setSectionWiseQuestions={setSectionWiseQuestions}
//           selecteSectionTypeID={selecteSectionTypeID}
//           setQuestionIds={setQuestionIds}
//           // tableQuestions={tableQuestions}
//           allQuesList={allQuesList}
//           handleReplaceRow={handleReplaceRow}
//           renderQuestionTextTable={renderQuestionTextTable}
//           selectedSectionPerRow={selectedSectionPerRow}
//           setSelectedSectionPerRow={setSelectedSectionPerRow}
//           isReadOnlyMode={isReadOnlyMode}
//           customSectionOptions={customSectionOptions}
//           sectionColumnLabel={sectionColumnLabel}
//           numQuestionsPerDate={numQuestionsPerDate}
//         />
//       </div>
//     </div>
//   );
// };

// export default TableDetailsSelectedQuestions;














































// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { Link } from "react-router-dom";
// import Filter from "../../../Assets/Images/CommanImages/filter.png";
// import columnaddition from "../../../Assets/Images/CommanImages/flat-color-icons_add-column.png";
// import updown from "../../../Assets/Images/CommanImages/updown.png";
// import searchicon from "../../../Assets/Images/CommanImages/searchyellow.png";
// import leftArrow from "../../../Assets/Images/CommanImages/Larrowbar.png";
// import rightArrow from "../../../Assets/Images/CommanImages/Rarrowbar.png";
// import FileExport from "../../../Assets/Images/CommanImages/fileexport.png";
// import InterogativeImg from "./../../../Assets/Images/CommanImages/Warning.png";
// import DeleteIcon from "./../../../Assets/Images/CommanImages/table_cross_icon.png";
// import ReplaceIcon from "./../../../Assets/Images/CommanImages/tabler_replace-filled.png";
// import EyeOpenIcon from "./../../../Assets/Images/CommanImages/eye_lock_open_icon.png";
// import ErrorImg from "../../../Assets/Images/CommanImages/Error.png";
// import InfoIcon from "../../../Assets/Images/CommanImages/Informative.png";
// import EyeLockIcon from "./../../../Assets/Images/CommanImages/eye-lock-icon.png";
// import SelectedValuesDropdown from "../../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
// import DropDown from "../../../Components/Shared/Dropdown/Dropdown";
// import FileSaver from "file-saver";
// import * as XLSX from "xlsx";
// import jsPDF from "jspdf";
// import "jspdf-autotable";
// import { API_BASE_URL } from "../../../Config/Config";
// import EndPoints from "../../../Api/Endpoints";
// import Latex from "react-latex";
// import "katex/dist/katex.min.css";
// import he from "he";
// import "./tab.css";

// const TableComponent = ({
//   headers,
//   data,
//   searchPlaceholder,
//   renderQuestionText,
//   handleRemoveRow,
//   selectedSections,
//   setSectionWiseQuestions,
//   selecteSectionTypeID,
//   handleReplaceRow,
//   renderQuestionTextTable,
//   selectedSectionPerRow,
//   setSelectedSectionPerRow,
//   isReadOnlyMode,
//   customSectionOptions,   // ← NEW: array of { id, label } — overrides generated options when provided
//   sectionColumnLabel,     // ← NEW: string to replace "Section" header label
//   numQuestionsPerDate,    // ← NEW: number — how many questions per date for sequential auto-assign
//   sectionWiseQuestions,   // ← NEW: existing assignments — used to skip already-assigned questions in auto-assign
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
// }) => {
//   const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
//   const [isFilterVisible, setIsFilterVisible] = useState(false);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [visibleColumns, setVisibleColumns] = useState([]);
//   const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
//   const [currentPage, setCurrentPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10);
//   const [averageRunTime, setAverageRunTime] = useState("");
//   const columnDropdownRef = useRef(null);
//   const [filters, setFilters] = useState({});
//   const [appliedFilters, setAppliedFilters] = useState({});
//   const [isFiltersApplied, setIsFiltersApplied] = useState(false);
//   // const [selectedSectionPerRow, setSelectedSectionPerRow] = useState({});

//   const generateSectionOptions = (selectedSections) => {
//     return Array.from({ length: selectedSections }, (_, i) => {
//       const label =
//         selecteSectionTypeID === 2 ? `${i + 1}` : String.fromCharCode(65 + i); // ✅ numeric or alphabetic
//       return {
//         id: label,
//         label: label,
//       };
//     });
//   };

//   const options = customSectionOptions && customSectionOptions.length > 0
//     ? customSectionOptions
//     : generateSectionOptions(selectedSections || 1);
//   useEffect(() => {
//     if (data.length === 0) return;

//     if (customSectionOptions && customSectionOptions.length > 0) {
//       // ── Sequential date auto-assign (MCQ of the Day mode) ───────────────
//       // Uses localStorage "mcqDateAssignments" as the single source of truth
//       // for { questionId: dateLabel } so assignments persist across subject switches.
//       // Only NEW questions (not already assigned) get a date assigned.
//       // Previously assigned questions keep their dates untouched.

//       const qPerDay = Math.max(1, parseInt(numQuestionsPerDate) || 1);

//       // ── 1. Load existing assignments from localStorage ──────────────────
//       const storedAssignments = JSON.parse(
//         localStorage.getItem("mcqDateAssignments") || "{}"
//       ); // { questionId: dateLabel }

//       // ── 2. Find questions that need a new date assigned ─────────────────
//       const newQuestions = data.filter(
//         (row) => !storedAssignments[String(row[1])]
//       );

//       // ── 3. Count total already-assigned to continue slot index ──────────
//       const totalExisting = Object.keys(storedAssignments).length;

//       // ── 4. Assign dates to new questions continuing from existing count ──
//       const updatedAssignments = { ...storedAssignments };
//       newQuestions.forEach((row, idx) => {
//         const questionId = String(row[1]);
//         const slotIndex  = totalExisting + idx;
//         const dateIndex  = Math.floor(slotIndex / qPerDay);
//         const dateOption = customSectionOptions[dateIndex] || customSectionOptions[customSectionOptions.length - 1];
//         updatedAssignments[questionId] = dateOption.id;
//       });

//       // ── 5. Persist updated assignments back to localStorage ─────────────
//       if (newQuestions.length > 0) {
//         localStorage.setItem("mcqDateAssignments", JSON.stringify(updatedAssignments));
//       }

//       // ── 6. Set dropdown state for current subject's questions only ───────
//       const currentDropdowns = {};
//       data.forEach((row) => {
//         const questionId = String(row[1]);
//         if (updatedAssignments[questionId]) {
//           currentDropdowns[questionId] = updatedAssignments[questionId];
//         }
//       });
//       setSelectedSectionPerRow(currentDropdowns);

//       // ── 7. Rebuild full sectionWiseQuestions from ALL assignments ────────
//       // We only have text for current subject's rows in `data`, so for
//       // questions from other subjects we use a placeholder — the save logic
//       // in McqOfTheDay uses question IDs not text, so this is safe.
//       const newSectionWise = {};
//       Object.entries(updatedAssignments).forEach(([questionId, dateLabel]) => {
//         if (!newSectionWise[dateLabel]) newSectionWise[dateLabel] = [];
//         // Try to find text from current data; use id as fallback for other subjects
//         const row = data.find((r) => String(r[1]) === questionId);
//         newSectionWise[dateLabel].push({
//           id:   questionId,
//           text: row ? renderQuestionText(row[2]) : questionId,
//         });
//       });

//       setSectionWiseQuestions?.(newSectionWise);
//       return;
//     }

//     // ── Original section logic (unchanged) ────────────────────────────────
//     if (data.length > 0 && selectedSections === 1) {
//       const defaultSectionLabel = selecteSectionTypeID === 2 ? "1" : "A";

//       const autoAssignDropdowns = {};
//       const autoAssignSectionWise = { [defaultSectionLabel]: [] };

//       data.forEach((row) => {
//         const questionId = row[1];
//         const questionText = row[2];

//         autoAssignDropdowns[questionId] = defaultSectionLabel;
//         autoAssignSectionWise[defaultSectionLabel].push({
//           id: questionId,
//           text: renderQuestionText(questionText),
//         });
//       });

//       setSelectedSectionPerRow(autoAssignDropdowns);
//       setSectionWiseQuestions?.(autoAssignSectionWise);
//     } else if (selectedSections > 1) {
//       // Clear previous auto-assignment if section count increased
//       setSelectedSectionPerRow({});
//       setSectionWiseQuestions({});
//     }
//   }, [data, selectedSections, selecteSectionTypeID, customSectionOptions, numQuestionsPerDate]);

//   // useEffect(() => {
//   //   if (headers.length > 0 && visibleColumns.length === 0) {
//   //     const initialVisible = headers
//   //       .slice(0, 6) // Get first 6 columns
//   //       .filter((_, index) => index !== 4 && index !== 5); // Exclude index 4 and 5
//   //     setVisibleColumns(initialVisible);
//   //   }
//   // }, [headers, visibleColumns]);


//   useEffect(() => {
//     if (headers.length > 0 && visibleColumns.length === 0) {
//       const questionIdColumn = headers[1]; // Question ID at index 1
//       const sectionColumn = headers[0]; // Section at index 0
      
//       const initialVisible = headers
//         .slice(0, 6) // Get first 6 columns
//         .filter((_, index) => 
//           index !== 4 && 
//           index !== 5 && 
//           index !== 0 // ✅ Exclude Section (index 0)
//         );
      
//       // Always include Section and Question ID
//       const finalVisible = [sectionColumn, ...initialVisible];
//       if (!finalVisible.includes(questionIdColumn)) {
//         finalVisible.push(questionIdColumn);
//       }
      
//       setVisibleColumns(finalVisible);
//     }
//   }, [headers, visibleColumns]);

//   // const handleColumnSelection = (column) => {
//   //   if (visibleColumns.includes(column)) {
//   //     setVisibleColumns(visibleColumns.filter((col) => col !== column));
//   //   } else {
//   //     setVisibleColumns([...visibleColumns, column]);
//   //   }
//   // };

//   const handleColumnSelection = (column) => {
//     const questionIdColumn = headers[1]; // Question ID at index 1
//     const sectionColumn = headers[0]; // Section at index 0
    
//     // Prevent toggling Section and Question ID
//     if (column === questionIdColumn || column === sectionColumn) {
//       return;
//     }
    
//     if (visibleColumns.includes(column)) {
//       setVisibleColumns(visibleColumns.filter((col) => col !== column));
//     } else {
//       setVisibleColumns([...visibleColumns, column]);
//     }
//   };


//   const handleSearch = (e) => {
//     setSearchQuery(e.target.value);
//     setCurrentPage(1);
//   };

//   const handleApplyFilter = () => {
//     if (Object.keys(filters).length > 0) {
//       setAppliedFilters({ ...filters }); // Persist selected filters
//       setCurrentPage(1); // Reset to the first page
//       setIsFiltersApplied(true); // Show Reset button
//       setIsFilterVisible(false); // Hide the filter sidebar
//     }
//   };

//   const handleResetFilter = () => {
//     setFilters({}); // Clear current filter selections
//     setAppliedFilters({}); // Clear applied filters
//     setAverageRunTime(""); // Reset any other state if required
//     setIsFiltersApplied(false); // Deactivate the Reset button
//   };

//   const filteredData = data.filter((row) => {
//     const matchesSearchQuery = row.some(
//       (cell) =>
//         cell && String(cell).toLowerCase().includes(searchQuery.toLowerCase())
//     );
//     const matchesAverageRunTime =
//       averageRunTime === "" || row[2] === averageRunTime;

//     // Apply appliedFilters
//     const matchesFilters = Object.entries(appliedFilters).every(
//       ([key, value]) => {
//         const colIndex = headers.indexOf(key);
//         return value ? row[colIndex] === value : true;
//       }
//     );

//     return matchesSearchQuery && matchesAverageRunTime && matchesFilters;
//   });

//   const handleSort = (column) => {
//     let direction = "asc";
//     if (sortConfig.key === column && sortConfig.direction === "asc") {
//       direction = "desc";
//     }
//     setSortConfig({ key: column, direction });
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         columnDropdownRef.current &&
//         !columnDropdownRef.current.contains(event.target)
//       ) {
//         setIsColumnDivVisible(false); // Close the dropdown if clicked outside
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const sortedData = React.useMemo(() => {
//     let sortableData = [...filteredData];
//     if (sortConfig.key !== null) {
//       const colIndex = headers.indexOf(sortConfig.key);
//       sortableData.sort((a, b) => {
//         if (a[colIndex] < b[colIndex]) {
//           return sortConfig.direction === "asc" ? -1 : 1;
//         }
//         if (a[colIndex] > b[colIndex]) {
//           return sortConfig.direction === "asc" ? 1 : -1;
//         }
//         return 0;
//       });
//     }
//     return sortableData;
//   }, [filteredData, sortConfig, headers]);

//   const handlePageSizeChange = (size) => {
//     setPageSize(size);
//     setCurrentPage(1);
//   };

//   const handlePageChange = (page) => {
//     setCurrentPage(page);
//   };

//   const totalPages = Math.ceil(sortedData.length / pageSize);
//   const paginatedData = React.useMemo(() => {
//     const startIndex = (currentPage - 1) * pageSize;
//     return sortedData.slice(startIndex, startIndex + pageSize);
//   }, [sortedData, currentPage, pageSize]);

//   const renderPagination = () => {
//     const pages = [];
//     if (totalPages <= 5) {
//       for (let i = 1; i <= totalPages; i++) {
//         pages.push(
//           <button
//             key={i}
//             onClick={() => handlePageChange(i)}
//             style={{ borderRadius: "5px" }}
//             className={i === currentPage ? "active" : ""}
//           >
//             {" "}
//             {i}{" "}
//           </button>
//         );
//       }
//     } else {
//       if (currentPage <= 3) {
//         for (let i = 1; i <= 3; i++) {
//           pages.push(
//             <button
//               key={i}
//               style={{ borderRadius: "5px" }}
//               onClick={() => handlePageChange(i)}
//               className={i === currentPage ? "active" : ""}
//             >
//               {" "}
//               {i}{" "}
//             </button>
//           );
//         }
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots1">
//             {" "}
//             ...{" "}
//           </span>
//         );
//         pages.push(
//           <button
//             key={totalPages}
//             onClick={() => handlePageChange(totalPages)}
//             style={{ borderRadius: "5px" }}
//           >
//             {totalPages}
//           </button>
//         );
//       } else if (currentPage > 3 && currentPage < totalPages - 2) {
//         pages.push(
//           <button
//             key={1}
//             onClick={() => handlePageChange(1)}
//             style={{ borderRadius: "5px" }}
//           >
//             {" "}
//             1{" "}
//           </button>
//         );
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots1">
//             {" "}
//             ...{" "}
//           </span>
//         );
//         for (let i = currentPage - 1; i <= currentPage + 1; i++) {
//           pages.push(
//             <button
//               key={i}
//               onClick={() => handlePageChange(i)}
//               style={{ borderRadius: "5px" }}
//               className={i === currentPage ? "active" : ""}
//             >
//               {" "}
//               {i}{" "}
//             </button>
//           );
//         }
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots2">
//             {" "}
//             ...{" "}
//           </span>
//         );
//         pages.push(
//           <button
//             key={totalPages}
//             onClick={() => handlePageChange(totalPages)}
//             style={{ borderRadius: "5px" }}
//           >
//             {" "}
//             {totalPages}{" "}
//           </button>
//         );
//       } else {
//         pages.push(
//           <button
//             key={1}
//             onClick={() => handlePageChange(1)}
//             style={{ borderRadius: "5px" }}
//           >
//             {" "}
//             1{" "}
//           </button>
//         );
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots1">
//             {" "}
//             ...{" "}
//           </span>
//         );
//         for (let i = totalPages - 2; i <= totalPages; i++) {
//           pages.push(
//             <button
//               key={i}
//               onClick={() => handlePageChange(i)}
//               style={{ borderRadius: "5px" }}
//               className={i === currentPage ? "active" : ""}
//             >
//               {" "}
//               {i}{" "}
//             </button>
//           );
//         }
//       }
//     }
//     return pages;
//   };
//   const [columnWidth, setColumnWidth] = useState(400);
//   const columnRef = useRef(null);
//   const isResizing = useRef(false);

//   const handleMouseDown = (event) => {
//     isResizing.current = true;
//     document.addEventListener("mousemove", handleMouseMove);
//     document.addEventListener("mouseup", handleMouseUp);
//   };

//   const handleMouseMove = (event) => {
//     if (isResizing.current) {
//       const newWidth = Math.max(
//         100,
//         event.clientX - columnRef.current.offsetLeft
//       );
//       setColumnWidth(newWidth);
//     }
//   };

//   const handleMouseUp = () => {
//     isResizing.current = false;
//     document.removeEventListener("mousemove", handleMouseMove);
//     document.removeEventListener("mouseup", handleMouseUp);
//   };

//   return (
//     <div>
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "space-between",
//           marginTop: "1.5%",
//         }}
//       >
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             width: "80vw",
//           }}
//         >
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               border: "1px solid #6A6A6A",
//               overflow: "hidden",
//             }}
//           >
//             <input
//               type="text"
//               placeholder={searchPlaceholder}
//               name="search"
//               className="search-input-ques-dash"
//               onChange={handleSearch}
//             />
//             <div
//               style={{
//                 width: "1px",
//                 height: "24px",
//                 backgroundColor: "#2F2E40",
//                 margin: "0 4px",
//               }}
//             ></div>
//             <img
//               src={searchicon}
//               alt="search"
//               className="search-icon-ques-dash"
//             />
//           </div>
//           <div
//             style={{ textAlign: "end", marginTop: "20px", color: "#424242" }}
//           >
//             Displaying{" "}
//             {Math.min((currentPage - 1) * pageSize + 1, sortedData.length)} -{" "}
//             {Math.min(currentPage * pageSize, sortedData.length)} of{" "}
//             {sortedData.length} records |
//             {["10", "25", "50", "100", "500"].map((size) => (
//               <span
//                 key={size}
//                 onClick={() => handlePageSizeChange(Number(size))}
//                 style={{
//                   cursor: "pointer",
//                   margin: "0 5px",
//                   textDecoration:
//                     size === pageSize.toString() ? "none" : "underline",
//                   color: size === pageSize.toString() ? "black" : "#337AB7",
//                 }}
//               >
//                 {size}
//               </span>
//             ))}
//           </div>
//         </div>
//       </div>
//       <div
//         style={{
//           display: "flex",
//           backgroundColor: "#D6D6D6",
//           marginTop: "9px",
//           borderTop: "1px solid grey",
//           borderBottom: "1px solid grey",
//         }}
//       >
//         <div
//           style={{
//             backgroundColor: "#FFBD20",
//             display: "flex",
//             alignItems: "center",
//             cursor: "pointer",
//             paddingLeft: "8px",
//             width: "90px",
//           }}
//           onClick={() => setIsFilterVisible(!isFilterVisible)}
//         >
//           <img
//             src={Filter}
//             style={{ height: "24px", width: "24px" }}
//             alt="filter"
//           />
//           <span style={{ marginLeft: "10px", color: "#2F2E40" }}>Filter</span>
//         </div>
//         <div
//           style={{
//             marginLeft: "auto",
//             textAlign: "end",
//             marginRight: "8px",
//             display: "flex",
//             alignItems: "center",
//             position: "relative",
//             cursor: "pointer",
//             height: "40px",
//           }}
//           onClick={() => setIsColumnDivVisible(!isColumnDivVisible)}
//         >
//           <img
//             src={columnaddition}
//             style={{ height: "34px", width: "32px" }}
//             alt="column addition"
//           />
//           <span
//             style={{
//               marginLeft: "4px",
//               color: "#2F2E40",
//               marginRight: "14px",
//               fontSize: "14px",
//             }}
//           >
//             Column Selection
//           </span>
//           {isColumnDivVisible && (
//             <div ref={columnDropdownRef}>
//               <div className="arrow-up-tc"></div>
//               <div className="popupColumn-tc">
//                 {/* {headers
//                   .filter((_, index) => index !== 4 && index !== 5) // Skip index 4 and 5
//                   .map((column, index) => (
//                     <div
//                       key={index}
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         handleColumnSelection(column);
//                       }}
//                     >
//                       <input
//                         type="checkbox"
//                         id={`column-${index}`}
//                         name="columnSelection"
//                         value={column}
//                         className="square-checkbox-tc"
//                         checked={visibleColumns.includes(column)}
//                         readOnly
//                       />
//                       <label htmlFor={`column-${index}`}>{column}</label>
//                     </div>
//                   ))} */}
//                   {headers
//                     .filter((_, index) => 
//                       index !== 0 && // ✅ Skip Section (index 0) from dropdown
//                       index !== 4 && 
//                       index !== 5
//                     )
//                     .map((column, index) => {
//                       const originalIndex = headers.indexOf(column);
//                       const isQuestionId = originalIndex === 1; // Check if it's Question ID
                      
//                       return (
//                         <div
//                           key={index}
//                           onClick={(e) => {
//                             e.stopPropagation();
//                             handleColumnSelection(column);
//                           }}
//                           style={{
//                             cursor: isQuestionId ? 'not-allowed' : 'pointer',
//                             opacity: isQuestionId ? 0.7 : 1,
//                           }}
//                         >
//                           <input
//                             type="checkbox"
//                             id={`column-${index}`}
//                             name="columnSelection"
//                             value={column}
//                             className="square-checkbox-tc"
//                             checked={visibleColumns.includes(column)}
//                             disabled={isQuestionId} 
//                             readOnly
//                           />
//                           <label 
//                             htmlFor={`column-${index}`}
//                             style={{
//                               cursor: isQuestionId ? 'not-allowed' : 'pointer',
//                             }}
//                           >
//                             {column}
//                           </label>
//                         </div>
//                       );
//                     })}
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//       {data.length > 0 ? (
//         <>
//           <div className="table-wrapper-cols-selections-selected-ques-list">
//             <table className="table-tc" style={{ width: "100%" }}>
//               <thead>
//                 <tr>
//                   {visibleColumns.map((heading, index) => (
//                     <td
//                       key={index}
//                       ref={index === 1 ? columnRef : null}
//                       className={`Heading-tc resizable-header ${
//                         index === 1 ? "resizable-header" : ""
//                       }`}
//                       style={{
//                         textAlign: "right",
//                         cursor: "pointer",
//                         width: index === 1 ? `${columnWidth}px` : "auto",
//                         position: "relative",
//                       }}
//                     >
//                       <span
//                         style={{
//                           display: "flex",
//                           alignItems: "left",
//                           justifyContent: "left",
//                           marginLeft: index === 0 ? "130px" : "",
//                         }}
//                       >
//                         {index === 0 && sectionColumnLabel ? sectionColumnLabel : heading}
//                         {index === 2 && (
//                           <div
//                             className="resize-handle"
//                             onMouseDown={handleMouseDown}
//                           ></div>
//                         )}
//                         <img
//                           onClick={() => handleSort(heading)}
//                           src={updown}
//                           style={{
//                             height: "20px",
//                             width: "20px",
//                             marginLeft: "5px",
//                           }}
//                           alt="sort"
//                         />
//                       </span>
//                     </td>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {/* {paginatedData.map((row, rowIndex) => ( */}
//                 {paginatedData.map((row, rowIndex) => {
//                   const questionId = row[1]; // ✅ Index for Question ID
//                   const questionText = row[2]; // ✅ Index for Question Text
//                   return (
//                     <tr
//                       key={rowIndex}
//                       className={rowIndex % 2 === 1 ? "even-row-tc" : ""}
//                     >
//                       {visibleColumns.map((column, cellIndex) => (
//                         <td
//                           key={cellIndex}
//                           style={{
//                             width:
//                               cellIndex === 3 ? `${columnWidth}px` : "100px",
//                             textAlign: "left",
//                             color: "#6A6A6A",
//                             verticalAlign: "middle",
//                             whiteSpace: "nowrap",
//                             overflow: "hidden",
//                             textOverflow: "ellipsis",
//                             maxWidth: `${columnWidth}px`,
//                           }}
//                         >
//                           {cellIndex === 0 ? ( // Ensure link only appears once
//                             <div
//                               style={{ display: "flex", alignItems: "center" }}
//                             >
//                               <div
//                                 className="flag-container-ques-bank-dash"
//                                 style={{
//                                   width: "220px",
//                                   display: "flex",
//                                   alignItems: "center",
//                                   gap: "20px",
//                                 }}
//                               >
//                                 <img
//                                   src={DeleteIcon}
//                                   alt="flag count"
//                                   style={{
//                                     width: "20px",
//                                     opacity: isReadOnlyMode ? 0.6 : 1,
//                                   }}
//                                   // onClick={() => handleRemoveRow && handleRemoveRow(row)}
//                                   onClick={() => {
//                                     if (!isReadOnlyMode && handleRemoveRow) {
//                                       handleRemoveRow(row);
//                                     }
//                                   }}
//                                 />
//                                 <img
//                                   src={ReplaceIcon}
//                                   alt="replace question"
//                                   style={{
//                                     width: "24px",
//                                     cursor: "pointer",
//                                     opacity: isReadOnlyMode ? 0.6 : 1,
//                                   }}
//                                   // onClick={() => handleReplaceRow(row)}
//                                   onClick={() => {
//                                     if (!isReadOnlyMode) {
//                                       handleReplaceRow(row);
//                                     }
//                                   }}
//                                 />
//                                 <div style={{ width: "24px" }}>
//                                   {row[4] === 13 && (
//                                     <img
//                                       src={EyeLockIcon}
//                                       alt="replace question"
//                                       style={{
//                                         width: "24px",
//                                         cursor: "pointer",
//                                       }}
//                                     />
//                                   )}
//                                 </div>
//                                 <select
//                                   style={{
//                                     width: "140px",
//                                     padding: "5px",
//                                     borderRadius: "4px",
//                                     border: "1px solid #ccc",
//                                     cursor: "pointer",
//                                   }}
//                                   value={
//                                     selectedSectionPerRow[questionId] || ""
//                                   }
//                                   onChange={(e) => {
//                                     const sectionLabel = e.target.value;

//                                     // ── Slot-full validation (MCQ-of-the-Day mode) ──
//                                     if (customSectionOptions && customSectionOptions.length > 0 && sectionLabel) {
//                                       const qPerDay = Math.max(1, parseInt(numQuestionsPerDate) || 1);
//                                       const currentInDate = Object.entries(selectedSectionPerRow)
//                                         .filter(([qid, date]) => date === sectionLabel && qid !== String(questionId))
//                                         .length;
//                                       if (currentInDate >= qPerDay) {
//                                         setMessageBox?.(
//                                           <div className="Container-messageBOX">
//                                             <div className="messagebox-insider1">
//                                               <span>
//                                                 ⚠ Date <b>{sectionLabel}</b> already has {qPerDay} question{qPerDay !== 1 ? "s" : ""} (slot full).
//                                                 Please deselect a question from that date first.
//                                               </span>
//                                             </div>
//                                             <div className="messagebox-insider2" style={{ marginTop: 10 }}>
//                                               <button className="messagebox-cancel-btn-ok" onClick={() => setIsMessageBoxVisible?.(false)}>OK</button>
//                                             </div>
//                                           </div>
//                                         );
//                                         setActiveImg?.(InterogativeImg);
//                                         setIsMessageBoxVisible?.(true);
//                                         return; // block the change
//                                       }
//                                     }
//                                     setSelectedSectionPerRow((prev) => ({
//                                       ...prev,
//                                       [questionId]: sectionLabel,
//                                     }));

//                                     setSectionWiseQuestions?.((prev) => {
//                                       const updated = { ...prev };

//                                       // Remove this question from all sections
//                                       for (const sec in updated) {
//                                         updated[sec] = updated[sec].filter(
//                                           (q) => q.id !== questionId
//                                         );
//                                       }

//                                       // Add to new section
//                                       if (sectionLabel) {
//                                         if (!updated[sectionLabel])
//                                           updated[sectionLabel] = [];
//                                         updated[sectionLabel].push({
//                                           id: questionId,
//                                           text: questionText,
//                                         });
//                                       }
//                                       return updated;
//                                     });
//                                   }}
//                                   disabled={isReadOnlyMode}
//                                 >
//                                   <option value="">Select</option>
//                                   {options.map((option) => (
//                                     <option key={option.id} value={option.id}>
//                                       {option.label}
//                                     </option>
//                                   ))}
//                                 </select>
//                               </div>
//                               <Link style={{ color: "#337ab7" }}>
//                                 <span
//                                   className="truncated-text"
//                                   title={row[headers.indexOf(column)]}
//                                 >
//                                   {" "}
//                                   {headers.indexOf(column) === 2
//                                     ? renderQuestionTextTable(
//                                         row[headers.indexOf(column)]
//                                       )
//                                     : row[headers.indexOf(column)]}{" "}
//                                 </span>
//                               </Link>
//                             </div>
//                           ) : (
//                             <span className="truncated-text-2">
//                               {" "}
//                               {headers.indexOf(column) === 2
//                                 ? renderQuestionTextTable(
//                                     row[headers.indexOf(column)]
//                                   )
//                                 : row[headers.indexOf(column)]}{" "}
//                             </span>
//                           )}
//                         </td>
//                       ))}
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </table>
//           </div>
//           <div className="pagination-tc">
//             <button
//               onClick={() => handlePageChange(1)}
//               disabled={currentPage === 1}
//               className="extreme-left-tc-pagination"
//             >
//               {" "}
//               <img src={leftArrow} alt="" />{" "}
//             </button>
//             <button
//               onClick={() => handlePageChange(currentPage - 1)}
//               disabled={currentPage === 1}
//               className="lefttc-pagination"
//             >
//               {" "}
//               {"<"}
//             </button>{" "}
//             {renderPagination()}{" "}
//             <button
//               onClick={() => handlePageChange(currentPage + 1)}
//               disabled={currentPage === totalPages}
//               className="righttc-pagination"
//             >
//               {" "}
//               {">"}{" "}
//             </button>
//             <button
//               onClick={() => handlePageChange(totalPages)}
//               disabled={currentPage === totalPages}
//               className="extreme-right-tc-pagination"
//             >
//               {" "}
//               <img src={rightArrow} alt="" />{" "}
//             </button>
//           </div>
//         </>
//       ) : (
//         "No data available"
//       )}
//       {isFilterVisible && (
//         <div className="filter-sidebar-tc">
//           <div className="filter-content-tc" style={{ position: "relative" }}>
//             <button
//               className="repman-cross-btn"
//               onClick={() => {
//                 setIsFilterVisible(false);
//               }}
//             >
//               {" "}
//               <p>X</p>{" "}
//             </button>
//             <h3 className="AdvanceF-heading-tc"> Filter</h3>
//             <div className="filter-apply-reset-ques-rev-dash">
//               {isFiltersApplied && (
//                 <button
//                   className="reset-btn-question-review-dash"
//                   onClick={handleResetFilter}
//                 >
//                   {" "}
//                   RESET{" "}
//                 </button>
//               )}
//               <button
//                 className="apply-btn-question-review-dash"
//                 onClick={handleApplyFilter}
//               >
//                 {" "}
//                 APPLY{" "}
//               </button>
//             </div>
//             <div className="filter-options-container">
//               {headers
//                 .filter((_, index) => index === 0 || index >= 3) // Skip index 2 and 4
//                 .map((header, filteredIndex) => {
//                   const originalIndex =
//                     filteredIndex === 0
//                       ? 0
//                       : filteredIndex + 1 + (filteredIndex >= 1 ? 1 : 0);
//                   let uniqueOptions = [
//                     ...new Set(
//                       data
//                         .map((row) => row[originalIndex])
//                         .filter((option) => option)
//                     ),
//                   ];
//                   if (originalIndex === 0 || originalIndex === 6) {
//                     uniqueOptions.sort((a, b) => (a > b ? 1 : -1));
//                   }
//                   return (
//                     <SelectedValuesDropdown
//                       key={originalIndex}
//                       label={header}
//                       width="300px"
//                       marginLeft="15px"
//                       marginTop="18px"
//                       setSelected={(selectedOption) => {
//                         setFilters((prevFilters) => ({
//                           ...prevFilters,
//                           [header]: selectedOption,
//                         }));
//                       }}
//                       options={uniqueOptions.map((value) => ({
//                         label: value,
//                         id: value,
//                       }))}
//                       selected={filters[header] || ""}
//                       Height="auto"
//                       OverFlow="auto"
//                       minheight="200px"
//                     />
//                   );
//                 })}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// const TableDetailsSelectedQuestions = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   dataClient,
//   setPagePath,
//   selectedSections,
//   setQuestionIds,
//   activeSubjectId,
//   setSectionWiseQuestions,
//   selecteSectionTypeID,
//   // tableQuestions,
//   allQuesList,
//   draftData,
//   isReadOnlyMode,
//   setDifficultyCount,
//   version,
//   customSectionOptions,   // ← NEW
//   sectionColumnLabel,     // ← NEW
//   numQuestionsPerDate,    // ← NEW
//   sectionWiseQuestions,   // ← NEW: passed through to TableComponent for auto-assign preservation
// }) => {
//   const [reportDashboardData, setReportDashboardData] = useState([]);
//   const [headers, setHeaders] = useState([]);
//   const [selectedSectionPerRow, setSelectedSectionPerRow] = useState({});
//   const [draftLoaded, setDraftLoaded] = useState(false);

//   const renderQuestionTextTable = (questionText) => {
//     const decodedQuestion = he.decode(questionText);
//     const questionSegments = decodedQuestion.split(/(imgsrc=[^ ]+)/g);
//     return questionSegments.map((segment, index) => {
//       if (segment.startsWith("imgsrc=")) {
//         const imageUrl = segment.replace("imgsrc=", "");
//         return (
//           <img
//             key={index}
//             src={imageUrl}
//             alt={`Question Image ${index}`}
//             style={{ width: "30px", height: "auto", margin: "5px" }}
//           />
//         );
//       } else {
//         return (
//           <span key={index} className="truncated-text-2">
//             <Latex>{segment}</Latex>
//           </span>
//         );
//       }
//     });
//   };

//   const renderQuestionText = (questionText) => {
//     const decodedQuestion = he.decode(questionText);
//     const questionSegments = decodedQuestion.split(/(imgsrc=[^ ]+)/g);
//     return questionSegments.map((segment, index) => {
//       if (segment.startsWith("imgsrc=")) {
//         const imageUrl = segment.replace("imgsrc=", "");
//         return (
//           <img
//             key={index}
//             src={imageUrl}
//             alt={`Question Image ${index}`}
//             style={{ width: "30px", margin: "5px" }}
//           />
//         );
//       } else {
//         return (
//           <span key={index} className="truncated-text-2">
//             <Latex>{segment}</Latex>
//           </span>
//         );
//       }
//     });
//   };

//   // useEffect(() => {
//   //   const fetchSelectedQuestions = async () => {
//   //     const subjectWiseSelected = JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}");
//   //     const localSubjectIds = subjectWiseSelected[activeSubjectId] || [];

//   //     const draftSubjectQuestions = draftData?.subjects?.find(subject => subject.subject_id === activeSubjectId)?.questions?.filter(q => q.status === 1) || [];
//   //     const draftSubjectIds = draftSubjectQuestions.map(q => q.parse_ques_set_question_id);
//   //     // console.log(draftSubjectIds, "draftSubjectIds in TableDetailsSelectedQuestions");

//   //     const mergedIds = Array.from(new Set([...localSubjectIds, ...draftSubjectIds]));
//   //     if (mergedIds.length === 0) return;

//   //     try {
//   //       const response = await fetch(`${API_BASE_URL}/coaching-collaborator-api/api/v1/get-questions-by-ids`, {
//   //         method: "POST",
//   //         headers: {
//   //           Authorization: `Bearer ${localStorage.getItem("other")}`,
//   //           Accept: "application/json",
//   //           "Content-Type": "application/json",
//   //         },
//   //         body: JSON.stringify(mergedIds),
//   //       });

//   //       const result = await response.json();
//   //       const tableData = result?.data?.table_data || [];

//   //       if (tableData.length > 1) {
//   //         const headers = tableData[0].map(h => h.replace(/^t\*|d\*|n\*/, ""));
//   //         const rows = tableData.slice(1);
//   //         setHeaders(["Section", ...headers]);
//   //         setReportDashboardData(rows.map(row => ["", ...row]));

//   //         const allIds = rows.map(row => row[0]);
//   //         const existing = JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}");
//   //         const updated = {
//   //           ...existing,
//   //           [activeSubjectId]: Array.from(new Set([...(existing[activeSubjectId] || []), ...allIds])),
//   //         };
//   //         localStorage.setItem("subjectWiseSelectedRowIds", JSON.stringify(updated));
//   //         setDraftLoaded(true);
//   //       }
//   //     } catch (error) {
//   //       console.error("Failed to fetch selected questions:", error);
//   //     }
//   //   };

//   //   fetchSelectedQuestions();
//   // }, [draftData, activeSubjectId, version]);

//   // useEffect(() => {
//   //   if (!reportDashboardData.length || !draftLoaded) return;
//   //   const difficultyIndex = headers.findIndex(h => h.toLowerCase().includes("difficulty level"));
//   //   const difficultyCount = { easy: 0, medium: 0, tough: 0 };
//   //   reportDashboardData.forEach(row => {
//   //     const diff = row[difficultyIndex]?.toLowerCase();
//   //     if (["easy", "medium", "tough"].includes(diff)) difficultyCount[diff]++;
//   //   });
//   //   setDifficultyCount?.(difficultyCount);
//   // }, [reportDashboardData, headers, draftLoaded]);

//   useEffect(() => {
//     const difficultyIndex = headers.findIndex((h) =>
//       h.toLowerCase().includes("difficulty level")
//     );

//     const difficultyCount = { easy: 0, medium: 0, tough: 0 };

//     if (reportDashboardData.length && draftLoaded) {
//       reportDashboardData.forEach((row) => {
//         const diff = row[difficultyIndex]?.toLowerCase();
//         if (["easy", "medium", "tough"].includes(diff)) {
//           difficultyCount[diff]++;
//         }
//       });
//     }
//     setDifficultyCount?.(difficultyCount);
//   }, [reportDashboardData, headers, draftLoaded, activeSubjectId]);

//   const quesTypeMapping = {
//     "Single Correct MCQ": 1,
//     "Multi Correct MCQ": 2,
//     "Fill in the blanks": 3,
//     "True/False": 4,
//   };

//   // Additional function to fetch selected questions based on activeSubjectId and draftData(SHASHI ON FRIDAY 30/05 2025)
//   const fetchSelectedQuestions = async () => {
//     const subjectWiseSelected = JSON.parse(
//       localStorage.getItem("subjectWiseSelectedRowIds") || "{}"
//     );
//     const deletedRowMap = JSON.parse(
//       localStorage.getItem("subjectWiseDeletedRowIds") || "{}"
//     );

//     const localSubjectIds = subjectWiseSelected[activeSubjectId] || [];

//     // const draftSubjectQuestions = draftData?.subjects?.find(
//     //   (subject) => subject.subject_id === activeSubjectId
//     // )?.questions?.filter((q) => q.status === 1) || [];

//     const draftSubjectQuestionsRaw =
//       draftData?.subjects?.find(
//         (subject) => subject.subject_superset_id === activeSubjectId
//       )?.questions || [];

//     // // CHANGES BY SHASHI ON MONDAY 16/05/2026 
//     // const draftSubjectQuestionsRaw =
//     //     draftData?.subjects
//     //       ?.filter((subject) => subject.subject_superset_id === activeSubjectId)
//     //       ?.flatMap((subject) => subject.questions || []) || [];

//     const draftSubjectQuestions = draftSubjectQuestionsRaw.filter(
//       (q) => q.status === 1
//     );
//     const draftSubjectDeletedQuestions = draftSubjectQuestionsRaw.filter(
//       (q) => q.status === 2
//     );

//     const draftSubjectIds = draftSubjectQuestions.map(
//       (q) => q.parse_ques_set_question_id
//     );
//     const deletedDraftIds = draftSubjectDeletedQuestions.map(
//       (q) => q.parse_ques_set_question_id
//     );

//     // const draftSubjectIds = draftSubjectQuestions.map((q) => q.parse_ques_set_question_id);

//     // Merge and deduplicate
//     const mergedIds = Array.from(
//       new Set([...localSubjectIds, ...draftSubjectIds])
//     );

//     // ✅ Remove deleted IDs
//     const deletedIds = deletedRowMap[activeSubjectId] || [];
//     const finalIds = mergedIds.filter((id) => !deletedIds.includes(id));

//     if (finalIds.length === 0) {
//       setReportDashboardData([]);
//       setHeaders([]);
//       return;
//     }

//     try {
//       const response = await fetch(
//         `${EndPoints.PRISM_GET_QUESTIONS_BY_IDS}`,
//         {
//           method: "POST",
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("other")}`,
//             Accept: "application/json",
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(finalIds),
//         }
//       );

//       const result = await response.json();
//       const tableData = result?.data?.table_data || [];

//       if (tableData.length > 1) {
//         const headers = tableData[0].map((h) => h.replace(/^t\*|d\*|n\*/, ""));
//         const rows = tableData.slice(1);
//         setHeaders([(sectionColumnLabel || "Section"), ...headers]);
//         // setReportDashboardData(rows.map((row) => ["", ...row]));

//         // Ensure table rows follow the order of `finalIds`
//         const idToRowMap = new Map();
//         rows.forEach((row) => {
//           const quesId = row[0]; // assuming 0 is Question ID (since headers have ["Section", ...])
//           idToRowMap.set(quesId, row);
//         });

//         const orderedRows = finalIds
//           .map((id) => idToRowMap.get(id))
//           .filter((row) => row); // skip if not found
//         setReportDashboardData(orderedRows.map((row) => ["", ...row])); // add empty section as first column

//         // ✅ Auto-assign default section (A/1) when selecting questions for the first time if only one section exists
//         if (selectedSections === 1) {
//           const defaultSection = selecteSectionTypeID === 2 ? "1" : "A";
//           const newSectionMap = {};

//           orderedRows.forEach((row) => {
//             const questionId = row[0]; // before "Section" column
//             newSectionMap[questionId] = defaultSection;
//           });

//           setSelectedSectionPerRow(newSectionMap);

//           // Also build sectionWiseQuestions
//           const sectionQuesMap = {
//             [defaultSection]: orderedRows.map((row) => ({
//               id: row[0],
//               text: renderQuestionTextTable(row[2]),
//             })),
//           };
//           setSectionWiseQuestions(sectionQuesMap);
//         }

//         const quesTypeMapPerSubject = {}; // New variable
//         const questionTypeIndex = headers.findIndex((h) =>
//           h.toLowerCase().includes("question type")
//         );
//         if (questionTypeIndex !== -1) {
//           rows.forEach((row) => {
//             const quesId = row[0]; // First column is Question ID (after Section)
//             const quesTypeText = row[questionTypeIndex];
//             const quesTypeId = quesTypeMapping[quesTypeText] || null;

//             if (quesTypeId !== null) {
//               quesTypeMapPerSubject[quesId] = quesTypeId;
//             }
//           });

//           // ✅ Save as a new key in localStorage
//           const existingTypeMap = JSON.parse(
//             localStorage.getItem("subjectWiseQuesTypeIds") || "{}"
//           );
//           localStorage.setItem(
//             "subjectWiseQuesTypeIds",
//             JSON.stringify({
//               ...existingTypeMap,
//               [activeSubjectId]: quesTypeMapPerSubject,
//             })
//           );
//         }

//         // ✅ Update localStorage: merge both
//         const existing = JSON.parse(
//           localStorage.getItem("subjectWiseSelectedRowIds") || "{}"
//         );
//         localStorage.setItem(
//           "subjectWiseSelectedRowIds",
//           JSON.stringify({
//             ...existing,
//             [activeSubjectId]: finalIds,
//           })
//         );

//         // ✅ Save deleted question IDs (status 2) in localStorage
//         // const existingDeleted = JSON.parse(localStorage.getItem("subjectWiseDeletedRowIds") || "{}");
//         // localStorage.setItem("subjectWiseDeletedRowIds", JSON.stringify({
//         //   ...existingDeleted,
//         //   [activeSubjectId]: deletedDraftIds,
//         // }));

//         const existingDeleted = JSON.parse(
//           localStorage.getItem("subjectWiseDeletedRowIds") || "{}"
//         );
//         const currentSelected =
//           JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}")[
//             activeSubjectId
//           ] || [];

//         const mergedDeletedIds = deletedDraftIds.filter(
//           (id) => !currentSelected.includes(id)
//         ); // ✅ do not save as deleted if user already reselected

//         localStorage.setItem(
//           "subjectWiseDeletedRowIds",
//           JSON.stringify({
//             ...existingDeleted,
//             [activeSubjectId]: mergedDeletedIds,
//           })
//         );
//         setDraftLoaded(true);
//       }
//     } catch (error) {
//       console.error("Failed to fetch selected questions:", error);
//     }
//   };

//   useEffect(() => {
//     fetchSelectedQuestions();
//   }, [activeSubjectId, draftData, version]);

//   // ── Reactively update the first header when sectionColumnLabel changes ──
//   // fetchSelectedQuestions only runs on version/draftData/activeSubjectId changes,
//   // so when the user picks a date range AFTER questions are already loaded,
//   // headers[0] stays "Section". This effect patches it in-place.
//   useEffect(() => {
//     if (!sectionColumnLabel) return;
//     setHeaders((prev) => {
//       if (prev.length === 0) return prev;
//       if (prev[0] === sectionColumnLabel) return prev; // already correct
//       return [sectionColumnLabel, ...prev.slice(1)];
//     });
//   }, [sectionColumnLabel]);

//   // Save selectedSectionPerRow to localStorage every time it updates
//   useEffect(() => {
//     if (
//       !selectedSectionPerRow ||
//       Object.keys(selectedSectionPerRow).length === 0
//     )
//       return;

//     const existingMap = JSON.parse(
//       localStorage.getItem("subjectWiseSectionMap") || "{}"
//     );
//     localStorage.setItem(
//       "subjectWiseSectionMap",
//       JSON.stringify({
//         ...existingMap,
//         [activeSubjectId]: selectedSectionPerRow,
//       })
//     );
//   }, [selectedSectionPerRow, activeSubjectId]);

//   // Restore selectedSectionPerRow and sectionWiseQuestions from localStorage.
//   // Skipped when customSectionOptions is provided (MCQ of the Day mode) — auto-assign handles it.
//   useEffect(() => {
//     if (customSectionOptions && customSectionOptions.length > 0) return;

//     const savedMap = JSON.parse(
//       localStorage.getItem("subjectWiseSectionMap") || "{}"
//     );
//     const subjectMap = savedMap[activeSubjectId] || {};

//     setSelectedSectionPerRow(subjectMap); // 🟢 restore dropdowns

//     const newSectionWise = {};
//     reportDashboardData.forEach((row) => {
//       const quesId = row[1];
//       const section = subjectMap[quesId];
//       if (section) {
//         if (!newSectionWise[section]) newSectionWise[section] = [];
//         newSectionWise[section].push({
//           id: quesId,
//           text: renderQuestionTextTable(row[2]),
//         });
//       }
//     });

//     setSectionWiseQuestions(newSectionWise); // 🟢 restore section mapping
//   }, [reportDashboardData, draftLoaded, activeSubjectId, customSectionOptions]);

//   // useEffect(() => {
//   //   if (!reportDashboardData.length || !draftLoaded) return;

//   //   const subject = draftData?.subjects?.find(s => s.subject_id === activeSubjectId);
//   //   const dropdownMap = {};

//   //   subject?.questions?.forEach(q => {
//   //     if (q.status === 1 && q.section_name) {
//   //       dropdownMap[q.parse_ques_set_question_id] = q.section_name;
//   //     }
//   //   });

//   //   setSelectedSectionPerRow(dropdownMap); // ✅ THIS LINE SETS DROPDOWN DEFAULT VALUES
//   // }, [reportDashboardData, draftData, activeSubjectId, draftLoaded]);

//   // This effect sets the section-wise questions map based on reportDashboardData and draftData
//   // useEffect(() => {
//   //   if (!reportDashboardData.length || !draftLoaded) return;

//   //   const subject = draftData?.subjects?.find(s => s.subject_id === activeSubjectId);
//   //   const dropdownMap = {};
//   //   const sectionMap = {};

//   //   subject?.questions?.forEach(q => {
//   //     if (q.status === 1 && q.section_name) {
//   //       const quesId = q.parse_ques_set_question_id;
//   //       const section = q.section_name;

//   //       dropdownMap[quesId] = section;

//   //       const matchingRow = reportDashboardData.find(r => r[1] === quesId);
//   //       const questionText = matchingRow?.[2] || ""; // 👈 take from reportDashboardData

//   //       if (!sectionMap[section]) sectionMap[section] = [];
//   //       sectionMap[section].push({
//   //         id: quesId,
//   //         text: renderQuestionTextTable(questionText), // ✅ make sure text is added here
//   //       });
//   //     }
//   //   });

//   //   setSelectedSectionPerRow(dropdownMap);
//   //   setSectionWiseQuestions(sectionMap); // ✅ key part
//   // }, [reportDashboardData, draftData, activeSubjectId, draftLoaded]);

//   useEffect(() => {
//     if (!reportDashboardData.length || !draftLoaded) return;

//     // Skip in MCQ-of-the-Day mode — sequential auto-assign handles this
//     if (customSectionOptions && customSectionOptions.length > 0) return;

//     const subject = draftData?.subjects?.find(
//       (s) => s.subject_superset_id === activeSubjectId
//     );
//     const dropdownMap = {};

//     subject?.questions?.forEach((q) => {

//     // // CHANGE ON 16/03/2026 BY SHASHI - to handle multiple subjects with same superset id
//     // const allSubjectQuestions = draftData?.subjects
//     //     ?.filter((s) => s.subject_superset_id === activeSubjectId)
//     //     ?.flatMap((s) => s.questions || []) || [];
        
//     //   const dropdownMap = {};

//     //   allSubjectQuestions.forEach((q) => {
      
//       if (q.status === 1 && q.section_name) {
//         const quesId = q.parse_ques_set_question_id;
//         dropdownMap[quesId] = q.section_name;
//       }
//     });

//     // 🧠 Merge draft (dropdownMap) + localStorage map
//     const savedMap = JSON.parse(
//       localStorage.getItem("subjectWiseSectionMap") || "{}"
//     );
//     const savedSubjectMap = savedMap[activeSubjectId] || {};

//     const mergedMap = {
//       ...dropdownMap, // from draft
//       ...savedSubjectMap, // from previously saved manual changes
//     };

//     setSelectedSectionPerRow(mergedMap);

//     // 🧠 Auto-assign section if none exists and only one section add this logic on Monday 14/07/2025
//     const finalMap = { ...mergedMap };
//     const defaultSection = selecteSectionTypeID === 2 ? "1" : "A";

//     if (selectedSections === 1) {
//       reportDashboardData.forEach((row) => {
//         const quesId = row[1];
//         if (!finalMap[quesId]) {
//           finalMap[quesId] = defaultSection;
//         }
//       });
//     }

//     setSelectedSectionPerRow(finalMap);

//     // 💾 Save merged version back
//     localStorage.setItem(
//       "subjectWiseSectionMap",
//       JSON.stringify({
//         ...savedMap,
//         [activeSubjectId]: mergedMap,
//       })
//     );

//     // 🛠 Build sectionWiseQuestions from merged map
//     const sectionMap = {};
//     reportDashboardData.forEach((row) => {
//       const quesId = row[1];
//       const section = mergedMap[quesId];
//       if (section) {
//         if (!sectionMap[section]) sectionMap[section] = [];
//         sectionMap[section].push({
//           id: quesId,
//           text: renderQuestionTextTable(row[2]),
//         });
//       }
//     });

//     setSectionWiseQuestions(sectionMap);
//   }, [reportDashboardData, draftData, activeSubjectId, draftLoaded, customSectionOptions]);

//   const handleRemoveRow = (rowToDelete) => {
//     const questionId = rowToDelete[1];
//     // Remove from UI
//     const updatedData = reportDashboardData.filter(
//       (row) => row[1] !== questionId
//     );
//     setReportDashboardData(updatedData);

//     // ✅ Remove from subjectWiseSelectedRowIds
//     const selectedMap = JSON.parse(
//       localStorage.getItem("subjectWiseSelectedRowIds") || "{}"
//     );
//     const updatedSelected = (selectedMap[activeSubjectId] || []).filter(
//       (id) => id !== questionId
//     );
//     localStorage.setItem(
//       "subjectWiseSelectedRowIds",
//       JSON.stringify({
//         ...selectedMap,
//         [activeSubjectId]: updatedSelected,
//       })
//     );

//     // ✅ Add to subjectWiseDeletedRowIds
//     const deletedMap = JSON.parse(
//       localStorage.getItem("subjectWiseDeletedRowIds") || "{}"
//     );
//     const updatedDeleted = Array.from(
//       new Set([...(deletedMap[activeSubjectId] || []), questionId])
//     );
//     localStorage.setItem(
//       "subjectWiseDeletedRowIds",
//       JSON.stringify({
//         ...deletedMap,
//         [activeSubjectId]: updatedDeleted,
//       })
//     );

//     // ✅ Update difficulty count
//     const difficultyIndex = headers.findIndex((h) =>
//       h.toLowerCase().includes("difficulty level")
//     );
//     const diff = rowToDelete[difficultyIndex]?.toLowerCase();
//     if (["easy", "medium", "tough"].includes(diff)) {
//       setDifficultyCount((prev) => ({
//         ...prev,
//         [diff]: Math.max(0, (prev?.[diff] || 0) - 1),
//       }));
//     }
//   };

//   const handleReplaceRow = (rowToReplace) => {
//     const questionIdIndex = 1; // in reportDashboardData
//     const currentQuesId = rowToReplace[questionIdIndex];

//     // ✅ Find this question in allQuesList to get correct Group ID
//     const matchedRow = allQuesList.find((r) => r[0] === currentQuesId);
//     // if (!matchedRow) {
//     //   console.warn("❌ No matching row found in allQuesList for ID:", currentQuesId);
//     //   return;
//     // }
//     if (!matchedRow) {
//       // console.warn("❌ No matching row found in allQuesList for ID:", currentQuesId);

//       setIsMessageBoxVisible(true);
//       setActiveImg(ErrorImg);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>
//               This question is missing from the current question set and cannot
//               be replaced.
//             </span>
//           </div>
//         </div>
//       );
//       return;
//     }
//     const groupIdIndexInAll =
//       headers.findIndex((h) => h.toLowerCase().includes("group id")) - 1; // -1 because allQuesList doesn't have "Section"
//     const currentGroupId = matchedRow[groupIdIndexInAll];

//     console.log("✅ Correct Group ID from allQuesList:", currentGroupId);

//     const selectedMap = JSON.parse(
//       localStorage.getItem("subjectWiseSelectedRowIds") || "{}"
//     );
//     const selectedIds = selectedMap[activeSubjectId] || [];

//     // ✅ Get same-group rows (excluding current and already selected)
//     const sameGroupRows = allQuesList.filter(
//       (r) =>
//         r[groupIdIndexInAll] === currentGroupId &&
//         r[0] !== currentQuesId &&
//         !selectedIds.includes(r[0])
//     );

//     console.log(
//       "🔄 Replacement candidates:",
//       sameGroupRows.map((r) => r[0])
//     );

//     if (sameGroupRows.length === 0) {
//       setIsMessageBoxVisible(true);
//       setActiveImg(ErrorImg);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             {/* <span>No replacement found for the same Group ID.</span> */}
//             <span>
//               No available questions in the list to replace the selected
//               question.
//             </span>
//           </div>
//         </div>
//       );
//       return;
//     }

//     const replacementRow = sameGroupRows[0];

//     // ✅ Replace row in reportDashboardData
//     const updatedData = reportDashboardData.map((row) =>
//       row[questionIdIndex] === currentQuesId ? [row[0], ...replacementRow] : row
//     );
//     setReportDashboardData(updatedData);

//     // ✅ Update localStorage IDs
//     const updatedIds = selectedIds
//       .filter((id) => id !== currentQuesId)
//       .concat(replacementRow[0]);
//     localStorage.setItem(
//       "subjectWiseSelectedRowIds",
//       JSON.stringify({
//         ...selectedMap,
//         [activeSubjectId]: updatedIds,
//       })
//     );

//     // ✅ Update question type map
//     const quesTypeText =
//       replacementRow[
//         headers.findIndex((h) => h.toLowerCase().includes("question type")) - 1
//       ]; // -1 because we added "Section"
//     const quesTypeId = quesTypeMapping[quesTypeText] || null;

//     if (quesTypeId !== null) {
//       const existingQuesTypeMap = JSON.parse(
//         localStorage.getItem("subjectWiseQuesTypeIds") || "{}"
//       );
//       const updatedQuesTypeMap = {
//         ...(existingQuesTypeMap[activeSubjectId] || {}),
//         [replacementRow[0]]: quesTypeId,
//       };

//       // Remove old ID
//       delete updatedQuesTypeMap[currentQuesId];

//       localStorage.setItem(
//         "subjectWiseQuesTypeIds",
//         JSON.stringify({
//           ...existingQuesTypeMap,
//           [activeSubjectId]: updatedQuesTypeMap,
//         })
//       );
//     }
//     console.log("✅ Replacement successful:", replacementRow[0]);
//   };

//   return (
//     <div style={{ height: "auto", width: "100%" }}>
//       <div style={{ position: "sticky", top: "0", paddingLeft: "15px" }}>
//         <TableComponent
//           headers={headers}
//           data={reportDashboardData}
//           searchPlaceholder="Filter Questions..."
//           dataClient={dataClient}
//           setPagePath={setPagePath}
//           renderQuestionText={renderQuestionText}
//           handleRemoveRow={handleRemoveRow}
//           selectedSections={selectedSections}
//           setIsMessageBoxVisible={setIsMessageBoxVisible}
//           setMessageBox={setMessageBox}
//           setActiveImg={setActiveImg}
//           setSectionWiseQuestions={setSectionWiseQuestions}
//           selecteSectionTypeID={selecteSectionTypeID}
//           setQuestionIds={setQuestionIds}
//           // tableQuestions={tableQuestions}
//           allQuesList={allQuesList}
//           handleReplaceRow={handleReplaceRow}
//           renderQuestionTextTable={renderQuestionTextTable}
//           selectedSectionPerRow={selectedSectionPerRow}
//           setSelectedSectionPerRow={setSelectedSectionPerRow}
//           isReadOnlyMode={isReadOnlyMode}
//           customSectionOptions={customSectionOptions}
//           sectionColumnLabel={sectionColumnLabel}
//           numQuestionsPerDate={numQuestionsPerDate}
//           sectionWiseQuestions={sectionWiseQuestions}
//         />
//       </div>
//     </div>
//   );
// };

// export default TableDetailsSelectedQuestions;























































import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import Filter from "../../../Assets/Images/CommanImages/filter.png";
import columnaddition from "../../../Assets/Images/CommanImages/flat-color-icons_add-column.png";
import updown from "../../../Assets/Images/CommanImages/updown.png";
import searchicon from "../../../Assets/Images/CommanImages/searchyellow.png";
import leftArrow from "../../../Assets/Images/CommanImages/Larrowbar.png";
import rightArrow from "../../../Assets/Images/CommanImages/Rarrowbar.png";
import FileExport from "../../../Assets/Images/CommanImages/fileexport.png";
import InterogativeImg from "./../../../Assets/Images/CommanImages/Warning.png";
import DeleteIcon from "./../../../Assets/Images/CommanImages/table_cross_icon.png";
import ReplaceIcon from "./../../../Assets/Images/CommanImages/tabler_replace-filled.png";
import EyeOpenIcon from "./../../../Assets/Images/CommanImages/eye_lock_open_icon.png";
import ErrorImg from "../../../Assets/Images/CommanImages/Error.png";
import InfoIcon from "../../../Assets/Images/CommanImages/Informative.png";
import EyeLockIcon from "./../../../Assets/Images/CommanImages/eye-lock-icon.png";
import SelectedValuesDropdown from "../../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
import DropDown from "../../../Components/Shared/Dropdown/Dropdown";
import FileSaver from "file-saver";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { API_BASE_URL } from "../../../Config/Config";
import EndPoints from "../../../Api/Endpoints";
import Latex from "react-latex";
import "katex/dist/katex.min.css";
import he from "he";
import "./tab.css";

const TableComponent = ({
  headers,
  data,
  searchPlaceholder,
  renderQuestionText,
  handleRemoveRow,
  selectedSections,
  setSectionWiseQuestions,
  selecteSectionTypeID,
  handleReplaceRow,
  renderQuestionTextTable,
  selectedSectionPerRow,
  setSelectedSectionPerRow,
  isReadOnlyMode,
  customSectionOptions,   // ← NEW: array of { id, label } — overrides generated options when provided
  sectionColumnLabel,     // ← NEW: string to replace "Section" header label
  numQuestionsPerDate,    // ← NEW: number — how many questions per date for sequential auto-assign
  sectionWiseQuestions,
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
}) => {
  const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [visibleColumns, setVisibleColumns] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [averageRunTime, setAverageRunTime] = useState("");
  const columnDropdownRef = useRef(null);
  const [filters, setFilters] = useState({});
  const [appliedFilters, setAppliedFilters] = useState({});
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  // const [selectedSectionPerRow, setSelectedSectionPerRow] = useState({});

  const generateSectionOptions = (selectedSections) => {
    return Array.from({ length: selectedSections }, (_, i) => {
      const label =
        selecteSectionTypeID === 2 ? `${i + 1}` : String.fromCharCode(65 + i); // ✅ numeric or alphabetic
      return {
        id: label,
        label: label,
      };
    });
  };

  const options = customSectionOptions && customSectionOptions.length > 0
    ? customSectionOptions
    : generateSectionOptions(selectedSections || 1);
  useEffect(() => {
    if (data.length === 0) return;

    if (customSectionOptions && customSectionOptions.length > 0) {
      const qPerDay = Math.max(1, parseInt(numQuestionsPerDate) || 1);

      const storedAssignments = JSON.parse(
        localStorage.getItem("mcqDateAssignments") || "{}"
      );

      const newQuestions = data.filter(
        (row) => !storedAssignments[String(row[1])]
      );

      const totalExisting = Object.keys(storedAssignments).length;

      const updatedAssignments = { ...storedAssignments };
      newQuestions.forEach((row, idx) => {
        const questionId = String(row[1]);
        const slotIndex  = totalExisting + idx;
        const dateIndex  = Math.floor(slotIndex / qPerDay);
        const dateOption = customSectionOptions[dateIndex] || customSectionOptions[customSectionOptions.length - 1];
        updatedAssignments[questionId] = dateOption.id;
      });

      if (newQuestions.length > 0) {
        localStorage.setItem("mcqDateAssignments", JSON.stringify(updatedAssignments));
      }

      const currentDropdowns = {};
      data.forEach((row) => {
        const questionId = String(row[1]);
        if (updatedAssignments[questionId]) {
          currentDropdowns[questionId] = updatedAssignments[questionId];
        }
      });
      setSelectedSectionPerRow(currentDropdowns);

      const newSectionWise = {};
      Object.entries(updatedAssignments).forEach(([questionId, dateLabel]) => {
        if (!newSectionWise[dateLabel]) newSectionWise[dateLabel] = [];
        const row = data.find((r) => String(r[1]) === questionId);
        newSectionWise[dateLabel].push({
          id:   questionId,
          text: row ? renderQuestionText(row[2]) : questionId,
        });
      });

      setSectionWiseQuestions?.(newSectionWise);
      return;
    }

    // ── Original section logic (unchanged) ────────────────────────────────
    if (data.length > 0 && selectedSections === 1) {
      const defaultSectionLabel = selecteSectionTypeID === 2 ? "1" : "A";

      const autoAssignDropdowns = {};
      const autoAssignSectionWise = { [defaultSectionLabel]: [] };

      data.forEach((row) => {
        const questionId = row[1];
        const questionText = row[2];

        autoAssignDropdowns[questionId] = defaultSectionLabel;
        autoAssignSectionWise[defaultSectionLabel].push({
          id: questionId,
          text: renderQuestionText(questionText),
        });
      });

      setSelectedSectionPerRow(autoAssignDropdowns);
      setSectionWiseQuestions?.(autoAssignSectionWise);
    } else if (selectedSections > 1) {
      // Clear previous auto-assignment if section count increased
      setSelectedSectionPerRow({});
      setSectionWiseQuestions({});
    }
    }, [data, selectedSections, selecteSectionTypeID, customSectionOptions, numQuestionsPerDate]);


  useEffect(() => {
    if (headers.length > 0 && visibleColumns.length === 0) {
      const questionIdColumn = headers[1]; // Question ID at index 1
      const sectionColumn = headers[0]; // Section at index 0

      const initialVisible = headers
        .slice(0, 6) // Get first 6 columns
        .filter((_, index) =>
          index !== 4 &&
          index !== 5 &&
          index !== 0 // ✅ Exclude Section (index 0)
        );

      // Always include Section and Question ID
      const finalVisible = [sectionColumn, ...initialVisible];
      if (!finalVisible.includes(questionIdColumn)) {
        finalVisible.push(questionIdColumn);
      }

      setVisibleColumns(finalVisible);
    }
  }, [headers, visibleColumns]);


  const handleColumnSelection = (column) => {
    const questionIdColumn = headers[1]; // Question ID at index 1
    const sectionColumn = headers[0]; // Section at index 0

    // Prevent toggling Section and Question ID
    if (column === questionIdColumn || column === sectionColumn) {
      return;
    }

    if (visibleColumns.includes(column)) {
      setVisibleColumns(visibleColumns.filter((col) => col !== column));
    } else {
      setVisibleColumns([...visibleColumns, column]);
    }
  };


  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const handleApplyFilter = () => {
    if (Object.keys(filters).length > 0) {
      setAppliedFilters({ ...filters }); // Persist selected filters
      setCurrentPage(1); // Reset to the first page
      setIsFiltersApplied(true); // Show Reset button
      setIsFilterVisible(false); // Hide the filter sidebar
    }
  };

  const handleResetFilter = () => {
    setFilters({}); // Clear current filter selections
    setAppliedFilters({}); // Clear applied filters
    setAverageRunTime(""); // Reset any other state if required
    setIsFiltersApplied(false); // Deactivate the Reset button
  };

  const filteredData = data.filter((row) => {
    const matchesSearchQuery = row.some(
      (cell) =>
        cell && String(cell).toLowerCase().includes(searchQuery.toLowerCase())
    );
    const matchesAverageRunTime =
      averageRunTime === "" || row[2] === averageRunTime;

    // Apply appliedFilters
    const matchesFilters = Object.entries(appliedFilters).every(
      ([key, value]) => {
        const colIndex = headers.indexOf(key);
        return value ? row[colIndex] === value : true;
      }
    );

    return matchesSearchQuery && matchesAverageRunTime && matchesFilters;
  });

  const handleSort = (column) => {
    let direction = "asc";
    if (sortConfig.key === column && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key: column, direction });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        columnDropdownRef.current &&
        !columnDropdownRef.current.contains(event.target)
      ) {
        setIsColumnDivVisible(false); // Close the dropdown if clicked outside
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const sortedData = React.useMemo(() => {
    let sortableData = [...filteredData];
    if (sortConfig.key !== null) {
      const colIndex = headers.indexOf(sortConfig.key);
      sortableData.sort((a, b) => {
        if (a[colIndex] < b[colIndex]) {
          return sortConfig.direction === "asc" ? -1 : 1;
        }
        if (a[colIndex] > b[colIndex]) {
          return sortConfig.direction === "asc" ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableData;
  }, [filteredData, sortConfig, headers]);

  const handlePageSizeChange = (size) => {
    setPageSize(size);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const totalPages = Math.ceil(sortedData.length / pageSize);
  const paginatedData = React.useMemo(() => {
    const startIndex = (currentPage - 1) * pageSize;
    return sortedData.slice(startIndex, startIndex + pageSize);
  }, [sortedData, currentPage, pageSize]);

  const renderPagination = () => {
    const pages = [];
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(
          <button
            key={i}
            onClick={() => handlePageChange(i)}
            style={{ borderRadius: "5px" }}
            className={i === currentPage ? "active" : ""}
          >
            {" "}
            {i}{" "}
          </button>
        );
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 3; i++) {
          pages.push(
            <button
              key={i}
              style={{ borderRadius: "5px" }}
              onClick={() => handlePageChange(i)}
              className={i === currentPage ? "active" : ""}
            >
              {" "}
              {i}{" "}
            </button>
          );
        }
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots1">
            {" "}
            ...{" "}
          </span>
        );
        pages.push(
          <button
            key={totalPages}
            onClick={() => handlePageChange(totalPages)}
            style={{ borderRadius: "5px" }}
          >
            {totalPages}
          </button>
        );
      } else if (currentPage > 3 && currentPage < totalPages - 2) {
        pages.push(
          <button
            key={1}
            onClick={() => handlePageChange(1)}
            style={{ borderRadius: "5px" }}
          >
            {" "}
            1{" "}
          </button>
        );
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots1">
            {" "}
            ...{" "}
          </span>
        );
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          pages.push(
            <button
              key={i}
              onClick={() => handlePageChange(i)}
              style={{ borderRadius: "5px" }}
              className={i === currentPage ? "active" : ""}
            >
              {" "}
              {i}{" "}
            </button>
          );
        }
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots2">
            {" "}
            ...{" "}
          </span>
        );
        pages.push(
          <button
            key={totalPages}
            onClick={() => handlePageChange(totalPages)}
            style={{ borderRadius: "5px" }}
          >
            {" "}
            {totalPages}{" "}
          </button>
        );
      } else {
        pages.push(
          <button
            key={1}
            onClick={() => handlePageChange(1)}
            style={{ borderRadius: "5px" }}
          >
            {" "}
            1{" "}
          </button>
        );
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots1">
            {" "}
            ...{" "}
          </span>
        );
        for (let i = totalPages - 2; i <= totalPages; i++) {
          pages.push(
            <button
              key={i}
              onClick={() => handlePageChange(i)}
              style={{ borderRadius: "5px" }}
              className={i === currentPage ? "active" : ""}
            >
              {" "}
              {i}{" "}
            </button>
          );
        }
      }
    }
    return pages;
  };
  const [columnWidth, setColumnWidth] = useState(400);
  const columnRef = useRef(null);
  const isResizing = useRef(false);

  const handleMouseDown = (event) => {
    isResizing.current = true;
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  const handleMouseMove = (event) => {
    if (isResizing.current) {
      const newWidth = Math.max(
        100,
        event.clientX - columnRef.current.offsetLeft
      );
      setColumnWidth(newWidth);
    }
  };

  const handleMouseUp = () => {
    isResizing.current = false;
    document.removeEventListener("mousemove", handleMouseMove);
    document.removeEventListener("mouseup", handleMouseUp);
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginTop: "1.5%",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "80vw",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              border: "1px solid #6A6A6A",
              overflow: "hidden",
            }}
          >
            <input
              type="text"
              placeholder={searchPlaceholder}
              name="search"
              className="search-input-ques-dash"
              onChange={handleSearch}
            />
            <div
              style={{
                width: "1px",
                height: "24px",
                backgroundColor: "#2F2E40",
                margin: "0 4px",
              }}
            ></div>
            <img
              src={searchicon}
              alt="search"
              className="search-icon-ques-dash"
            />
          </div>
          <div
            style={{ textAlign: "end", marginTop: "20px", color: "#424242" }}
          >
            Displaying{" "}
            {Math.min((currentPage - 1) * pageSize + 1, sortedData.length)} -{" "}
            {Math.min(currentPage * pageSize, sortedData.length)} of{" "}
            {sortedData.length} records |
            {["10", "25", "50", "100", "500"].map((size) => (
              <span
                key={size}
                onClick={() => handlePageSizeChange(Number(size))}
                style={{
                  cursor: "pointer",
                  margin: "0 5px",
                  textDecoration:
                    size === pageSize.toString() ? "none" : "underline",
                  color: size === pageSize.toString() ? "black" : "#337AB7",
                }}
              >
                {size}
              </span>
            ))}
          </div>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          backgroundColor: "#D6D6D6",
          marginTop: "9px",
          borderTop: "1px solid grey",
          borderBottom: "1px solid grey",
        }}
      >
        <div
          style={{
            backgroundColor: "#FFBD20",
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            paddingLeft: "8px",
            width: "90px",
          }}
          onClick={() => setIsFilterVisible(!isFilterVisible)}
        >
          <img
            src={Filter}
            style={{ height: "24px", width: "24px" }}
            alt="filter"
          />
          <span style={{ marginLeft: "10px", color: "#2F2E40" }}>Filter</span>
        </div>
        <div
          style={{
            marginLeft: "auto",
            textAlign: "end",
            marginRight: "8px",
            display: "flex",
            alignItems: "center",
            position: "relative",
            cursor: "pointer",
            height: "40px",
          }}
          onClick={() => setIsColumnDivVisible(!isColumnDivVisible)}
        >
          <img
            src={columnaddition}
            style={{ height: "34px", width: "32px" }}
            alt="column addition"
          />
          <span
            style={{
              marginLeft: "4px",
              color: "#2F2E40",
              marginRight: "14px",
              fontSize: "14px",
            }}
          >
            Column Selection
          </span>
          {isColumnDivVisible && (
            <div ref={columnDropdownRef}>
              <div className="arrow-up-tc"></div>
              <div className="popupColumn-tc">
                {}
                  {headers
                    .filter((_, index) =>
                      index !== 0 && // ✅ Skip Section (index 0) from dropdown
                      index !== 4 &&
                      index !== 5
                    )
                    .map((column, index) => {
                      const originalIndex = headers.indexOf(column);
                      const isQuestionId = originalIndex === 1; // Check if it's Question ID

                      return (
                        <div
                          key={index}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleColumnSelection(column);
                          }}
                          style={{
                            cursor: isQuestionId ? 'not-allowed' : 'pointer',
                            opacity: isQuestionId ? 0.7 : 1,
                          }}
                        >
                          <input
                            type="checkbox"
                            id={`column-${index}`}
                            name="columnSelection"
                            value={column}
                            className="square-checkbox-tc"
                            checked={visibleColumns.includes(column)}
                            disabled={isQuestionId}
                            readOnly
                          />
                          <label
                            htmlFor={`column-${index}`}
                            style={{
                              cursor: isQuestionId ? 'not-allowed' : 'pointer',
                            }}
                          >
                            {column}
                          </label>
                        </div>
                      );
                    })}
              </div>
            </div>
          )}
        </div>
      </div>
      {data.length > 0 ? (
        <>
          <div className="table-wrapper-cols-selections-selected-ques-list">
            <table className="table-tc" style={{ width: "100%" }}>
              <thead>
                <tr>
                  {visibleColumns.map((heading, index) => (
                    <td
                      key={index}
                      ref={index === 1 ? columnRef : null}
                      className={`Heading-tc resizable-header ${
                        index === 1 ? "resizable-header" : ""
                      }`}
                      style={{
                        textAlign: "right",
                        cursor: "pointer",
                        width: index === 1 ? `${columnWidth}px` : "auto",
                        position: "relative",
                      }}
                    >
                      <span
                        style={{
                          display: "flex",
                          alignItems: "left",
                          justifyContent: "left",
                          marginLeft: index === 0 ? "130px" : "",
                        }}
                      >
                        {index === 0 && sectionColumnLabel ? sectionColumnLabel : heading}
                        {index === 2 && (
                          <div
                            className="resize-handle"
                            onMouseDown={handleMouseDown}
                          ></div>
                        )}
                        <img
                          onClick={() => handleSort(heading)}
                          src={updown}
                          style={{
                            height: "20px",
                            width: "20px",
                            marginLeft: "5px",
                          }}
                          alt="sort"
                        />
                      </span>
                    </td>
                  ))}
                </tr>
              </thead>
              <tbody>
                {}
                {paginatedData.map((row, rowIndex) => {
                  const questionId = row[1]; // ✅ Index for Question ID
                  const questionText = row[2]; // ✅ Index for Question Text
                  return (
                    <tr
                      key={rowIndex}
                      className={rowIndex % 2 === 1 ? "even-row-tc" : ""}
                    >
                      {visibleColumns.map((column, cellIndex) => (
                        <td
                          key={cellIndex}
                          style={{
                            width:
                              cellIndex === 3 ? `${columnWidth}px` : "100px",
                            textAlign: "left",
                            color: "#6A6A6A",
                            verticalAlign: "middle",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: `${columnWidth}px`,
                          }}
                        >
                          {cellIndex === 0 ? ( // Ensure link only appears once
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <div
                                className="flag-container-ques-bank-dash"
                                style={{
                                  width: "220px",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "20px",
                                }}
                              >
                                <img
                                  src={DeleteIcon}
                                  alt="flag count"
                                  style={{
                                    width: "20px",
                                    opacity: isReadOnlyMode ? 0.6 : 1,
                                  }}
                                  // onClick={() => handleRemoveRow && handleRemoveRow(row)}
                                  onClick={() => {
                                    if (!isReadOnlyMode && handleRemoveRow) {
                                      handleRemoveRow(row);
                                    }
                                  }}
                                />
                                <img
                                  src={ReplaceIcon}
                                  alt="replace question"
                                  style={{
                                    width: "24px",
                                    cursor: "pointer",
                                    opacity: isReadOnlyMode ? 0.6 : 1,
                                  }}
                                  // onClick={() => handleReplaceRow(row)}
                                  onClick={() => {
                                    if (!isReadOnlyMode) {
                                      handleReplaceRow(row);
                                    }
                                  }}
                                />
                                <div style={{ width: "24px" }}>
                                  {row[4] === 13 && (
                                    <img
                                      src={EyeLockIcon}
                                      alt="replace question"
                                      style={{
                                        width: "24px",
                                        cursor: "pointer",
                                      }}
                                    />
                                  )}
                                </div>
                                <select
                                  style={{
                                    width: "140px",
                                    padding: "5px",
                                    borderRadius: "4px",
                                    border: "1px solid #ccc",
                                    cursor: "pointer",
                                  }}
                                  value={
                                    selectedSectionPerRow[questionId] || ""
                                  }
                                  onChange={(e) => {
                                    const sectionLabel = e.target.value;

                                    // ── Slot-full validation (MCQ-of-the-Day mode) ──
                                    if (customSectionOptions && customSectionOptions.length > 0 && sectionLabel) {
                                      const qPerDay = Math.max(1, parseInt(numQuestionsPerDate) || 1);
                                      const currentInDate = Object.entries(selectedSectionPerRow)
                                        .filter(([qid, date]) => date === sectionLabel && qid !== String(questionId))
                                        .length;
                                      if (currentInDate >= qPerDay) {
                                        setMessageBox?.(
                                          <div className="Container-messageBOX">
                                            <div className="messagebox-insider1">
                                              <span>
                                                ⚠ Date <b>{sectionLabel}</b> already has {qPerDay} question{qPerDay !== 1 ? "s" : ""} (slot full).
                                                Please deselect a question from that date first.
                                              </span>
                                            </div>
                                            <div className="messagebox-insider2" style={{ marginTop: 10 }}>
                                              <button className="messagebox-cancel-btn-ok" onClick={() => setIsMessageBoxVisible?.(false)}>OK</button>
                                            </div>
                                          </div>
                                        );
                                        setActiveImg?.(InterogativeImg);
                                        setIsMessageBoxVisible?.(true);
                                        return; // block the change
                                      }
                                    }
                                    setSelectedSectionPerRow((prev) => ({
                                      ...prev,
                                      [questionId]: sectionLabel,
                                    }));

                                    setSectionWiseQuestions?.((prev) => {
                                      const updated = { ...prev };

                                      // Remove this question from all sections
                                      for (const sec in updated) {
                                        updated[sec] = updated[sec].filter(
                                          (q) => q.id !== questionId
                                        );
                                      }

                                      // Add to new section
                                      if (sectionLabel) {
                                        if (!updated[sectionLabel])
                                          updated[sectionLabel] = [];
                                        updated[sectionLabel].push({
                                          id: questionId,
                                          text: questionText,
                                        });
                                      }
                                      return updated;
                                    });
                                  }}
                                  disabled={isReadOnlyMode}
                                >
                                  <option value="">Select</option>
                                  {options.map((option) => (
                                    <option key={option.id} value={option.id}>
                                      {option.label}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <Link style={{ color: "#337ab7" }}>
                                <span
                                  className="truncated-text"
                                  title={row[headers.indexOf(column)]}
                                >
                                  {" "}
                                  {headers.indexOf(column) === 2
                                    ? renderQuestionTextTable(
                                        row[headers.indexOf(column)]
                                      )
                                    : row[headers.indexOf(column)]}{" "}
                                </span>
                              </Link>
                            </div>
                          ) : (
                            <span className="truncated-text-2">
                              {" "}
                              {headers.indexOf(column) === 2
                                ? renderQuestionTextTable(
                                    row[headers.indexOf(column)]
                                  )
                                : row[headers.indexOf(column)]}{" "}
                            </span>
                          )}
                        </td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="pagination-tc">
            <button
              onClick={() => handlePageChange(1)}
              disabled={currentPage === 1}
              className="extreme-left-tc-pagination"
            >
              {" "}
              <img src={leftArrow} alt="" />{" "}
            </button>
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="lefttc-pagination"
            >
              {" "}
              {"<"}
            </button>{" "}
            {renderPagination()}{" "}
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="righttc-pagination"
            >
              {" "}
              {">"}{" "}
            </button>
            <button
              onClick={() => handlePageChange(totalPages)}
              disabled={currentPage === totalPages}
              className="extreme-right-tc-pagination"
            >
              {" "}
              <img src={rightArrow} alt="" />{" "}
            </button>
          </div>
        </>
      ) : (
        "No data available"
      )}
      {isFilterVisible && (
        <div className="filter-sidebar-tc">
          <div className="filter-content-tc" style={{ position: "relative" }}>
            <button
              className="repman-cross-btn"
              onClick={() => {
                setIsFilterVisible(false);
              }}
            >
              {" "}
              <p>X</p>{" "}
            </button>
            <h3 className="AdvanceF-heading-tc"> Filter</h3>
            <div className="filter-apply-reset-ques-rev-dash">
              {isFiltersApplied && (
                <button
                  className="reset-btn-question-review-dash"
                  onClick={handleResetFilter}
                >
                  {" "}
                  RESET{" "}
                </button>
              )}
              <button
                className="apply-btn-question-review-dash"
                onClick={handleApplyFilter}
              >
                {" "}
                APPLY{" "}
              </button>
            </div>
            <div className="filter-options-container">
              {headers
                .filter((_, index) => index === 0 || index >= 3) // Skip index 2 and 4
                .map((header, filteredIndex) => {
                  const originalIndex =
                    filteredIndex === 0
                      ? 0
                      : filteredIndex + 1 + (filteredIndex >= 1 ? 1 : 0);
                  let uniqueOptions = [
                    ...new Set(
                      data
                        .map((row) => row[originalIndex])
                        .filter((option) => option)
                    ),
                  ];
                  if (originalIndex === 0 || originalIndex === 6) {
                    uniqueOptions.sort((a, b) => (a > b ? 1 : -1));
                  }
                  return (
                    <SelectedValuesDropdown
                      key={originalIndex}
                      label={header}
                      width="300px"
                      marginLeft="15px"
                      marginTop="18px"
                      setSelected={(selectedOption) => {
                        setFilters((prevFilters) => ({
                          ...prevFilters,
                          [header]: selectedOption,
                        }));
                      }}
                      options={uniqueOptions.map((value) => ({
                        label: value,
                        id: value,
                      }))}
                      selected={filters[header] || ""}
                      Height="auto"
                      OverFlow="auto"
                      minheight="200px"
                    />
                  );
                })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const TableDetailsSelectedQuestions = ({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  dataClient,
  setPagePath,
  selectedSections,
  setQuestionIds,
  activeSubjectId,
  setSectionWiseQuestions,
  selecteSectionTypeID,
  // tableQuestions,
  allQuesList,
  draftData,
  isReadOnlyMode,
  setDifficultyCount,
  version,
  customSectionOptions,   // ← NEW
  sectionColumnLabel,     // ← NEW
  numQuestionsPerDate,    // ← NEW
  sectionWiseQuestions,
}) => {
  const [reportDashboardData, setReportDashboardData] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [selectedSectionPerRow, setSelectedSectionPerRow] = useState({});
  const [draftLoaded, setDraftLoaded] = useState(false);

  const renderQuestionTextTable = (questionText) => {
    const decodedQuestion = he.decode(questionText);
    const questionSegments = decodedQuestion.split(/(imgsrc=[^ ]+)/g);
    return questionSegments.map((segment, index) => {
      if (segment.startsWith("imgsrc=")) {
        const imageUrl = segment.replace("imgsrc=", "");
        return (
          <img
            key={index}
            src={imageUrl}
            alt={`Question Image ${index}`}
            style={{ width: "30px", height: "auto", margin: "5px" }}
          />
        );
      } else {
        return (
          <span key={index} className="truncated-text-2">
            <Latex>{segment}</Latex>
          </span>
        );
      }
    });
  };

  const renderQuestionText = (questionText) => {
    const decodedQuestion = he.decode(questionText);
    const questionSegments = decodedQuestion.split(/(imgsrc=[^ ]+)/g);
    return questionSegments.map((segment, index) => {
      if (segment.startsWith("imgsrc=")) {
        const imageUrl = segment.replace("imgsrc=", "");
        return (
          <img
            key={index}
            src={imageUrl}
            alt={`Question Image ${index}`}
            style={{ width: "30px", margin: "5px" }}
          />
        );
      } else {
        return (
          <span key={index} className="truncated-text-2">
            <Latex>{segment}</Latex>
          </span>
        );
      }
    });
  };


  //   fetchSelectedQuestions();
  // }, [draftData, activeSubjectId, version]);


  useEffect(() => {
    const difficultyIndex = headers.findIndex((h) =>
      h.toLowerCase().includes("difficulty level")
    );

    const difficultyCount = { easy: 0, medium: 0, tough: 0 };

    if (reportDashboardData.length && draftLoaded) {
      reportDashboardData.forEach((row) => {
        const diff = row[difficultyIndex]?.toLowerCase();
        if (["easy", "medium", "tough"].includes(diff)) {
          difficultyCount[diff]++;
        }
      });
    }
    setDifficultyCount?.(difficultyCount);
  }, [reportDashboardData, headers, draftLoaded, activeSubjectId]);

  const quesTypeMapping = {
    "Single Correct MCQ": 1,
    "Multi Correct MCQ": 2,
    "Fill in the blanks": 3,
    "True/False": 4,
  };

  // Additional function to fetch selected questions based on activeSubjectId and draftData(SHASHI ON FRIDAY 30/05 2025)
  const fetchSelectedQuestions = async () => {
    const subjectWiseSelected = JSON.parse(
      localStorage.getItem("subjectWiseSelectedRowIds") || "{}"
    );
    const deletedRowMap = JSON.parse(
      localStorage.getItem("subjectWiseDeletedRowIds") || "{}"
    );

    // ── In MCQ mode: fetch ALL subjects' IDs for display ─────────────────
    // But only use current subject's IDs for the write-back to localStorage
    // to prevent cross-subject contamination.
    const currentSubjectIds = subjectWiseSelected[activeSubjectId] || [];
    const localSubjectIds = customSectionOptions && customSectionOptions.length > 0
      ? Array.from(new Set(Object.values(subjectWiseSelected).flat()))
      : currentSubjectIds;

    const draftSubjectQuestionsRaw =
      draftData?.subjects?.find(
        (subject) => subject.subject_superset_id === activeSubjectId
      )?.questions || [];

    const draftSubjectQuestions = draftSubjectQuestionsRaw.filter(
      (q) => q.status === 1
    );
    const draftSubjectDeletedQuestions = draftSubjectQuestionsRaw.filter(
      (q) => q.status === 2
    );

    const draftSubjectIds = draftSubjectQuestions.map(
      (q) => q.parse_ques_set_question_id
    );
    const deletedDraftIds = draftSubjectDeletedQuestions.map(
      (q) => q.parse_ques_set_question_id
    );

    // Merge and deduplicate — for FETCH use all subjects, for WRITE use current only
    const mergedIds = Array.from(
      new Set([...localSubjectIds, ...draftSubjectIds])
    );

    // ✅ finalIds for fetch = all subjects (MCQ mode) or current only (normal mode)
    const deletedIds = deletedRowMap[activeSubjectId] || [];
    const finalIds = mergedIds.filter((id) => !deletedIds.includes(id));

    // ✅ currentFinalIds for localStorage write = ONLY current subject's IDs
    // This prevents other subjects' IDs from being written into the current subject's key
    const currentFinalIds = Array.from(
      new Set([...currentSubjectIds, ...draftSubjectIds])
    ).filter((id) => !deletedIds.includes(id));

    if (finalIds.length === 0) {
      setReportDashboardData([]);
      setHeaders([]);
      return;
    }

    try {
      const response = await fetch(
        `${EndPoints.PRISM_GET_QUESTIONS_BY_IDS}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("other")}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(finalIds),
        }
      );

      const result = await response.json();
      const tableData = result?.data?.table_data || [];

      if (tableData.length > 1) {
        const headers = tableData[0].map((h) => h.replace(/^t\*|d\*|n\*/, ""));
        const rows = tableData.slice(1);
        setHeaders([(sectionColumnLabel || "Section"), ...headers]);
        // setReportDashboardData(rows.map((row) => ["", ...row]));

        // Ensure table rows follow the order of `finalIds`
        const idToRowMap = new Map();
        rows.forEach((row) => {
          const quesId = row[0]; // assuming 0 is Question ID (since headers have ["Section", ...])
          idToRowMap.set(quesId, row);
        });

        const orderedRows = finalIds
          .map((id) => idToRowMap.get(id))
          .filter((row) => row); // skip if not found
        setReportDashboardData(orderedRows.map((row) => ["", ...row])); // add empty section as first column

        // ✅ Auto-assign default section (A/1) when selecting questions for the first time if only one section exists
        if (selectedSections === 1) {
          const defaultSection = selecteSectionTypeID === 2 ? "1" : "A";
          const newSectionMap = {};

          orderedRows.forEach((row) => {
            const questionId = row[0]; // before "Section" column
            newSectionMap[questionId] = defaultSection;
          });

          setSelectedSectionPerRow(newSectionMap);

          // Also build sectionWiseQuestions
          const sectionQuesMap = {
            [defaultSection]: orderedRows.map((row) => ({
              id: row[0],
              text: renderQuestionTextTable(row[2]),
            })),
          };
          setSectionWiseQuestions(sectionQuesMap);
        }

        const quesTypeMapPerSubject = {}; // New variable
        const questionTypeIndex = headers.findIndex((h) =>
          h.toLowerCase().includes("question type")
        );
        if (questionTypeIndex !== -1) {
          rows.forEach((row) => {
            const quesId = row[0]; // First column is Question ID (after Section)
            const quesTypeText = row[questionTypeIndex];
            const quesTypeId = quesTypeMapping[quesTypeText] || null;

            if (quesTypeId !== null) {
              quesTypeMapPerSubject[quesId] = quesTypeId;
            }
          });

          // ✅ Save as a new key in localStorage
          const existingTypeMap = JSON.parse(
            localStorage.getItem("subjectWiseQuesTypeIds") || "{}"
          );
          localStorage.setItem(
            "subjectWiseQuesTypeIds",
            JSON.stringify({
              ...existingTypeMap,
              [activeSubjectId]: quesTypeMapPerSubject,
            })
          );
        }

        // ✅ Update localStorage: write ONLY current subject's IDs (not all subjects)
        const existing = JSON.parse(
          localStorage.getItem("subjectWiseSelectedRowIds") || "{}"
        );
        localStorage.setItem(
          "subjectWiseSelectedRowIds",
          JSON.stringify({
            ...existing,
            [activeSubjectId]: currentFinalIds,
          })
        );


        const existingDeleted = JSON.parse(
          localStorage.getItem("subjectWiseDeletedRowIds") || "{}"
        );
        const currentSelected =
          JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}")[
            activeSubjectId
          ] || [];

        const mergedDeletedIds = deletedDraftIds.filter(
          (id) => !currentSelected.includes(id)
        ); // ✅ do not save as deleted if user already reselected

        localStorage.setItem(
          "subjectWiseDeletedRowIds",
          JSON.stringify({
            ...existingDeleted,
            [activeSubjectId]: mergedDeletedIds,
          })
        );
        setDraftLoaded(true);
      }
    } catch (error) {
      console.error("Failed to fetch selected questions:", error);
    }
  };

  useEffect(() => {
    fetchSelectedQuestions();
  }, [activeSubjectId, draftData, version]);

  // ── Reactively update the first header when sectionColumnLabel changes ──
  // fetchSelectedQuestions only runs on version/draftData/activeSubjectId changes,
  // so when the user picks a date range AFTER questions are already loaded,
  // headers[0] stays "Section". This effect patches it in-place.
  useEffect(() => {
    if (!sectionColumnLabel) return;
    setHeaders((prev) => {
      if (prev.length === 0) return prev;
      if (prev[0] === sectionColumnLabel) return prev; // already correct
      return [sectionColumnLabel, ...prev.slice(1)];
    });
  }, [sectionColumnLabel]);

  // Save selectedSectionPerRow to localStorage every time it updates
  useEffect(() => {
    if (
      !selectedSectionPerRow ||
      Object.keys(selectedSectionPerRow).length === 0
    )
      return;

    const existingMap = JSON.parse(
      localStorage.getItem("subjectWiseSectionMap") || "{}"
    );
    localStorage.setItem(
      "subjectWiseSectionMap",
      JSON.stringify({
        ...existingMap,
        [activeSubjectId]: selectedSectionPerRow,
      })
    );
  }, [selectedSectionPerRow, activeSubjectId]);

  useEffect(() => {
    if (customSectionOptions && customSectionOptions.length > 0) return;

    const savedMap = JSON.parse(
      localStorage.getItem("subjectWiseSectionMap") || "{}"
    );
    const subjectMap = savedMap[activeSubjectId] || {};

    setSelectedSectionPerRow(subjectMap); // 🟢 restore dropdowns

    const newSectionWise = {};
    reportDashboardData.forEach((row) => {
      const quesId = row[1];
      const section = subjectMap[quesId];
      if (section) {
        if (!newSectionWise[section]) newSectionWise[section] = [];
        newSectionWise[section].push({
          id: quesId,
          text: renderQuestionTextTable(row[2]),
        });
      }
    });

    setSectionWiseQuestions(newSectionWise); // 🟢 restore section mapping
  }, [reportDashboardData, draftLoaded, activeSubjectId, customSectionOptions]);


  //       dropdownMap[quesId] = section;


  useEffect(() => {
    if (!reportDashboardData.length || !draftLoaded) return;

    // Skip in MCQ-of-the-Day mode — sequential auto-assign handles this
    if (customSectionOptions && customSectionOptions.length > 0) return;

    const subject = draftData?.subjects?.find(
      (s) => s.subject_superset_id === activeSubjectId
    );
    const dropdownMap = {};

    subject?.questions?.forEach((q) => {


    //   const dropdownMap = {};

    //   allSubjectQuestions.forEach((q) => {

      if (q.status === 1 && q.section_name) {
        const quesId = q.parse_ques_set_question_id;
        dropdownMap[quesId] = q.section_name;
      }
    });

    // 🧠 Merge draft (dropdownMap) + localStorage map
    const savedMap = JSON.parse(
      localStorage.getItem("subjectWiseSectionMap") || "{}"
    );
    const savedSubjectMap = savedMap[activeSubjectId] || {};

    const mergedMap = {
      ...dropdownMap, // from draft
      ...savedSubjectMap, // from previously saved manual changes
    };

    setSelectedSectionPerRow(mergedMap);

    // 🧠 Auto-assign section if none exists and only one section add this logic on Monday 14/07/2025
    const finalMap = { ...mergedMap };
    const defaultSection = selecteSectionTypeID === 2 ? "1" : "A";

    if (selectedSections === 1) {
      reportDashboardData.forEach((row) => {
        const quesId = row[1];
        if (!finalMap[quesId]) {
          finalMap[quesId] = defaultSection;
        }
      });
    }

    setSelectedSectionPerRow(finalMap);

    // 💾 Save merged version back
    localStorage.setItem(
      "subjectWiseSectionMap",
      JSON.stringify({
        ...savedMap,
        [activeSubjectId]: mergedMap,
      })
    );

    // 🛠 Build sectionWiseQuestions from merged map
    const sectionMap = {};
    reportDashboardData.forEach((row) => {
      const quesId = row[1];
      const section = mergedMap[quesId];
      if (section) {
        if (!sectionMap[section]) sectionMap[section] = [];
        sectionMap[section].push({
          id: quesId,
          text: renderQuestionTextTable(row[2]),
        });
      }
    });

    setSectionWiseQuestions(sectionMap);
  }, [reportDashboardData, draftData, activeSubjectId, draftLoaded, customSectionOptions]);

  const handleRemoveRow = (rowToDelete) => {
    const questionId = rowToDelete[1];
    // Remove from UI
    const updatedData = reportDashboardData.filter(
      (row) => row[1] !== questionId
    );
    setReportDashboardData(updatedData);

    // ✅ Remove from subjectWiseSelectedRowIds
    const selectedMap = JSON.parse(
      localStorage.getItem("subjectWiseSelectedRowIds") || "{}"
    );
    const updatedSelected = (selectedMap[activeSubjectId] || []).filter(
      (id) => id !== questionId
    );
    localStorage.setItem(
      "subjectWiseSelectedRowIds",
      JSON.stringify({
        ...selectedMap,
        [activeSubjectId]: updatedSelected,
      })
    );

    // ✅ Add to subjectWiseDeletedRowIds
    const deletedMap = JSON.parse(
      localStorage.getItem("subjectWiseDeletedRowIds") || "{}"
    );
    const updatedDeleted = Array.from(
      new Set([...(deletedMap[activeSubjectId] || []), questionId])
    );
    localStorage.setItem(
      "subjectWiseDeletedRowIds",
      JSON.stringify({
        ...deletedMap,
        [activeSubjectId]: updatedDeleted,
      })
    );

    // ✅ Update difficulty count
    const difficultyIndex = headers.findIndex((h) =>
      h.toLowerCase().includes("difficulty level")
    );
    const diff = rowToDelete[difficultyIndex]?.toLowerCase();
    if (["easy", "medium", "tough"].includes(diff)) {
      setDifficultyCount((prev) => ({
        ...prev,
        [diff]: Math.max(0, (prev?.[diff] || 0) - 1),
      }));
    }
  };

  const handleReplaceRow = (rowToReplace) => {
    const questionIdIndex = 1; // in reportDashboardData
    const currentQuesId = rowToReplace[questionIdIndex];

    // ✅ Find this question in allQuesList to get correct Group ID
    const matchedRow = allQuesList.find((r) => r[0] === currentQuesId);
    // if (!matchedRow) {
    //   console.warn("❌ No matching row found in allQuesList for ID:", currentQuesId);
    //   return;
    // }
    if (!matchedRow) {
      // console.warn("❌ No matching row found in allQuesList for ID:", currentQuesId);

      setIsMessageBoxVisible(true);
      setActiveImg(ErrorImg);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>
              This question is missing from the current question set and cannot
              be replaced.
            </span>
          </div>
        </div>
      );
      return;
    }
    const groupIdIndexInAll =
      headers.findIndex((h) => h.toLowerCase().includes("group id")) - 1; // -1 because allQuesList doesn't have "Section"
    const currentGroupId = matchedRow[groupIdIndexInAll];

    console.log("✅ Correct Group ID from allQuesList:", currentGroupId);

    const selectedMap = JSON.parse(
      localStorage.getItem("subjectWiseSelectedRowIds") || "{}"
    );
    const selectedIds = selectedMap[activeSubjectId] || [];

    // ✅ Get same-group rows (excluding current and already selected)
    const sameGroupRows = allQuesList.filter(
      (r) =>
        r[groupIdIndexInAll] === currentGroupId &&
        r[0] !== currentQuesId &&
        !selectedIds.includes(r[0])
    );

    console.log(
      "🔄 Replacement candidates:",
      sameGroupRows.map((r) => r[0])
    );

    if (sameGroupRows.length === 0) {
      setIsMessageBoxVisible(true);
      setActiveImg(ErrorImg);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            {}
            <span>
              No available questions in the list to replace the selected
              question.
            </span>
          </div>
        </div>
      );
      return;
    }

    const replacementRow = sameGroupRows[0];

    // ✅ Replace row in reportDashboardData
    const updatedData = reportDashboardData.map((row) =>
      row[questionIdIndex] === currentQuesId ? [row[0], ...replacementRow] : row
    );
    setReportDashboardData(updatedData);

    // ✅ Update localStorage IDs
    const updatedIds = selectedIds
      .filter((id) => id !== currentQuesId)
      .concat(replacementRow[0]);
    localStorage.setItem(
      "subjectWiseSelectedRowIds",
      JSON.stringify({
        ...selectedMap,
        [activeSubjectId]: updatedIds,
      })
    );

    // ✅ Update question type map
    const quesTypeText =
      replacementRow[
        headers.findIndex((h) => h.toLowerCase().includes("question type")) - 1
      ]; // -1 because we added "Section"
    const quesTypeId = quesTypeMapping[quesTypeText] || null;

    if (quesTypeId !== null) {
      const existingQuesTypeMap = JSON.parse(
        localStorage.getItem("subjectWiseQuesTypeIds") || "{}"
      );
      const updatedQuesTypeMap = {
        ...(existingQuesTypeMap[activeSubjectId] || {}),
        [replacementRow[0]]: quesTypeId,
      };

      // Remove old ID
      delete updatedQuesTypeMap[currentQuesId];

      localStorage.setItem(
        "subjectWiseQuesTypeIds",
        JSON.stringify({
          ...existingQuesTypeMap,
          [activeSubjectId]: updatedQuesTypeMap,
        })
      );
    }
    console.log("✅ Replacement successful:", replacementRow[0]);
  };

  return (
    <div style={{ height: "auto", width: "100%" }}>
      <div style={{ position: "sticky", top: "0", paddingLeft: "15px" }}>
        <TableComponent
          headers={headers}
          data={reportDashboardData}
          searchPlaceholder="Filter Questions..."
          dataClient={dataClient}
          setPagePath={setPagePath}
          renderQuestionText={renderQuestionText}
          handleRemoveRow={handleRemoveRow}
          selectedSections={selectedSections}
          setIsMessageBoxVisible={setIsMessageBoxVisible}
          setMessageBox={setMessageBox}
          setActiveImg={setActiveImg}
          setSectionWiseQuestions={setSectionWiseQuestions}
          selecteSectionTypeID={selecteSectionTypeID}
          setQuestionIds={setQuestionIds}
          // tableQuestions={tableQuestions}
          allQuesList={allQuesList}
          handleReplaceRow={handleReplaceRow}
          renderQuestionTextTable={renderQuestionTextTable}
          selectedSectionPerRow={selectedSectionPerRow}
          setSelectedSectionPerRow={setSelectedSectionPerRow}
          isReadOnlyMode={isReadOnlyMode}
          customSectionOptions={customSectionOptions}
          sectionColumnLabel={sectionColumnLabel}
          numQuestionsPerDate={numQuestionsPerDate}
          sectionWiseQuestions={sectionWiseQuestions}
        />
      </div>
    </div>
  );
};

export default TableDetailsSelectedQuestions;


//   const replacementRow = replacementCandidates[0];


// //   if (!selectedQuestions || selectedQuestions.length === 0) {
// //     fetchSelectedQuestionsFromLocalStorage();
// //   }
// // }, []);


// //   fetchSelectedQuestions();
// // }, []);


// //     if (mergedIds.length === 0) return;


// //   fetchSelectedQuestions();
// // }, [draftData]);

// const [draftLoaded, setDraftLoaded] = useState(false);


// //     const mergedIds = Array.from(new Set([...localSelectedIds, ...draftIds]));

// //     if (mergedIds.length === 0) return;


// //   fetchSelectedQuestions();
// // }, [draftData]);


// //   const draftSubjectIds = draftSubjectQuestions.map((q) => q.parse_ques_set_question_id);


// //     // console.log(draftSubjectIds, "draftSubjectQuestions");


// //     if (mergedIds.length === 0) return;


// //   fetchSelectedQuestions();
// // }, [draftData, activeSubjectId]);


// //   const draftSubjectIds = draftSubjectQuestions.map((q) => q.parse_ques_set_question_id);

// //   const existingIds = JSON.parse(localStorage.getItem("selectedRowIds") || "[]");

// //   const mergedIds = Array.from(new Set([...existingIds, ...draftSubjectIds]));


//   fetchSelectedQuestions();
// }, [draftData, activeSubjectId]);


//   const difficultyCount = { easy: 0, medium: 0, tough: 0 };


//   setDifficultyCount?.(difficultyCount);
// }, [reportDashboardData, headers, draftLoaded]);


// //   const storedIds = JSON.parse(localStorage.getItem("selectedRowIds") || "[]");


// export default TableDetailsSelectedQuestions;


//   setSelectedQuestions(updatedQuestions);


//   const transformedRows = storedQuestions.map((row) => ["", ...row]);


//   if (!storedQuestions.length) return;


//   const transformedRows = storedQuestions.map((row) => ["", ...row]);